import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding, NgModule, Injectable, inject, Optional, ChangeDetectorRef, ViewChild, HostListener, ElementRef, ViewContainerRef, DestroyRef, signal, ComponentFactoryResolver } from '@angular/core';
import * as i2 from '@spartacus/core';
import { UrlModule, I18nModule, GlobalMessageType, provideDefaultConfig, AuthGuard, FeaturesConfigModule, FeatureConfigService, useFeatureStyles, EventService, OCC_CART_ID_CURRENT, TranslationService, provideDefaultConfigFactory, MODULE_INITIALIZER, isNotUndefined } from '@spartacus/core';
import * as i2$1 from '@angular/common';
import { CommonModule, formatCurrency, getCurrencySymbol } from '@angular/common';
import * as i2$2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3 from '@spartacus/storefront';
import { BtnLikeLinkModule, MediaModule, ItemCounterModule, FormErrorsModule, MessageComponentModule, SpinnerModule, CustomFormValidators, CardModule, PwaModule, PromotionsModule, PasswordVisibilityToggleModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, provideOutlet, OutletModule, ICON_TYPE, LaunchDialogService, DIALOG_TYPE, LAUNCH_CALLER, KeyboardFocusModule, IconModule, PaginationModule, SortingModule, OutletContextData, SelectFocusUtility, OutletService, OutletPosition, ListNavigationModule } from '@spartacus/storefront';
import * as i3$1 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { map, distinctUntilChanged, tap, shareReplay, switchMap, filter, first, take, withLatestFrom, catchError, startWith } from 'rxjs/operators';
import * as i1 from '@spartacus/order/root';
import { paymentMethodCard, billingAddressCard, OrderConfig, OrderOutlets, deliveryAddressCard, deliveryModeCard, OrderFacade, OrderConfirmationOrderEntriesContextToken, DownloadOrderInvoicesEvent, OrderAttachmentsFacade, USE_MY_ACCOUNT_V2_ORDER, OrderDetailsOrderEntriesContextToken } from '@spartacus/order/root';
import { MyAccountV2OrderHistoryService } from '@spartacus/order/core';
import { BehaviorSubject, combineLatest, of, Subscription, share, EMPTY } from 'rxjs';
import * as i5 from '@spartacus/cart/base/components';
import { AbstractOrderContextModule } from '@spartacus/cart/base/components';
import * as i3$3 from '@spartacus/cart/base/root';
import { CartOutlets, OrderEntriesSource, AbstractOrderType, PromotionLocation, CartValidationStatusCode } from '@spartacus/cart/base/root';
import * as i1$1 from '@spartacus/user/profile/root';
import * as i4 from '@spartacus/cart/base/components/add-to-cart';
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart';
import * as i3$2 from '@spartacus/pdf-invoices/components';
import { InvoicesListComponent, PDFInvoicesComponentsModule } from '@spartacus/pdf-invoices/components';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { NgSelectModule } from '@ng-select/ng-select';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = a0 => ({
  code: a0
});
const _c1 = (a0, a1) => ({
  cxRoute: a0,
  params: a1
});
function AmendOrderActionsComponent_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function AmendOrderActionsComponent_button_6_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.continue($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "common.continue"), " ");
  }
}
function AmendOrderActionsComponent_button_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "orderDetails.cancellationAndReturn.submitDescription"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "orderDetails.cancellationAndReturn.submit"), " ");
  }
}
function CancelOrReturnItemsComponent_div_0_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function CancelOrReturnItemsComponent_div_0_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const form_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.setAll(form_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "orderDetails.cancellationAndReturn.setAll"), " ");
  }
}
function CancelOrReturnItemsComponent_div_0_th_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "orderDetails.cancellationAndReturn.quantity"), " ");
  }
}
function CancelOrReturnItemsComponent_div_0_th_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "orderDetails.cancellationAndReturn.totalPrice"), " ");
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "cartItems.id"), " ", item_r4.product.code, " ");
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_ng_container_8_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", variant_r5.name, ": ");
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_ng_container_8_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", variant_r5.value, " ");
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_ng_container_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, CancelOrReturnItemsComponent_div_0_tr_20_ng_container_8_div_1_div_1_Template, 2, 1, "div", 31)(2, CancelOrReturnItemsComponent_div_0_tr_20_ng_container_8_div_1_div_2_Template, 2, 1, "div", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", variant_r5.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", variant_r5.value);
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CancelOrReturnItemsComponent_div_0_tr_20_ng_container_8_div_1_Template, 3, 2, "div", 29);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r4.product.baseOptions[0] == null ? null : item_r4.product.baseOptions[0].selected == null ? null : item_r4.product.baseOptions[0].selected.variantOptionQualifiers);
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_td_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 34)(1, "div", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "orderDetails.cancellationAndReturn.itemPrice"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", item_r4.basePrice == null ? null : item_r4.basePrice.formattedValue, " ");
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_td_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 35)(1, "div", 36);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "cartItems.quantityTitle"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "orderDetails.cancellationAndReturn.quantity"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getMaxAmendQuantity(item_r4), " ");
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const form_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getControl(form_r2, item_r4).value, " ");
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_cx_item_counter_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-item-counter", 37);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const form_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("min", 0)("max", ctx_r2.getMaxAmendQuantity(item_r4))("control", ctx_r2.getControl(form_r2, item_r4));
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_td_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 38)(1, "div", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_7_0;
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "orderDetails.cancellationAndReturn.totalPrice"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((tmp_7_0 = ctx_r2.getItemPrice(item_r4)) == null ? null : tmp_7_0.formattedValue);
  }
}
function CancelOrReturnItemsComponent_div_0_tr_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 14)(1, "td", 15)(2, "div", 16);
    i0.ɵɵelement(3, "cx-media", 17);
    i0.ɵɵelementStart(4, "div", 18)(5, "div", 19);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CancelOrReturnItemsComponent_div_0_tr_20_div_7_Template, 3, 4, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, CancelOrReturnItemsComponent_div_0_tr_20_ng_container_8_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, CancelOrReturnItemsComponent_div_0_tr_20_td_9_Template, 6, 4, "td", 21)(10, CancelOrReturnItemsComponent_div_0_tr_20_td_10_Template, 7, 7, "td", 22);
    i0.ɵɵelementStart(11, "td", 23)(12, "div", 24);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 25);
    i0.ɵɵtemplate(16, CancelOrReturnItemsComponent_div_0_tr_20_ng_container_16_Template, 2, 1, "ng-container", 0)(17, CancelOrReturnItemsComponent_div_0_tr_20_cx_item_counter_17_Template, 1, 3, "cx-item-counter", 26);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(18, CancelOrReturnItemsComponent_div_0_tr_20_td_18_Template, 6, 4, "td", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("container", item_r4.product.images == null ? null : item_r4.product.images.PRIMARY);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", item_r4.product.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r4.product.code);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r4.product.baseOptions == null ? null : item_r4.product.baseOptions.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r4.basePrice);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isConfirmation);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 10, ctx_r2.isCancellation() ? "orderDetails.cancellationAndReturn.cancelQty" : "orderDetails.cancellationAndReturn.returnQty"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.isConfirmation);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isConfirmation);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isConfirmation);
  }
}
function CancelOrReturnItemsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CancelOrReturnItemsComponent_div_0_button_1_Template, 3, 3, "button", 1);
    i0.ɵɵelementStart(2, "table", 2)(3, "caption", 3);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "thead")(7, "tr")(8, "th", 4);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 5);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CancelOrReturnItemsComponent_div_0_th_14_Template, 3, 3, "th", 6);
    i0.ɵɵelementStart(15, "th", 7);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, CancelOrReturnItemsComponent_div_0_th_18_Template, 3, 3, "th", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "tbody", 9);
    i0.ɵɵtemplate(20, CancelOrReturnItemsComponent_div_0_tr_20_Template, 19, 12, "tr", 10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.isConfirmation);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 8, "orderDetails.caption"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 10, "orderDetails.cancellationAndReturn.item"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 12, "orderDetails.cancellationAndReturn.itemPrice"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isConfirmation);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 14, ctx_r2.isCancellation() ? "orderDetails.cancellationAndReturn.cancelQty" : "orderDetails.cancellationAndReturn.returnQty"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isConfirmation);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.entries);
  }
}
function CancelOrderConfirmationComponent_form_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CancelOrderConfirmationComponent_form_0_cx_amend_order_items_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-amend-order-items", 5);
  }
  if (rf & 2) {
    const entries_r4 = ctx.ngIf;
    i0.ɵɵproperty("entries", entries_r4)("isConfirmation", true);
  }
}
function CancelOrderConfirmationComponent_form_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CancelOrderConfirmationComponent_form_0_ng_template_5_cx_amend_order_actions_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-amend-order-actions", 7);
  }
  if (rf & 2) {
    const form_r2 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("orderCode", ctx_r2.orderCode)("amendOrderForm", form_r2);
  }
}
function CancelOrderConfirmationComponent_form_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CancelOrderConfirmationComponent_form_0_ng_template_5_cx_amend_order_actions_0_Template, 1, 2, "cx-amend-order-actions", 6);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r2.orderCode);
  }
}
function CancelOrderConfirmationComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 2);
    i0.ɵɵlistener("ngSubmit", function CancelOrderConfirmationComponent_form_0_Template_form_ngSubmit_0_listener() {
      const form_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.submit(form_r2));
    });
    i0.ɵɵtemplate(1, CancelOrderConfirmationComponent_form_0_ng_container_1_Template, 1, 0, "ng-container", 3)(2, CancelOrderConfirmationComponent_form_0_cx_amend_order_items_2_Template, 1, 2, "cx-amend-order-items", 4);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, CancelOrderConfirmationComponent_form_0_ng_container_4_Template, 1, 0, "ng-container", 3)(5, CancelOrderConfirmationComponent_form_0_ng_template_5_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const form_r2 = ctx.ngIf;
    const actions_r5 = i0.ɵɵreference(6);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", form_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx_r2.entries$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", actions_r5);
  }
}
function CancelOrderComponent_ng_container_0_cx_message_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-message", 6);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 3, "formErrors.cxNoSelectedItemToCancel"))("isVisibleCloseButton", false)("type", ctx_r0.globalMessageType.MSG_TYPE_ERROR);
  }
}
function CancelOrderComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CancelOrderComponent_ng_container_0_cx_amend_order_items_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-amend-order-items", 7);
  }
  if (rf & 2) {
    const entries_r2 = ctx.ngIf;
    i0.ɵɵproperty("entries", entries_r2);
  }
}
function CancelOrderComponent_ng_container_0_cx_form_errors_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 8);
  }
  if (rf & 2) {
    const form_r3 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("control", form_r3.get("entries"));
  }
}
function CancelOrderComponent_ng_container_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CancelOrderComponent_ng_container_0_ng_template_7_cx_amend_order_actions_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-amend-order-actions", 10);
  }
  if (rf & 2) {
    const form_r3 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("orderCode", ctx_r0.orderCode)("amendOrderForm", form_r3);
  }
}
function CancelOrderComponent_ng_container_0_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CancelOrderComponent_ng_container_0_ng_template_7_cx_amend_order_actions_0_Template, 1, 2, "cx-amend-order-actions", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.orderCode);
  }
}
function CancelOrderComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CancelOrderComponent_ng_container_0_cx_message_1_Template, 2, 5, "cx-message", 2)(2, CancelOrderComponent_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 3)(3, CancelOrderComponent_ng_container_0_cx_amend_order_items_3_Template, 1, 1, "cx-amend-order-items", 4);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, CancelOrderComponent_ng_container_0_cx_form_errors_5_Template, 1, 1, "cx-form-errors", 5)(6, CancelOrderComponent_ng_container_0_ng_container_6_Template, 1, 0, "ng-container", 3)(7, CancelOrderComponent_ng_container_0_ng_template_7_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const form_r3 = ctx.ngIf;
    const actions_r4 = i0.ɵɵreference(8);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !form_r3.get("entries").valid && form_r3.get("entries").touched);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 5, ctx_r0.entries$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "!a11yRepeatedCancelOrderError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r4);
  }
}
function ReturnOrderConfirmationComponent_form_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ReturnOrderConfirmationComponent_form_0_cx_amend_order_items_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-amend-order-items", 5);
  }
  if (rf & 2) {
    const entries_r4 = ctx.ngIf;
    i0.ɵɵproperty("entries", entries_r4)("isConfirmation", true);
  }
}
function ReturnOrderConfirmationComponent_form_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ReturnOrderConfirmationComponent_form_0_ng_template_5_cx_amend_order_actions_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-amend-order-actions", 7);
  }
  if (rf & 2) {
    const form_r2 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("orderCode", ctx_r2.orderCode)("amendOrderForm", form_r2);
  }
}
function ReturnOrderConfirmationComponent_form_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ReturnOrderConfirmationComponent_form_0_ng_template_5_cx_amend_order_actions_0_Template, 1, 2, "cx-amend-order-actions", 6);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r2.orderCode);
  }
}
function ReturnOrderConfirmationComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 2);
    i0.ɵɵlistener("ngSubmit", function ReturnOrderConfirmationComponent_form_0_Template_form_ngSubmit_0_listener() {
      const form_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.submit(form_r2));
    });
    i0.ɵɵtemplate(1, ReturnOrderConfirmationComponent_form_0_ng_container_1_Template, 1, 0, "ng-container", 3)(2, ReturnOrderConfirmationComponent_form_0_cx_amend_order_items_2_Template, 1, 2, "cx-amend-order-items", 4);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, ReturnOrderConfirmationComponent_form_0_ng_container_4_Template, 1, 0, "ng-container", 3)(5, ReturnOrderConfirmationComponent_form_0_ng_template_5_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const form_r2 = ctx.ngIf;
    const actions_r5 = i0.ɵɵreference(6);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", form_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx_r2.entries$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", actions_r5);
  }
}
function ReturnOrderComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ReturnOrderComponent_ng_container_0_cx_amend_order_items_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-amend-order-items", 5);
  }
  if (rf & 2) {
    const entries_r1 = ctx.ngIf;
    i0.ɵɵproperty("entries", entries_r1);
  }
}
function ReturnOrderComponent_ng_container_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ReturnOrderComponent_ng_container_0_ng_template_6_cx_amend_order_actions_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-amend-order-actions", 7);
  }
  if (rf & 2) {
    const form_r2 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("orderCode", ctx_r2.orderCode)("amendOrderForm", form_r2);
  }
}
function ReturnOrderComponent_ng_container_0_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ReturnOrderComponent_ng_container_0_ng_template_6_cx_amend_order_actions_0_Template, 1, 2, "cx-amend-order-actions", 6);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r2.orderCode);
  }
}
function ReturnOrderComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ReturnOrderComponent_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 2)(2, ReturnOrderComponent_ng_container_0_cx_amend_order_items_2_Template, 1, 1, "cx-amend-order-items", 3);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelement(4, "cx-form-errors", 4);
    i0.ɵɵtemplate(5, ReturnOrderComponent_ng_container_0_ng_container_5_Template, 1, 0, "ng-container", 2)(6, ReturnOrderComponent_ng_container_0_ng_template_6_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const form_r2 = ctx.ngIf;
    const actions_r4 = i0.ɵɵreference(7);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx_r2.entries$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", form_r2.get("entries"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", actions_r4);
  }
}
const _c2 = () => ({
  cxRoute: "orders"
});
const _c3 = a0 => ({
  value: a0
});
const _c4 = a0 => ({
  cxRoute: "orderDetails",
  params: a0
});
const _c5 = () => ({
  value: 1
});
const _c6 = a0 => ({
  cxRoute: "orderReturn",
  params: a0
});
const _c7 = () => ({
  cxRoute: "home"
});
function MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "myAccountV2Orders.orderStatusLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "orderDetails.statusDisplay_" + order_r1.statusDisplay), " ");
  }
}
function MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_ng_container_9_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" + ", i0.ɵɵpipeBind2(2, 1, "myAccountV2Orders.items", i0.ɵɵpureFunction1(4, _c3, order_r1.totalItems - 1)), " ");
  }
}
function MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_ng_container_9_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" + ", i0.ɵɵpipeBind2(2, 1, "myAccountV2Orders.item", i0.ɵɵpureFunction0(4, _c5)), " ");
  }
}
function MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_ng_container_9_span_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "a", 27);
    i0.ɵɵpipe(3, "cxUrl");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", " | ", "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(3, 3, i0.ɵɵpureFunction1(7, _c6, order_r1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, "myAccountV2Orders.returnOrder"), " ");
  }
}
function MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 16)(2, "div", 17);
    i0.ɵɵelement(3, "cx-media", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 19)(5, "div", 20)(6, "div", 21);
    i0.ɵɵtext(7);
    i0.ɵɵtemplate(8, MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_ng_container_9_span_8_Template, 3, 6, "span", 14)(9, MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_ng_container_9_span_9_Template, 3, 5, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 22);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxDate");
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 23);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 24)(18, "div", 25);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(21, "div", 26)(22, "span")(23, "a", 27);
    i0.ɵɵpipe(24, "cxUrl");
    i0.ɵɵpipe(25, "cxTranslate");
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(28, MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_ng_container_9_span_28_Template, 6, 9, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r2 = ctx.ngIf;
    const order_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("container", product_r2.images == null ? null : product_r2.images.PRIMARY);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", product_r2.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r1.totalItems - 1 > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r1.totalItems - 1 === 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(13, 14, "myAccountV2Orders.purchasedOn", i0.ɵɵpureFunction1(30, _c3, i0.ɵɵpipeBind2(12, 11, order_r1.placed, "d, MMMM, yyyy"))), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(16, 17, "myAccountV2Orders.orderedItems", i0.ɵɵpureFunction1(32, _c3, order_r1.totalItems)), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(20, 20, "myAccountV2Orders.totalPrice", i0.ɵɵpureFunction1(34, _c3, order_r1.total == null ? null : order_r1.total.formattedValue)), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(24, 23, i0.ɵɵpureFunction1(36, _c4, order_r1)));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(25, 25, "myAccountV2Orders.orderDetailsLabel", i0.ɵɵpureFunction1(38, _c3, order_r1.code)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 28, "myAccountV2Orders.orderDetails"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", order_r1.returnable);
  }
}
function MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9)(2, "div", 10);
    i0.ɵɵtemplate(3, MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_div_3_Template, 4, 6, "div", 11);
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 13);
    i0.ɵɵtemplate(9, MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_ng_container_9_Template, 29, 40, "ng-container", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", order_r1.statusDisplay);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 4, "myAccountV2OrderHistory.orderCodeLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 6, "myAccountV2Orders.orderNumber", i0.ɵɵpureFunction1(9, _c3, order_r1.code)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.getProduct(order_r1));
  }
}
function MyAccountV2OrdersComponent_div_11_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtemplate(2, MyAccountV2OrdersComponent_div_11_ng_container_1_ng_container_2_Template, 10, 11, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderHistory_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", orderHistory_r4.orders);
  }
}
function MyAccountV2OrdersComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MyAccountV2OrdersComponent_div_11_ng_container_1_Template, 3, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const orderHistory_r4 = ctx.ngIf;
    i0.ɵɵnextContext();
    const noOrder_r5 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", orderHistory_r4.pagination.totalResults > 0)("ngIfElse", noOrder_r5);
  }
}
function MyAccountV2OrdersComponent_ng_template_13_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29)(1, "div");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 30);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 4, "orderHistory.notFound"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, "orderHistory.noOrders"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 8, i0.ɵɵpureFunction0(12, _c7)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 10, "orderHistory.startShopping"));
  }
}
function MyAccountV2OrdersComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MyAccountV2OrdersComponent_ng_template_13_div_0_Template, 9, 13, "div", 28);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const loading_r6 = i0.ɵɵreference(16);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx_r2.isLoaded$))("ngIfElse", loading_r6);
  }
}
function MyAccountV2OrdersComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function OrderDetailBillingComponent_div_0_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "cx-card", 6);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const paymentDetails_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 1, ctx_r1.getPaymentMethodCard(paymentDetails_r1)));
  }
}
function OrderDetailBillingComponent_div_0_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "cx-card", 6);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const paymentDetails_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 1, ctx_r1.getBillingAddressCard(paymentDetails_r1)));
  }
}
function OrderDetailBillingComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, OrderDetailBillingComponent_div_0_div_1_div_1_Template, 3, 3, "div", 4)(2, OrderDetailBillingComponent_div_0_div_1_div_2_Template, 3, 3, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const paymentDetails_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isPaymentInfoCardFull(paymentDetails_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", paymentDetails_r1 == null ? null : paymentDetails_r1.billingAddress);
  }
}
function OrderDetailBillingComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, OrderDetailBillingComponent_div_0_div_1_Template, 3, 2, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r3 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r3.paymentInfo);
  }
}
const _c8 = a0 => ({
  item: a0,
  readonly: true
});
const _c9 = a0 => ({
  sapQuoteCode: a0
});
const _c10 = a0 => ({
  id: a0
});
const _c11 = a0 => ({
  quoteId: a0
});
const _c12 = a0 => ({
  cxRoute: "quoteDetails",
  params: a0
});
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_1_ng_template_15_Template(rf, ctx) {}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelement(2, "cx-card", 10);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelement(4, "cx-card", 10);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵelement(7, "cx-card", 10);
    i0.ɵɵpipe(8, "cxDate");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelement(10, "cx-card", 10);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelement(12, "cx-card", 10);
    i0.ɵɵpipe(13, "cxDate");
    i0.ɵɵpipe(14, "async");
    i0.ɵɵtemplate(15, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_1_ng_template_15_Template, 0, 0, "ng-template", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(3, 7, ctx_r1.getReplenishmentCodeCardContent(order_r1 == null ? null : order_r1.replenishmentOrderCode)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(5, 9, ctx_r1.getReplenishmentActiveCardContent(order_r1 == null ? null : order_r1.active)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(9, 13, ctx_r1.getReplenishmentStartOnCardContent(i0.ɵɵpipeBind1(8, 11, order_r1 == null ? null : order_r1.firstDate))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(11, 15, ctx_r1.getReplenishmentFrequencyCardContent(order_r1 == null ? null : order_r1.trigger == null ? null : order_r1.trigger.displayTimeTable)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(14, 19, ctx_r1.getReplenishmentNextDateCardContent(i0.ɵɵpipeBind1(13, 17, order_r1 == null ? null : order_r1.trigger == null ? null : order_r1.trigger.activationTime))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxOutlet", ctx_r1.cartOutlets.ORDER_OVERVIEW)("cxOutletContext", i0.ɵɵpureFunction1(21, _c8, order_r1));
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_template_2_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_template_2_ng_template_9_Template(rf, ctx) {}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "cx-card", 10);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelement(3, "cx-card", 10);
    i0.ɵɵpipe(4, "cxDate");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelement(6, "cx-card", 10);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtemplate(8, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_template_2_ng_container_8_Template, 1, 0, "ng-container", 11)(9, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_template_2_ng_template_9_Template, 0, 0, "ng-template", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    const showQuoteCode_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 7, ctx_r1.getOrderCodeCardContent(order_r1 == null ? null : order_r1.code)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(5, 11, ctx_r1.getOrderCurrentDateCardContent(i0.ɵɵpipeBind1(4, 9, order_r1 == null ? null : order_r1.created))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(7, 13, ctx_r1.getOrderStatusCardContent(order_r1.statusDisplay)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", showQuoteCode_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(15, _c9, order_r1.sapQuoteCode));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r1.cartOutlets.ORDER_OVERVIEW)("cxOutletContext", i0.ɵɵpureFunction1(17, _c8, order_r1));
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_4_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-card", 10);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(4).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 1, ctx_r1.getCostCenterCardContent(order_r1 == null ? null : order_r1.costCenter)));
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelement(2, "cx-card", 10);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelement(4, "cx-card", 10);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵtemplate(6, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_4_ng_container_6_Template, 3, 3, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(3, 3, ctx_r1.getPurchaseOrderNumber(order_r1 == null ? null : order_r1.purchaseOrderNumber)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(5, 5, ctx_r1.getMethodOfPaymentCardContent(order_r1.paymentInfo)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", order_r1.costCenter);
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-card", 10);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 1, ctx_r1.getAddressCardContent(order_r1 == null ? null : order_r1.deliveryAddress)));
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-card", 10);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 1, ctx_r1.getDeliveryModeCardContent(order_r1 == null ? null : order_r1.deliveryMode)));
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_template_8_Template(rf, ctx) {}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_9_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-card", 10);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(5).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 1, ctx_r1.getPaymentInfoCardContent(order_r1 == null ? null : order_r1.paymentInfo)));
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_9_div_1_ng_container_1_Template, 3, 3, "ng-container", 4);
    i0.ɵɵelement(2, "cx-card", 10);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(4).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isPaymentInfoCardFull(order_r1 == null ? null : order_r1.paymentInfo));
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(3, 2, ctx_r1.getBillingAddressCardContent(order_r1 == null ? null : order_r1.paymentInfo == null ? null : order_r1.paymentInfo.billingAddress)));
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_9_div_1_Template, 4, 4, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (order_r1 == null ? null : order_r1.paymentInfo == null ? null : order_r1.paymentInfo.billingAddress) || ctx_r1.isPaymentInfoCardFull(order_r1 == null ? null : order_r1.paymentInfo));
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_1_Template, 16, 23, "ng-container", 7)(2, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_template_2_Template, 10, 19, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_4_Template, 7, 7, "ng-container", 4);
    i0.ɵɵelementStart(5, "div", 8);
    i0.ɵɵtemplate(6, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_6_Template, 3, 3, "ng-container", 4)(7, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_7_Template, 3, 3, "ng-container", 4)(8, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_template_8_Template, 0, 0, "ng-template", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, OrderOverviewComponent_div_0_ng_container_1_div_1_ng_container_9_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const otherOrder_r4 = i0.ɵɵreference(3);
    const order_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r1.replenishmentOrderCode)("ngIfElse", otherOrder_r4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", order_r1.purchaseOrderNumber || order_r1.purchaseOrderNumber === "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", order_r1.deliveryAddress);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.shouldShowDeliveryMode(order_r1.deliveryMode));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r1.orderOutlets.SERVICE_DETAILS)("cxOutletContext", i0.ɵɵpureFunction1(8, _c8, order_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r1.paymentInfo);
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_3_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_3_ng_template_10_Template(rf, ctx) {}
function OrderOverviewComponent_div_0_ng_container_1_div_3_cx_order_detail_billing_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-order-detail-billing");
  }
}
function OrderOverviewComponent_div_0_ng_container_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 13);
    i0.ɵɵelement(2, "cx-card", 10);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelement(4, "cx-card", 10);
    i0.ɵɵpipe(5, "cxDate");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelement(7, "cx-card", 10);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, OrderOverviewComponent_div_0_ng_container_1_div_3_ng_container_9_Template, 1, 0, "ng-container", 11)(10, OrderOverviewComponent_div_0_ng_container_1_div_3_ng_template_10_Template, 0, 0, "ng-template", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, OrderOverviewComponent_div_0_ng_container_1_div_3_cx_order_detail_billing_11_Template, 1, 0, "cx-order-detail-billing", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    const showQuoteCode_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(3, 8, ctx_r1.getOrderCodeCardContent(order_r1 == null ? null : order_r1.code)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(6, 12, ctx_r1.getOrderCurrentDateCardContent(i0.ɵɵpipeBind1(5, 10, order_r1 == null ? null : order_r1.created))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(8, 14, ctx_r1.getOrderStatusCardContent(order_r1.statusDisplay)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", showQuoteCode_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(16, _c9, order_r1.sapQuoteCode));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r1.cartOutlets.ORDER_OVERVIEW)("cxOutletContext", i0.ɵɵpureFunction1(18, _c8, order_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isPaymentInfoCardFull(order_r1 == null ? null : order_r1.paymentInfo) || (order_r1 == null ? null : order_r1.paymentInfo == null ? null : order_r1.paymentInfo.billingAddress));
  }
}
function OrderOverviewComponent_div_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderOverviewComponent_div_0_ng_container_1_div_1_Template, 10, 10, "div", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, OrderOverviewComponent_div_0_ng_container_1_div_3_Template, 12, 20, "div", 5);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 2, ctx_r1.simple$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r1.simple$));
  }
}
function OrderOverviewComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, OrderOverviewComponent_div_0_ng_container_1_Template, 5, 6, "ng-container", 4);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 1, ctx_r1.isOrderLoading$));
  }
}
function OrderOverviewComponent_ng_template_2_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 17);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const quoteCode_r5 = i0.ɵɵnextContext().sapQuoteCode;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, "orderDetails.quoteCode", i0.ɵɵpureFunction1(10, _c10, quoteCode_r5)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 6, i0.ɵɵpureFunction1(14, _c12, i0.ɵɵpureFunction1(12, _c11, quoteCode_r5))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 8, "orderDetails.quoteDetail"), " ");
  }
}
function OrderOverviewComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OrderOverviewComponent_ng_template_2_div_0_Template, 8, 16, "div", 14);
  }
  if (rf & 2) {
    const quoteCode_r5 = ctx.sapQuoteCode;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.orderConfig.showOrderQuoteLink && quoteCode_r5);
  }
}
const _c13 = () => [];
const _c14 = (a0, a1) => ({
  id: a0,
  type: a1
});
const _c15 = (a0, a1) => ({
  items: a0,
  readonly: true,
  promotionLocation: a1
});
function OrderConfirmationItemsComponent_div_0_ng_template_5_Template(rf, ctx) {}
function OrderConfirmationItemsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "cx-promotions", 3);
    i0.ɵɵtemplate(5, OrderConfirmationItemsComponent_div_0_ng_template_5_Template, 0, 0, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "checkoutOrderConfirmation.orderItems"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("promotions", order_r1.appliedOrderPromotions || i0.ɵɵpureFunction0(7, _c13));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxAbstractOrderContext", i0.ɵɵpureFunction2(8, _c14, order_r1.code, ctx_r1.abstractOrderType.ORDER))("cxOutlet", ctx_r1.cartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction2(11, _c15, order_r1.entries, ctx_r1.promotionLocation));
  }
}
const _c16 = a0 => ({
  items: a0,
  readonly: true
});
function OrderConfirmationShippingComponent_div_0_ng_container_1_div_13_ng_template_1_Template(rf, ctx) {}
function OrderConfirmationShippingComponent_div_0_ng_container_1_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, OrderConfirmationShippingComponent_div_0_ng_container_1_div_13_ng_template_1_Template, 0, 0, "ng-template", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxAbstractOrderContext", i0.ɵɵpureFunction2(3, _c14, order_r1.code, ctx_r1.abstractOrderType.ORDER))("cxOutlet", ctx_r1.cartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction1(6, _c16, ctx_r1.entries));
  }
}
function OrderConfirmationShippingComponent_div_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "div", 6);
    i0.ɵɵelement(7, "cx-card", 7);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 5)(10, "div", 6);
    i0.ɵɵelement(11, "cx-card", 7);
    i0.ɵɵpipe(12, "async");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(13, OrderConfirmationShippingComponent_div_0_ng_container_1_div_13_Template, 2, 8, "div", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "checkoutMode.deliveryEntries"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(8, 6, ctx_r1.getDeliveryAddressCard(order_r1.deliveryAddress)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(12, 8, ctx_r1.getDeliveryModeCard(order_r1.deliveryMode)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showItemList);
  }
}
function OrderConfirmationShippingComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, OrderConfirmationShippingComponent_div_0_ng_container_1_Template, 14, 10, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.showItemList || (ctx_r1.entries == null ? null : ctx_r1.entries.length) > 0);
  }
}
const _c17 = a0 => ({
  email: a0
});
const _c18 = a0 => ({
  label: a0
});
function OrderConfirmationThankYouMessageComponent_ng_container_0_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "cx-guest-register-form", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("guid", ctx_r1.orderGuid)("email", order_r1.paymentInfo.billingAddress.email);
  }
}
function OrderConfirmationThankYouMessageComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "span", 2);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 3)(6, "h2");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, OrderConfirmationThankYouMessageComponent_ng_container_0_div_12_Template, 2, 2, "div", 0);
    i0.ɵɵelement(13, "cx-add-to-home-screen-banner");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const order_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(4, 5, "checkoutOrderConfirmation.confirmationOfOrder"), " ", (tmp_2_0 = order_r1.replenishmentOrderCode) !== null && tmp_2_0 !== undefined ? tmp_2_0 : order_r1.code, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 7, "checkoutOrderConfirmation.thankYou"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 9, "checkoutOrderConfirmation.invoiceHasBeenSentByEmail"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isGuestCustomer && ctx_r1.orderGuid && (order_r1 == null ? null : order_r1.paymentInfo == null ? null : order_r1.paymentInfo.billingAddress == null ? null : order_r1.paymentInfo.billingAddress.email));
  }
}
function OrderConfirmationTotalsComponent_div_0_ng_template_3_Template(rf, ctx) {}
function OrderConfirmationTotalsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
    i0.ɵɵtemplate(3, OrderConfirmationTotalsComponent_div_0_ng_template_3_Template, 0, 0, "ng-template", 4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const order_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxOutlet", ctx_r1.cartOutlets.ORDER_SUMMARY)("cxOutletContext", order_r1);
  }
}
const _c19 = a0 => ({
  cxRoute: "orderCancel",
  params: a0
});
function OrderDetailActionsComponent_ng_container_0_a_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 2, i0.ɵɵpureFunction1(6, _c19, order_r1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "orderDetails.cancellationAndReturn.cancelAction"), " ");
  }
}
function OrderDetailActionsComponent_ng_container_0_a_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 2, i0.ɵɵpureFunction1(6, _c6, order_r1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "orderDetails.cancellationAndReturn.returnAction"), " ");
  }
}
function OrderDetailActionsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "button", 3);
    i0.ɵɵpipe(4, "cxUrl");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 2);
    i0.ɵɵtemplate(8, OrderDetailActionsComponent_ng_container_0_a_8_Template, 4, 8, "a", 4)(9, OrderDetailActionsComponent_ng_container_0_a_9_Template, 4, 8, "a", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = ctx.ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(4, 4, i0.ɵɵpureFunction0(8, _c2)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, "common.back"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", order_r1.cancellable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r1.returnable);
  }
}
function MyAccountV2OrderDetailsActionsComponent_ng_container_0_span_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8)(1, "button", 10);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction1(6, _c19, ctx_r1.order)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "myAccountV2OrderDetails.cancelItems"), " ");
  }
}
function MyAccountV2OrderDetailsActionsComponent_ng_container_0_span_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8)(1, "button", 11);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction1(6, _c6, ctx_r1.order)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "myAccountV2OrderDetails.returnItems"), " ");
  }
}
function MyAccountV2OrderDetailsActionsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "span", 3)(4, "span", 4)(5, "button", 5);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "div", 6)(10, "span", 3);
    i0.ɵɵtemplate(11, MyAccountV2OrderDetailsActionsComponent_ng_container_0_span_11_Template, 5, 8, "span", 7)(12, MyAccountV2OrderDetailsActionsComponent_ng_container_0_span_12_Template, 5, 8, "span", 7);
    i0.ɵɵelementStart(13, "span", 8)(14, "button", 9);
    i0.ɵɵlistener("click", function MyAccountV2OrderDetailsActionsComponent_ng_container_0_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showDialog(ctx_r1.order));
    });
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 5, i0.ɵɵpureFunction0(11, _c2)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 7, "myAccountV2OrderDetails.viewAllOrders"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.order.cancellable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.order.returnable);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 9, "myAccountV2OrderDetails.downloadInvoices"), " ");
  }
}
function MyAccountV2DownloadInvoicesComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "myAccountV2OrderDetails.noInvoices"), " ");
  }
}
function MyAccountV2DownloadInvoicesComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c20 = ["element"];
function ConsignmentTrackingComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 1);
    i0.ɵɵlistener("click", function ConsignmentTrackingComponent_ng_container_0_div_1_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.openTrackingDialog(ctx_r1.consignment));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "orderDetails.consignmentTracking.action"), " ");
  }
}
function ConsignmentTrackingComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConsignmentTrackingComponent_ng_container_0_div_1_Template, 4, 3, "div", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.consignmentStatus.includes(ctx_r1.consignment.status));
  }
}
const _c21 = (a0, a1) => ({
  item: a0,
  order: a1
});
const _c22 = (a0, a1, a2) => ({
  displayAddToCart: a0,
  addToCartString: a1,
  optionalBtn: a2
});
const _c23 = (a0, a1, a2) => ({
  items: a0,
  readonly: true,
  promotionLocation: a1,
  options: a2
});
function OrderConsignedEntriesComponent_div_0_ng_template_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const consignment_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "orderDetails.deliveryStatus_" + (consignment_r1 == null ? null : consignment_r1.status)), " ");
  }
}
function OrderConsignedEntriesComponent_div_0_ng_template_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxDate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const consignment_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, consignment_r1 == null ? null : consignment_r1.statusDate));
  }
}
function OrderConsignedEntriesComponent_div_0_ng_template_1_cx_consignment_tracking_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-consignment-tracking", 12);
  }
  if (rf & 2) {
    const consignment_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("orderCode", ctx_r1.order.code)("consignment", consignment_r1);
  }
}
function OrderConsignedEntriesComponent_div_0_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtemplate(2, OrderConsignedEntriesComponent_div_0_ng_template_1_span_2_Template, 3, 3, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, OrderConsignedEntriesComponent_div_0_ng_template_1_div_3_Template, 4, 3, "div", 9)(4, OrderConsignedEntriesComponent_div_0_ng_template_1_cx_consignment_tracking_4_Template, 1, 2, "cx-consignment-tracking", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const consignment_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", consignment_r1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", consignment_r1 == null ? null : consignment_r1.statusDate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "consignmentTracking");
  }
}
function OrderConsignedEntriesComponent_div_0_ng_template_3_Template(rf, ctx) {}
function OrderConsignedEntriesComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, OrderConsignedEntriesComponent_div_0_ng_template_1_Template, 5, 3, "ng-template", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtemplate(3, OrderConsignedEntriesComponent_div_0_ng_template_3_Template, 0, 0, "ng-template", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const consignment_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const addToCartBtn_r3 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r1.OrderOutlets.ORDER_CONSIGNMENT)("cxOutletContext", i0.ɵɵpureFunction2(5, _c21, consignment_r1, ctx_r1.order));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxAbstractOrderContext", i0.ɵɵpureFunction2(8, _c14, ctx_r1.order.code, ctx_r1.abstractOrderType.ORDER))("cxOutlet", ctx_r1.CartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction3(15, _c23, consignment_r1.entries, ctx_r1.promotionLocation, i0.ɵɵpureFunction3(11, _c22, ctx_r1.enableAddToCart, ctx_r1.buyItAgainTranslation, addToCartBtn_r3)));
  }
}
function OrderConsignedEntriesComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-add-to-cart", 13);
  }
  if (rf & 2) {
    const ctx_ir4 = ctx.$implicit;
    i0.ɵɵproperty("productCode", ctx_ir4.item.product == null ? null : ctx_ir4.item.product.code)("product", ctx_ir4.item.product)("showQuantity", false)("options", ctx_ir4.options)("pickupStore", ctx_ir4.item.deliveryPointOfService == null ? null : ctx_ir4.item.deliveryPointOfService.name);
  }
}
const _c24 = a0 => ({
  showItemList: false,
  order: a0
});
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-promotions", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("promotions", order_r1.appliedOrderPromotions || i0.ɵɵpureFunction0(1, _c13));
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "deliveryPointOfServiceDetails.itemsToBePickUp"), " ");
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_cx_order_consigned_entries_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-order-consigned-entries", 6);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "cxTranslate");
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("order", order_r1)("consignments", ctx_r1.pickupConsignments)("enableAddToCart", i0.ɵɵpipeBind1(1, 4, ctx_r1.enableAddToCart$))("buyItAgainTranslation", i0.ɵɵpipeBind1(2, 6, "addToCart.buyItAgain"));
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_4_ng_template_0_Template(rf, ctx) {}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OrderDetailItemsComponent_ng_container_0_ng_container_1_4_ng_template_0_Template, 0, 0, "ng-template", 7);
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxOutlet", ctx_r1.OrderOutlets.CONSIGNMENT_DELIVERY_INFO)("cxOutletContext", i0.ɵɵpureFunction1(2, _c24, order_r1));
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_cx_order_consigned_entries_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-order-consigned-entries", 6);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "cxTranslate");
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("order", order_r1)("consignments", ctx_r1.deliveryConsignments)("enableAddToCart", i0.ɵɵpipeBind1(1, 4, ctx_r1.enableAddToCart$))("buyItAgainTranslation", i0.ɵɵpipeBind1(2, 6, "addToCart.buyItAgain"));
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "orderDetails.statusDisplay_" + (order_r1 == null ? null : order_r1.statusDisplay)), " ");
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_2_h2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "checkoutMode.deliveryEntries"), " ");
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_2_ng_template_4_Template(rf, ctx) {}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_2_h2_1_Template, 3, 3, "h2", 11);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtemplate(4, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_2_ng_template_4_Template, 0, 0, "ng-template", 13);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    const addToCartBtn_r3 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 4, ctx_r1.groupCartItems$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxAbstractOrderContext", i0.ɵɵpureFunction2(10, _c14, order_r1.code, ctx_r1.abstractOrderType.ORDER))("cxOutlet", ctx_r1.CartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction3(17, _c23, ctx_r1.deliveryUnConsignedEntries, ctx_r1.promotionLocation, i0.ɵɵpureFunction3(13, _c22, i0.ɵɵpipeBind1(5, 6, ctx_r1.enableAddToCart$), i0.ɵɵpipeBind1(6, 8, "addToCart.buyItAgain"), addToCartBtn_r3)));
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_3_ng_template_5_Template(rf, ctx) {}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵtemplate(5, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_3_ng_template_5_Template, 0, 0, "ng-template", 13);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    const addToCartBtn_r3 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "checkoutPickupInStore.heading"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxAbstractOrderContext", i0.ɵɵpureFunction2(10, _c14, order_r1.code, ctx_r1.abstractOrderType.ORDER))("cxOutlet", ctx_r1.CartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction3(17, _c23, ctx_r1.pickupUnconsignedEntries, ctx_r1.promotionLocation, i0.ɵɵpureFunction3(13, _c22, i0.ɵɵpipeBind1(6, 6, ctx_r1.enableAddToCart$), i0.ɵɵpipeBind1(7, 8, "addToCart.buyItAgain"), addToCartBtn_r3)));
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_div_1_Template, 4, 3, "div", 8)(2, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_2_Template, 7, 21, "ng-container", 1)(3, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_ng_container_3_Template, 8, 21, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r1 == null ? null : order_r1.statusDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.deliveryUnConsignedEntries == null ? null : ctx_r1.deliveryUnConsignedEntries.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pickupUnconsignedEntries == null ? null : ctx_r1.pickupUnconsignedEntries.length);
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "orderDetails.statusDisplay_" + (order_r1 == null ? null : order_r1.statusDisplay)), " ");
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_8_ng_template_4_Template(rf, ctx) {}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_8_div_2_Template, 4, 3, "div", 8);
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtemplate(4, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_8_ng_template_4_Template, 0, 0, "ng-template", 13);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext(2).ngIf;
    const addToCartBtn_r3 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", order_r1 == null ? null : order_r1.statusDisplay);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxAbstractOrderContext", i0.ɵɵpureFunction2(8, _c14, order_r1.code, ctx_r1.abstractOrderType.ORDER))("cxOutlet", ctx_r1.CartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction3(15, _c23, order_r1.entries, ctx_r1.promotionLocation, i0.ɵɵpureFunction3(11, _c22, i0.ɵɵpipeBind1(5, 4, ctx_r1.enableAddToCart$), i0.ɵɵpipeBind1(6, 6, "addToCart.buyItAgain"), addToCartBtn_r3)));
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_1_Template, 2, 2, "ng-container", 1)(2, OrderDetailItemsComponent_ng_container_0_ng_container_1_div_2_Template, 3, 3, "div", 2)(3, OrderDetailItemsComponent_ng_container_0_ng_container_1_cx_order_consigned_entries_3_Template, 3, 8, "cx-order-consigned-entries", 3)(4, OrderDetailItemsComponent_ng_container_0_ng_container_1_4_Template, 1, 4, null, 1);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵtemplate(6, OrderDetailItemsComponent_ng_container_0_ng_container_1_cx_order_consigned_entries_6_Template, 3, 8, "cx-order-consigned-entries", 3)(7, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_7_Template, 4, 3, "ng-container", 1)(8, OrderDetailItemsComponent_ng_container_0_ng_container_1_ng_container_8_Template, 7, 19, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (order_r1.consignments == null ? null : order_r1.consignments.length) || (order_r1.unconsignedEntries == null ? null : order_r1.unconsignedEntries.length) || order_r1.replenishmentOrderCode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pickupConsignments == null ? null : ctx_r1.pickupConsignments.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pickupConsignments);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.deliveryConsignments && ctx_r1.deliveryConsignments.length > 0 && i0.ɵɵpipeBind1(5, 7, ctx_r1.groupCartItems$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.deliveryConsignments);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r1 == null ? null : order_r1.unconsignedEntries == null ? null : order_r1.unconsignedEntries.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (order_r1 == null ? null : order_r1.entries) && (order_r1 == null ? null : order_r1.replenishmentOrderCode));
  }
}
function OrderDetailItemsComponent_ng_container_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-add-to-cart", 16);
  }
  if (rf & 2) {
    const ctx_ir4 = ctx.$implicit;
    i0.ɵɵproperty("productCode", ctx_ir4.item.product == null ? null : ctx_ir4.item.product.code)("product", ctx_ir4.item.product)("showQuantity", false)("options", ctx_ir4.options)("pickupStore", ctx_ir4.item.deliveryPointOfService == null ? null : ctx_ir4.item.deliveryPointOfService.name);
  }
}
function OrderDetailItemsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderDetailItemsComponent_ng_container_0_ng_container_1_Template, 9, 9, "ng-container", 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, OrderDetailItemsComponent_ng_container_0_ng_template_3_Template, 1, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 1, ctx_r1.isOrderLoading$));
  }
}
function TrackingEventsComponent_ng_container_2_ng_container_9_ng_container_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const consignmentTracking_r4 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", consignmentTracking_r4.trackingUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(consignmentTracking_r4 == null ? null : consignmentTracking_r4.trackingID);
  }
}
function TrackingEventsComponent_ng_container_2_ng_container_9_ng_container_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const consignmentTracking_r4 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", consignmentTracking_r4 == null ? null : consignmentTracking_r4.trackingID, " ");
  }
}
function TrackingEventsComponent_ng_container_2_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 11)(2, "div", 12)(3, "div", 13)(4, "div", 14);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 15);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxDate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 13)(11, "div", 14);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 15);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "cxDate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(17, "div", 12)(18, "div", 13)(19, "div", 14);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 15);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 13)(25, "div", 14);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 15);
    i0.ɵɵtemplate(29, TrackingEventsComponent_ng_container_2_ng_container_9_ng_container_29_Template, 3, 2, "ng-container", 16)(30, TrackingEventsComponent_ng_container_2_ng_container_9_ng_container_30_Template, 3, 1, "ng-container", 16);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const consignmentTracking_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 9, "orderDetails.consignmentTracking.dialog.shipped"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(9, 11, ctx_r2.shipDate, "medium"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 14, "orderDetails.consignmentTracking.dialog.estimate"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(16, 16, consignmentTracking_r4 == null ? null : consignmentTracking_r4.targetArrivalDate, "medium"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 19, "orderDetails.consignmentTracking.dialog.carrier"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", consignmentTracking_r4 == null ? null : consignmentTracking_r4.carrierDetails == null ? null : consignmentTracking_r4.carrierDetails.name, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 21, "orderDetails.consignmentTracking.dialog.trackingId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", consignmentTracking_r4 == null ? null : consignmentTracking_r4.trackingUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(consignmentTracking_r4 == null ? null : consignmentTracking_r4.trackingUrl));
  }
}
function TrackingEventsComponent_ng_container_2_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18)(2, "div", 19);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 20);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 19);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 21);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const consignmentEvent_r5 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 4, consignmentEvent_r5.eventDate, "medium"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", consignmentEvent_r5.referenceCode, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", consignmentEvent_r5.detail, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" location: ", consignmentEvent_r5.location, " ");
  }
}
function TrackingEventsComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5)(2, "div", 6);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 7);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵlistener("click", function TrackingEventsComponent_ng_container_2_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close("Cross click"));
    });
    i0.ɵɵelementStart(7, "span", 8);
    i0.ɵɵtext(8, "\xD7");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(9, TrackingEventsComponent_ng_container_2_ng_container_9_Template, 31, 23, "ng-container", 4);
    i0.ɵɵelementStart(10, "div", 9);
    i0.ɵɵtemplate(11, TrackingEventsComponent_ng_container_2_ng_container_11_Template, 11, 7, "ng-container", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const consignmentTracking_r4 = ctx.ngIf;
    i0.ɵɵnextContext();
    const noTracking_r6 = i0.ɵɵreference(5);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "orderDetails.consignmentTracking.dialog.header"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 7, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (consignmentTracking_r4 == null ? null : consignmentTracking_r4.carrierDetails) && (consignmentTracking_r4 == null ? null : consignmentTracking_r4.trackingID))("ngIfElse", noTracking_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", consignmentTracking_r4.trackingEvents);
  }
}
function TrackingEventsComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "orderDetails.consignmentTracking.dialog.noTracking"), " ");
  }
}
function TrackingEventsComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24)(2, "div", 25);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 26);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵlistener("click", function TrackingEventsComponent_ng_template_6_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close("Cross click"));
    });
    i0.ɵɵelementStart(7, "span", 8);
    i0.ɵɵtext(8, "\xD7");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 27)(10, "div", 12)(11, "div", 28);
    i0.ɵɵelement(12, "cx-spinner");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, "orderDetails.consignmentTracking.dialog.loadingHeader"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 4, "common.close"));
  }
}
function MyAccountV2ConsignmentTrackingComponent_div_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "orderDetails.deliveryStatus_" + ctx_r0.consignment.status), " ");
  }
}
function MyAccountV2ConsignmentTrackingComponent_div_0_span_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementStart(3, "a", 8);
    i0.ɵɵlistener("click", function MyAccountV2ConsignmentTrackingComponent_div_0_span_3_span_1_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.openTrackingDialog(ctx_r0.consignment));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "orderDetails.consignmentTracking.dialog.trackingId"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.consignment.trackingID, " ");
  }
}
function MyAccountV2ConsignmentTrackingComponent_div_0_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtemplate(1, MyAccountV2ConsignmentTrackingComponent_div_0_span_3_span_1_Template, 5, 4, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const showNoTrackingMessage_r3 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.consignment.trackingID)("ngIfElse", showNoTrackingMessage_r3);
  }
}
function MyAccountV2ConsignmentTrackingComponent_div_0_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxDate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r0.consignment.statusDate), " ");
  }
}
function MyAccountV2ConsignmentTrackingComponent_div_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵlistener("click", function MyAccountV2ConsignmentTrackingComponent_div_0_ng_template_5_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openTrackingDialog(ctx_r0.consignment));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "orderDetails.consignmentTracking.action"), " ");
  }
}
function MyAccountV2ConsignmentTrackingComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "span");
    i0.ɵɵtemplate(2, MyAccountV2ConsignmentTrackingComponent_div_0_span_2_Template, 3, 3, "span", 3)(3, MyAccountV2ConsignmentTrackingComponent_div_0_span_3_Template, 2, 2, "span", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MyAccountV2ConsignmentTrackingComponent_div_0_span_4_Template, 3, 3, "span", 5)(5, MyAccountV2ConsignmentTrackingComponent_div_0_ng_template_5_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.consignment.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.consignmentStatus.includes((tmp_3_0 = ctx_r0.consignment.status) !== null && tmp_3_0 !== undefined ? tmp_3_0 : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.consignment == null ? null : ctx_r0.consignment.statusDate);
  }
}
function OrderDetailReorderComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3)(3, "button", 4, 0);
    i0.ɵɵlistener("click", function OrderDetailReorderComponent_ng_container_0_ng_container_1_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const order_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onReorderClick(order_r2));
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 1, "reorder.button"), " ");
  }
}
function OrderDetailReorderComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderDetailReorderComponent_ng_container_0_ng_container_1_Template, 7, 3, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r2 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r2.code);
  }
}
const _c25 = (a0, a1, a2, a3) => ({
  quantity: a0,
  quantityAdded: a1,
  productCode: a2,
  productName: a3
});
function ReorderDialogComponent_ng_container_13_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 14)(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15)(6, "div", 16)(7, "div", 17)(8, "button", 18);
    i0.ɵɵlistener("click", function ReorderDialogComponent_ng_container_13_ng_container_1_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close("Cancel creating cart from order"));
    });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 19);
    i0.ɵɵlistener("click", function ReorderDialogComponent_ng_container_13_ng_container_1_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r1);
      const data_r3 = i0.ɵɵnextContext().ngIf;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.createCartFromOrder(data_r3.orderCode));
    });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "reorder.dialog.areYouSureToReplaceCart"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 5, "reorder.dialog.cancel"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 7, "reorder.dialog.continue"), " ");
  }
}
function ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 21)(2, "span", 22);
    i0.ɵɵelement(3, "cx-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.SUCCESS);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "reorder.dialog.messages.success"), " ");
  }
}
function ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_template_3_span_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 22);
    i0.ɵɵelement(2, "cx-icon", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.INFO);
  }
}
function ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_template_3_span_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵelement(1, "cx-icon", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.iconTypes.ERROR);
  }
}
function ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_template_3_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtemplate(1, ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_template_3_span_0_ng_container_1_Template, 3, 1, "ng-container", 13)(2, ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_template_3_span_0_ng_template_2_Template, 2, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const cartModification_r4 = ctx.$implicit;
    const errorIcon_r5 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", cartModification_r4.statusCode === ctx_r1.cartValidationStatusCode.LOW_STOCK)("ngIfElse", errorIcon_r5);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 3, "reorder.dialog.messages." + cartModification_r4.statusCode, i0.ɵɵpureFunction4(6, _c25, cartModification_r4.quantity, cartModification_r4.quantityAdded, cartModification_r4.entry.product.code, cartModification_r4.entry.product.name)), " ");
  }
}
function ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_template_3_span_0_Template, 7, 11, "span", 24);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.cartModifications);
  }
}
function ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 20);
    i0.ɵɵtemplate(2, ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_container_2_Template, 6, 4, "ng-container", 13)(3, ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_ng_template_3_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cartResponse_r6 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r1.cartModifications == null ? null : ctx_r1.cartModifications.length))("ngIfElse", cartResponse_r6);
  }
}
function ReorderDialogComponent_ng_container_13_ng_template_3_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function ReorderDialogComponent_ng_container_13_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ReorderDialogComponent_ng_container_13_ng_template_3_ng_container_0_Template, 5, 2, "ng-container", 13);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, ReorderDialogComponent_ng_container_13_ng_template_3_ng_template_2_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const loading_r7 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 2, ctx_r1.loading$))("ngIfElse", loading_r7);
  }
}
function ReorderDialogComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ReorderDialogComponent_ng_container_13_ng_container_1_Template, 14, 9, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, ReorderDialogComponent_ng_container_13_ng_template_3_Template, 4, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const result_r8 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.showDecisionPrompt$))("ngIfElse", result_r8);
  }
}
function OrderDetailTotalsComponent_ng_container_0_ng_template_3_Template(rf, ctx) {}
function OrderDetailTotalsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
    i0.ɵɵtemplate(3, OrderDetailTotalsComponent_ng_container_0_ng_template_3_Template, 0, 0, "ng-template", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxOutlet", ctx_r1.CartOutlets.ORDER_SUMMARY)("cxOutletContext", order_r1);
  }
}
function OrderAttachmentsComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3)(3, "button", 4, 0);
    i0.ɵɵlistener("click", function OrderAttachmentsComponent_ng_container_0_ng_container_1_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const order_r2 = i0.ɵɵnextContext().ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onOrderAttachmentsClick(order_r2.code));
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 1, "attachments.button"), " ");
  }
}
function OrderAttachmentsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderAttachmentsComponent_ng_container_0_ng_container_1_Template, 7, 3, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r2 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", order_r2.code);
  }
}
const _c26 = a0 => ({
  disabled: a0
});
const _c27 = a0 => ({
  hidden: a0
});
function OrderAttachmentsDialogComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const count_r2 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", "(" + count_r2 + ")", " ");
  }
}
function OrderAttachmentsDialogComponent_cx_message_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 17);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function OrderAttachmentsDialogComponent_cx_message_14_Template_cx_message_closeMessage_0_listener() {
      const errorId_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.closeErrorMessage(errorId_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "attachments.dialog.downloadError"))("type", ctx_r4.globalMessageType.MSG_TYPE_ERROR);
  }
}
function OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_ng_container_2_tr_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 21)(1, "td")(2, "a", 22);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵlistener("mousedown", function OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_ng_container_2_tr_1_Template_a_mousedown_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const attachment_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r4 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r4.onMouseDown($event, attachment_r7.sapAttachmentId, attachment_r7.sapFileName));
    })("keydown.enter", function OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_ng_container_2_tr_1_Template_a_keydown_enter_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const attachment_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r4 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r4.openOrderAttachment(attachment_r7.sapAttachmentId, attachment_r7.sapFileName));
    });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "td")(7, "div", 23);
    i0.ɵɵelement(8, "cx-spinner");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "td")(10, "a", 24);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵlistener("click", function OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_ng_container_2_tr_1_Template_a_click_10_listener() {
      i0.ɵɵrestoreView(_r6);
      const attachment_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r4 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r4.openOrderAttachment(attachment_r7.sapAttachmentId, attachment_r7.sapFileName));
    })("keydown.enter", function OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_ng_container_2_tr_1_Template_a_keydown_enter_10_listener() {
      i0.ɵɵrestoreView(_r6);
      const attachment_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r4 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r4.openOrderAttachment(attachment_r7.sapAttachmentId, attachment_r7.sapFileName));
    });
    i0.ɵɵelement(13, "cx-icon", 10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const attachment_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 9, "attachments.dialog.preview"));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c26, ctx_r4.loadingAttachments.includes(attachment_r7.sapAttachmentId)));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 11, "attachments.dialog.preview"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", attachment_r7.sapFileName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c27, !ctx_r4.loadingAttachments.includes(attachment_r7.sapAttachmentId)));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(11, 13, "attachments.dialog.preview"));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c26, ctx_r4.loadingAttachments.includes(attachment_r7.sapAttachmentId)));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(12, 15, "attachments.dialog.preview"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r4.iconTypes.FILE);
  }
}
function OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_ng_container_2_tr_1_Template, 14, 23, "tr", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const attachment_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", attachment_r7.sapAttachmentId);
  }
}
function OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "table", 18);
    i0.ɵɵtemplate(2, OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const attachments_r8 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", attachments_r8);
  }
}
function OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_ng_container_1_Template, 3, 1, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    const empty_r9 = i0.ɵɵreference(25);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.attachmentsCount())("ngIfElse", empty_r9);
  }
}
function OrderAttachmentsDialogComponent_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderAttachmentsDialogComponent_ng_container_15_ng_container_1_Template, 2, 2, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const error_r10 = i0.ɵɵreference(23);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.loadError())("ngIfElse", error_r10);
  }
}
function OrderAttachmentsDialogComponent_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-message", 25);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 3, "attachments.dialog.error"))("type", ctx_r4.globalMessageType.MSG_TYPE_ERROR)("isVisibleCloseButton", false);
  }
}
function OrderAttachmentsDialogComponent_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-message", 26);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 3, "attachments.dialog.empty"))("type", ctx_r4.globalMessageType.MSG_TYPE_INFO)("isVisibleCloseButton", false);
  }
}
function OrderAttachmentsDialogComponent_ng_template_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c28 = (a0, a1) => ({
  orderHistory: a0,
  replenishmentOrder: a1
});
const _c29 = a0 => ({
  "cx-order-history-table-po": a0
});
function OrderHistoryComponent_ng_container_0_ng_container_1_h4_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h4");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "orderHistory.replenishmentHistory"), " ");
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_h2_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "orderHistory.orderHistory"), " ");
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "cx-pagination", 19);
    i0.ɵɵlistener("viewPageEvent", function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_div_10_Template_cx_pagination_viewPageEvent_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const type_r4 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("pagination", type_r4.orderHistory.pagination);
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_ng_container_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 15);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "orderHistory.PONumber"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "orderHistory.costCenter"), " ");
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_tr_31_ng_container_8_a_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 23);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 3, i0.ɵɵpureFunction1(5, _c4, order_r6)))("queryParams", ctx_r1.getQueryParams(order_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", order_r6.purchaseOrderNumber, "");
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_tr_31_ng_container_8_a_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 23);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const order_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 3, i0.ɵɵpureFunction1(5, _c4, order_r6)))("queryParams", ctx_r1.getQueryParams(order_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", order_r6.costCenter == null ? null : order_r6.costCenter.name, "");
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_tr_31_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td", 27)(2, "div", 22);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_tr_31_ng_container_8_a_5_Template, 3, 7, "a", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 29)(7, "div", 22);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_tr_31_ng_container_8_a_10_Template, 3, 7, "a", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "orderHistory.PONumber"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", order_r6.purchaseOrderNumber);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 6, "orderHistory.costCenter"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", order_r6.costCenter == null ? null : order_r6.costCenter.name);
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_tr_31_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 20);
    i0.ɵɵlistener("click", function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_tr_31_Template_tr_click_0_listener() {
      const order_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.goToOrderDetail(order_r6));
    });
    i0.ɵɵelementStart(1, "td", 21)(2, "div", 22);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 23);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_tr_31_ng_container_8_Template, 11, 8, "ng-container", 2);
    i0.ɵɵelementStart(9, "td", 24)(10, "div", 22);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "a", 23);
    i0.ɵɵpipe(14, "cxUrl");
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "cxDate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "td", 25)(18, "div", 22);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "a", 23);
    i0.ɵɵpipe(22, "cxUrl");
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "td", 26)(26, "div", 22);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "a", 23);
    i0.ɵɵpipe(30, "cxUrl");
    i0.ɵɵtext(31);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const order_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-rowindex", i_r7 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 18, "orderHistory.orderId"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 20, i0.ɵɵpureFunction1(39, _c4, order_r6)))("queryParams", ctx_r1.getQueryParams(order_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", order_r6 == null ? null : order_r6.code, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasPONumber);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 22, "orderHistory.date"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(14, 24, i0.ɵɵpureFunction1(41, _c4, order_r6)))("queryParams", ctx_r1.getQueryParams(order_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(16, 26, order_r6 == null ? null : order_r6.placed, "longDate"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 29, "orderHistory.status"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(22, 31, i0.ɵɵpureFunction1(43, _c4, order_r6)))("queryParams", ctx_r1.getQueryParams(order_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 33, "orderDetails.statusDisplay_" + (order_r6 == null ? null : order_r6.statusDisplay)), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(28, 35, "orderHistory.total"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(30, 37, i0.ɵɵpureFunction1(45, _c4, order_r6)))("queryParams", ctx_r1.getQueryParams(order_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", order_r6 == null ? null : order_r6.total.formattedValue, "");
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_div_33_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "cx-pagination", 30);
    i0.ɵɵlistener("viewPageEvent", function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_div_33_Template_cx_pagination_viewPageEvent_1_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const type_r4 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("pagination", type_r4.orderHistory.pagination);
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "label", 8)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "cx-sorting", 9);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_Template_cx_sorting_sortListEvent_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.changeSortCode($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_div_10_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "table", 11)(12, "caption", 12);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "thead", 13)(16, "tr", 14)(17, "th", 15);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_ng_container_20_Template, 7, 6, "ng-container", 2);
    i0.ɵɵelementStart(21, "th", 15);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "th", 15);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "th", 15);
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(30, "tbody");
    i0.ɵɵtemplate(31, OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_tr_31_Template, 32, 47, "tr", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 17);
    i0.ɵɵtemplate(33, OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_div_33_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const type_r4 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 16, "orderHistory.sortBy"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 18, "orderHistory.sortBy"));
    i0.ɵɵproperty("sortOptions", type_r4.orderHistory.sorts)("sortLabels", i0.ɵɵpipeBind1(8, 20, ctx_r1.getSortLabels()))("selectedOption", type_r4.orderHistory.pagination.sort)("ariaLabel", i0.ɵɵpipeBind1(9, 22, "orderHistory.sortOrders"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", type_r4.orderHistory.pagination.totalPages > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(34, _c29, ctx_r1.hasPONumber));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 24, "orderHistory.orderHistory"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 26, "orderHistory.orderId"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.hasPONumber);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 28, "orderHistory.date"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 30, "orderHistory.status"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(29, 32, "orderHistory.total"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", type_r4.orderHistory.orders);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", type_r4.orderHistory.pagination.totalPages > 1);
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_template_7_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "orderHistory.notFound"));
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_template_7_div_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 32);
    i0.ɵɵpipe(4, "cxUrl");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, "orderHistory.noOrders"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(4, 5, i0.ɵɵpureFunction0(9, _c7)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 7, "orderHistory.startShopping"));
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_template_7_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div");
    i0.ɵɵtemplate(2, OrderHistoryComponent_ng_container_0_ng_container_1_ng_template_7_div_0_ng_container_2_Template, 4, 3, "ng-container", 6)(3, OrderHistoryComponent_ng_container_0_ng_container_1_ng_template_7_div_0_ng_template_3_Template, 7, 10, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const otherOrder_r9 = i0.ɵɵreference(4);
    const type_r4 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵproperty("ngClass", type_r4.replenishmentOrder ? "cx-replenishment-details-order-history-no-order" : "cx-order-history-no-order");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", type_r4.replenishmentOrder)("ngIfElse", otherOrder_r9);
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OrderHistoryComponent_ng_container_0_ng_container_1_ng_template_7_div_0_Template, 5, 3, "div", 31);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r1.isLoaded$));
  }
}
function OrderHistoryComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4);
    i0.ɵɵtemplate(3, OrderHistoryComponent_ng_container_0_ng_container_1_h4_3_Template, 3, 3, "h4", 2)(4, OrderHistoryComponent_ng_container_0_ng_container_1_h2_4_Template, 3, 3, "h2", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtemplate(6, OrderHistoryComponent_ng_container_0_ng_container_1_ng_container_6_Template, 34, 36, "ng-container", 6)(7, OrderHistoryComponent_ng_container_0_ng_container_1_ng_template_7_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const noOrder_r10 = i0.ɵɵreference(8);
    const type_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", type_r4.replenishmentOrder ? "cx-replenishment-details-order-history-header" : "cx-order-history-header");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r4.replenishmentOrder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !type_r4.replenishmentOrder);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", type_r4.orderHistory.pagination.totalResults > 0)("ngIfElse", noOrder_r10);
  }
}
function OrderHistoryComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, OrderHistoryComponent_ng_container_0_ng_container_1_Template, 9, 5, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const type_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", type_r4.orderHistory);
  }
}
const _c30 = a0 => ({
  param: a0
});
function MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_container_7_ng_container_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const tracking_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", tracking_r1.trackingUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tracking_r1.trackingID);
  }
}
function MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_container_7_ng_container_1_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const tracking_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵtextInterpolate1(" ", tracking_r1.trackingID, " ");
  }
}
function MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_container_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵtemplate(5, MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_container_7_ng_container_1_ng_container_5_Template, 3, 2, "ng-container", 5);
    i0.ɵɵtext(6, " | ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵpipe(11, "cxDate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_container_7_ng_container_1_ng_template_12_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const tracking_r1 = ctx.ngIf;
    const showNumber_r2 = i0.ɵɵreference(13);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 7, "orderDetails.consignmentTracking.dialog.trackingId"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, "orderDetails.consignmentTracking.dialog.trackingId"), ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", tracking_r1.trackingUrl)("ngIfElse", showNumber_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 11, "myAccountV2OrderHistory.estimateDeliveryLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(10, 13, "orderDetails.consignmentTracking.dialog.estimate"), ": ", i0.ɵɵpipeBind2(11, 15, tracking_r1.targetArrivalDate, "d, MMMM, yyyy"), " ");
  }
}
function MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_container_7_ng_container_1_Template, 14, 18, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const consignment_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", consignment_r3.consignmentTracking);
  }
}
function MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_template_8_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const consignment_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "myAccountV2OrderHistory.consignmentStatusLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "orderDetails.deliveryStatus_" + (consignment_r3 == null ? null : consignment_r3.status == null ? null : consignment_r3.status.toUpperCase())), " ");
  }
}
function MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_template_8_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxDate");
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const consignment_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "myAccountV2OrderHistory.consignmentStatusDateLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" | ", i0.ɵɵpipeBind2(4, 7, "myAccountV2OrderHistory.statusDate", i0.ɵɵpureFunction1(10, _c30, i0.ɵɵpipeBind2(3, 4, consignment_r3.statusDate, "d, MMMM, yyyy"))), " ");
  }
}
function MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_template_8_span_0_Template, 4, 6, "span", 6)(1, MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_template_8_span_1_Template, 5, 12, "span", 6);
  }
  if (rf & 2) {
    const consignment_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngIf", consignment_r3.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", consignment_r3.statusDate);
  }
}
function MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, " | ");
    i0.ɵɵtemplate(7, MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_container_7_Template, 2, 1, "ng-container", 5)(8, MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_ng_template_8_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const showLastUpdated_r4 = i0.ɵɵreference(9);
    const ctx_r4 = i0.ɵɵnextContext();
    const consignment_r3 = ctx_r4.$implicit;
    const i_r6 = ctx_r4.index;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 5, "myAccountV2OrderHistory.consignmentDetailLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 7, "myAccountV2OrderHistory.consignmentNumberLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 9, "myAccountV2OrderHistory.consignmentCode", i0.ɵɵpureFunction1(12, _c30, i_r6 + 1)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", consignment_r3.trackingID)("ngIfElse", showLastUpdated_r4);
  }
}
function MyAccountV2ConsignmentEntriesComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MyAccountV2ConsignmentEntriesComponent_ng_container_0_div_1_Template, 10, 14, "div", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const consignment_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", consignment_r3);
  }
}
const _c31 = a0 => ({
  count: a0
});
const _c32 = a0 => ({
  cxRoute: "returnRequestDetails",
  params: a0
});
const _c33 = () => ({
  param: 1
});
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 10);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵtemplate(4, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_2_ng_container_4_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "cx-my-account-v2-consignment-entries", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_7_0;
    let tmp_8_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const showManyItems_r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "myAccountV2OrderHistory.deliveryPointOfServiceDetails.itemsToBePickUp"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", showManyItems_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c31, ctx_r0.getConsignmentsCount(ctx_r0.getPickupConsignments((tmp_6_0 = ctx_r0.order.consignments) !== null && tmp_6_0 !== undefined ? tmp_6_0 : i0.ɵɵpureFunction0(7, _c13)))));
    i0.ɵɵadvance();
    i0.ɵɵproperty("orderCode", (tmp_7_0 = ctx_r0.order.code) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "")("consignments", ctx_r0.getPickupConsignments((tmp_8_0 = ctx_r0.order.consignments) !== null && tmp_8_0 !== undefined ? tmp_8_0 : i0.ɵɵpureFunction0(10, _c13)));
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 10);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵtemplate(4, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_3_ng_container_4_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "cx-my-account-v2-consignment-entries", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_7_0;
    let tmp_8_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const showManyItems_r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 5, "myAccountV2OrderHistory.checkoutMode.deliveryEntries"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", showManyItems_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c31, ctx_r0.getConsignmentsCount(ctx_r0.getDeliveryConsignments((tmp_6_0 = ctx_r0.order.consignments) !== null && tmp_6_0 !== undefined ? tmp_6_0 : i0.ɵɵpureFunction0(7, _c13)))));
    i0.ɵɵadvance();
    i0.ɵɵproperty("orderCode", (tmp_7_0 = ctx_r0.order.code) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "")("consignments", ctx_r0.getDeliveryConsignments((tmp_8_0 = ctx_r0.order.consignments) !== null && tmp_8_0 !== undefined ? tmp_8_0 : i0.ɵɵpureFunction0(10, _c13)));
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtemplate(3, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_div_1_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    const showManyItems_r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "orderDetails.statusDisplay_" + ctx_r0.order.statusDisplay), " - ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", showManyItems_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c31, ctx_r0.getOrderEntriesCount(ctx_r0.order.unconsignedEntries)));
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_ng_template_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtemplate(3, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_ng_template_2_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    const showManyItems_r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "orderDetails.statusDisplay_" + ctx_r0.order.statusDisplay), " - ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", showManyItems_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c31, ctx_r0.getOrderEntriesCount(ctx_r0.order.unconsignedEntries)));
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_div_1_Template, 4, 7, "div", 14)(2, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_ng_template_2_Template, 4, 7, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const nonCritical_r3 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isStatusCritical(ctx_r0.order.statusDisplay))("ngIfElse", nonCritical_r3);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtemplate(3, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_2_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    const showManyItems_r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "myAccountV2OrderHistory.checkoutMode.deliveryEntries"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", showManyItems_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c31, ctx_r0.getOrderEntriesCount(ctx_r0.getDeliveryUnconsignedEntries((tmp_7_0 = ctx_r0.order.unconsignedEntries) !== null && tmp_7_0 !== undefined ? tmp_7_0 : i0.ɵɵpureFunction0(5, _c13)))));
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtemplate(3, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_3_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    const showManyItems_r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "myAccountV2OrderHistory.checkoutPickupInStore.heading"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", showManyItems_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c31, ctx_r0.getOrderEntriesCount(ctx_r0.getPickupUnconsignedEntries((tmp_7_0 = ctx_r0.order.unconsignedEntries) !== null && tmp_7_0 !== undefined ? tmp_7_0 : i0.ɵɵpureFunction0(5, _c13)))));
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_1_Template, 4, 2, "div", 7)(2, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_2_Template, 4, 8, "div", 13)(3, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_div_3_Template, 4, 8, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_6_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.order.statusDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.getOrderEntriesCount(ctx_r0.getDeliveryUnconsignedEntries((tmp_5_0 = ctx_r0.order.unconsignedEntries) !== null && tmp_5_0 !== undefined ? tmp_5_0 : i0.ɵɵpureFunction0(3, _c13))) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.getOrderEntriesCount(ctx_r0.getPickupUnconsignedEntries((tmp_6_0 = ctx_r0.order.unconsignedEntries) !== null && tmp_6_0 !== undefined ? tmp_6_0 : i0.ɵɵpureFunction0(4, _c13))) > 0);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_5_a_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const returnRequest_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 2, i0.ɵɵpureFunction1(4, _c32, returnRequest_r4)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", returnRequest_r4.rma, "");
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_5_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const returnRequest_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", returnRequest_r4.code, " ");
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_5_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxDate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const creationTime_r5 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 4, "myAccountV2OrderHistory.returnProcessed", i0.ɵɵpureFunction1(7, _c30, i0.ɵɵpipeBind2(2, 1, creationTime_r5, "d, MMMM, yyyy"))), " ");
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵtemplate(4, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_5_a_4_Template, 3, 6, "a", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_5_ng_template_5_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(7, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_5_div_7_Template, 4, 9, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const returnRequest_r4 = ctx.$implicit;
    const showReturnCode_r6 = i0.ɵɵreference(6);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "returnRequestList.returnRequestId"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", returnRequest_r4.rma)("ngIfElse", showReturnCode_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", returnRequest_r4.creationTime);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_ng_container_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-media", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("container", item_r7.PRIMARY);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MyAccountV2OrderConsolidatedInformationComponent_div_0_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.getProductImages(ctx_r0.order.entries));
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵtemplate(2, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_2_Template, 6, 11, "div", 7)(3, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_3_Template, 6, 11, "div", 7)(4, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_4_Template, 4, 5, "div", 7)(5, MyAccountV2OrderConsolidatedInformationComponent_div_0_div_5_Template, 8, 6, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵtemplate(7, MyAccountV2OrderConsolidatedInformationComponent_div_0_ng_container_7_Template, 2, 1, "ng-container", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.getConsignmentsCount(ctx_r0.getPickupConsignments((tmp_3_0 = ctx_r0.order.consignments) !== null && tmp_3_0 !== undefined ? tmp_3_0 : i0.ɵɵpureFunction0(5, _c13))) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.getConsignmentsCount(ctx_r0.getDeliveryConsignments((tmp_4_0 = ctx_r0.order.consignments) !== null && tmp_4_0 !== undefined ? tmp_4_0 : i0.ɵɵpureFunction0(6, _c13))) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.getOrderEntriesCount(ctx_r0.order.unconsignedEntries) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.order.returnRequests);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.order.entries);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const count_r8 = i0.ɵɵnextContext().count;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "myAccountV2OrderHistory.items", i0.ɵɵpureFunction1(4, _c30, count_r8)), " ");
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MyAccountV2OrderConsolidatedInformationComponent_ng_template_1_ng_container_0_Template, 3, 6, "ng-container", 20);
  }
  if (rf & 2) {
    const count_r8 = ctx.count;
    i0.ɵɵnextContext();
    const showOneItem_r9 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngIf", count_r8 > 1)("ngIfElse", showOneItem_r9);
  }
}
function MyAccountV2OrderConsolidatedInformationComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 1, "myAccountV2OrderHistory.item", i0.ɵɵpureFunction0(4, _c33)), "\n");
  }
}
function MyAccountV2OrderHistoryComponent_div_0_ng_container_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "div", 8);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵlistener("click", function MyAccountV2OrderHistoryComponent_div_0_ng_container_8_ng_container_1_Template_div_click_2_listener() {
      const order_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.goToOrderDetail(order_r2));
    });
    i0.ɵɵelementStart(4, "a", 9);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 10)(9, "span");
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementStart(15, "strong");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(18, "cx-my-account-v2-order-consolidated-information", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const order_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 10, "myAccountV2OrderHistory.orderCodeLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 12, i0.ɵɵpureFunction1(26, _c4, order_r2)))("queryParams", ctx_r2.getQueryParams(order_r2));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(7, 14, "orderHistory.orderId"), " ", order_r2 == null ? null : order_r2.code, "");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 16, "myAccountV2OrderHistory.orderPlaced"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(12, 18, order_r2.placed, "d, MMMM, yyyy"), " | ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(14, 21, "myAccountV2OrderHistory.totalPriceLabel"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(17, 23, "myAccountV2OrderHistory.totalPrice", i0.ɵɵpureFunction1(28, _c30, order_r2.total == null ? null : order_r2.total.formattedValue)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("order", order_r2);
  }
}
function MyAccountV2OrderHistoryComponent_div_0_ng_container_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵelementStart(2, "cx-pagination", 13);
    i0.ɵɵlistener("viewPageEvent", function MyAccountV2OrderHistoryComponent_div_0_ng_container_8_div_2_Template_cx_pagination_viewPageEvent_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.pageChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const orderHistory_r5 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "myAccountV2OrderHistory.orderListPagination"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pagination", orderHistory_r5.pagination);
  }
}
function MyAccountV2OrderHistoryComponent_div_0_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MyAccountV2OrderHistoryComponent_div_0_ng_container_8_ng_container_1_Template, 19, 30, "ng-container", 5)(2, MyAccountV2OrderHistoryComponent_div_0_ng_container_8_div_2_Template, 3, 4, "div", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const orderHistory_r5 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", orderHistory_r5.orders);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", orderHistory_r5.pagination.totalPages > 1);
  }
}
function MyAccountV2OrderHistoryComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵelementStart(2, "div", 3)(3, "h2");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 4);
    i0.ɵɵtemplate(8, MyAccountV2OrderHistoryComponent_div_0_ng_container_8_Template, 3, 2, "ng-container", 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const orderHistory_r5 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    const noOrder_r6 = i0.ɵɵreference(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 4, "myAccountV2OrderHistory.orderListResults"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 8, "myAccountV2OrderHistory.heading", i0.ɵɵpureFunction1(11, _c30, i0.ɵɵpipeBind1(5, 6, ctx_r2.tabTitleParam$))), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", orderHistory_r5.pagination.totalResults > 0)("ngIfElse", noOrder_r6);
  }
}
function MyAccountV2OrderHistoryComponent_ng_template_2_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 14);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 4, "orderHistory.notFound"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, "orderHistory.noOrders"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 8, i0.ɵɵpureFunction0(12, _c7)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 10, "orderHistory.startShopping"));
  }
}
function MyAccountV2OrderHistoryComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MyAccountV2OrderHistoryComponent_ng_template_2_div_0_Template, 9, 13, "div", 2);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const loading_r7 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx_r2.isLoaded$))("ngIfElse", loading_r7);
  }
}
function MyAccountV2OrderHistoryComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c34 = () => ({
  cxRoute: "replenishmentOrders"
});
function ReplenishmentOrderCancellationComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "button", 5, 0);
    i0.ɵɵlistener("click", function ReplenishmentOrderCancellationComponent_div_6_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openDialog());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "orderDetails.cancelReplenishment.title"), " ");
  }
}
const _c35 = a0 => ({
  cxRoute: "replenishmentDetails",
  params: a0
});
function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "cx-pagination", 18);
    i0.ɵɵlistener("viewPageEvent", function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_div_10_Template_cx_pagination_viewPageEvent_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const replenishmentOrders_r4 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("pagination", replenishmentOrders_r4.pagination);
  }
}
function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_thead_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 19)(1, "th", 20)(2, "span", 21);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "th", 20)(6, "span", 21);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "th", 20)(10, "span", 21);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "th", 20)(14, "span", 21);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "th", 20)(18, "span", 21);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "th", 22)(22, "span", 21);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "th", 20)(26, "span", 21);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "orderHistory.replenishmentOrderId"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 9, "orderHistory.purchaseOrderNumber"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 11, "orderHistory.startOn"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 13, "orderHistory.frequency"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 15, "orderHistory.nextOrderDate"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 17, "orderHistory.total"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(28, 19, "orderHistory.actions"), " ");
  }
}
function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_thead_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 19)(1, "tr")(2, "th", 23)(3, "span", 21);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "th", 23)(7, "span", 21);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "th", 23)(11, "span", 21);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "th", 23)(15, "span", 21);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "th", 23)(19, "span", 21);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "th", 24)(23, "span", 21);
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "th", 23)(27, "span", 21);
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, "orderHistory.replenishmentOrderId"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 9, "orderHistory.purchaseOrderNumber"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 11, "orderHistory.startOn"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 13, "orderHistory.frequency"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 15, "orderHistory.nextOrderDate"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 17, "orderHistory.total"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(29, 19, "orderHistory.actions"), " ");
  }
}
function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_tr_18_button_50_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36, 1);
    i0.ɵɵlistener("click", function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_tr_18_button_50_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const order_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.openDialog($event, order_r6 == null ? null : order_r6.replenishmentOrderCode));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "orderHistory.cancel"), " ");
  }
}
function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_tr_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 25);
    i0.ɵɵlistener("click", function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_tr_18_Template_tr_click_0_listener() {
      const order_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.goToOrderDetail(order_r6));
    });
    i0.ɵɵelementStart(1, "td", 26)(2, "div", 27);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 28);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "td", 29)(9, "div", 27);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "a", 30);
    i0.ɵɵpipe(13, "cxUrl");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "td", 29)(17, "div", 27);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "a", 28);
    i0.ɵɵpipe(21, "cxUrl");
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "cxDate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "td", 31)(25, "div", 27);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "a", 28);
    i0.ɵɵpipe(29, "cxUrl");
    i0.ɵɵtext(30);
    i0.ɵɵpipe(31, "slice");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "td", 29)(33, "div", 27);
    i0.ɵɵtext(34);
    i0.ɵɵpipe(35, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "a", 32);
    i0.ɵɵpipe(37, "cxUrl");
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "cxDate");
    i0.ɵɵpipe(40, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(41, "td", 33)(42, "div", 27);
    i0.ɵɵtext(43);
    i0.ɵɵpipe(44, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(45, "a", 28);
    i0.ɵɵpipe(46, "cxUrl");
    i0.ɵɵtext(47);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(48, "td", 34);
    i0.ɵɵelement(49, "div", 27);
    i0.ɵɵtemplate(50, ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_tr_18_button_50_Template, 4, 3, "button", 35);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const order_r6 = ctx.$implicit;
    const i_r8 = ctx.index;
    i0.ɵɵattribute("aria-rowindex", i_r8 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 20, "orderHistory.replenishmentOrderId"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 22, i0.ɵɵpureFunction1(58, _c35, order_r6)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", order_r6 == null ? null : order_r6.replenishmentOrderCode, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 24, "orderHistory.purchaseOrderNumber"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(13, 26, i0.ɵɵpureFunction1(60, _c35, order_r6)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (order_r6 == null ? null : order_r6.purchaseOrderNumber == null ? null : order_r6.purchaseOrderNumber.length) > 0 ? order_r6 == null ? null : order_r6.purchaseOrderNumber : i0.ɵɵpipeBind1(15, 28, "orderHistory.emptyPurchaseOrderId"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 30, "orderHistory.startOn"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(21, 32, i0.ɵɵpureFunction1(62, _c35, order_r6)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(23, 34, order_r6 == null ? null : order_r6.firstDate, "M/d/yyyy"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 37, "orderHistory.frequency"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(29, 39, i0.ɵɵpureFunction1(64, _c35, order_r6)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(31, 41, order_r6 == null ? null : order_r6.trigger.displayTimeTable, 0, -12), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 45, "orderHistory.nextOrderDate"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(37, 47, i0.ɵɵpureFunction1(66, _c35, order_r6)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (order_r6 == null ? null : order_r6.active) ? i0.ɵɵpipeBind2(39, 49, order_r6 == null ? null : order_r6.trigger.activationTime, "M/d/yyyy") : i0.ɵɵpipeBind1(40, 52, "orderHistory.cancelled"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(44, 54, "orderHistory.total"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(46, 56, i0.ɵɵpureFunction1(68, _c35, order_r6)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", order_r6 == null ? null : order_r6.totalPriceWithTax.formattedValue, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", order_r6 == null ? null : order_r6.active);
  }
}
function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_cx_pagination_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-pagination", 37);
    i0.ɵɵlistener("viewPageEvent", function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_cx_pagination_21_Template_cx_pagination_viewPageEvent_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const replenishmentOrders_r4 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("pagination", replenishmentOrders_r4.pagination);
  }
}
function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "label", 8)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "cx-sorting", 9);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_Template_cx_sorting_sortListEvent_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changeSortCode($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_div_10_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "table", 11)(12, "caption", 12);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_thead_15_Template, 29, 21, "thead", 13)(16, ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_thead_16_Template, 30, 21, "thead", 13);
    i0.ɵɵelementStart(17, "tbody");
    i0.ɵɵtemplate(18, ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_tr_18_Template, 51, 70, "tr", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 15)(20, "div", 16);
    i0.ɵɵtemplate(21, ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_cx_pagination_21_Template, 1, 1, "cx-pagination", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const replenishmentOrders_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 12, "orderHistory.sortBy"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 14, "orderHistory.sortBy"));
    i0.ɵɵproperty("sortOptions", replenishmentOrders_r4.sorts)("sortLabels", i0.ɵɵpipeBind1(8, 16, ctx_r1.getSortLabels()))("selectedOption", replenishmentOrders_r4.pagination.sort)("ariaLabel", i0.ɵɵpipeBind1(9, 18, "orderHistory.sortOrders"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", replenishmentOrders_r4.pagination.totalPages > 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 20, "orderHistory.orderHistory"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "!a11yTableHeaderReadout");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yTableHeaderReadout");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", replenishmentOrders_r4.replenishmentOrders);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", replenishmentOrders_r4.pagination.totalPages > 1);
  }
}
function ReplenishmentOrderHistoryComponent_ng_container_0_ng_template_8_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39)(1, "div", 40)(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 41);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "orderHistory.noReplenishmentOrders"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 5, i0.ɵɵpureFunction0(9, _c7)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 7, "orderHistory.startShopping"));
  }
}
function ReplenishmentOrderHistoryComponent_ng_container_0_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ReplenishmentOrderHistoryComponent_ng_container_0_ng_template_8_div_0_Template, 9, 10, "div", 38);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r1.isLoaded$));
  }
}
function ReplenishmentOrderHistoryComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "h3");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵtemplate(7, ReplenishmentOrderHistoryComponent_ng_container_0_ng_container_7_Template, 22, 22, "ng-container", 6)(8, ReplenishmentOrderHistoryComponent_ng_container_0_ng_template_8_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const replenishmentOrders_r4 = ctx.ngIf;
    const noOrder_r10 = i0.ɵɵreference(9);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "orderHistory.replenishmentOrderHistory"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", replenishmentOrders_r4.pagination.totalResults > 0)("ngIfElse", noOrder_r10);
  }
}
function ReturnRequestItemsComponent_table_0_tr_19_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const returnEntry_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", returnEntry_r1.orderEntry == null ? null : returnEntry_r1.orderEntry.product.name, " ");
  }
}
function ReturnRequestItemsComponent_table_0_tr_19_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const returnEntry_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "cartItems.id"), " ", returnEntry_r1.orderEntry == null ? null : returnEntry_r1.orderEntry.product.code, " ");
  }
}
function ReturnRequestItemsComponent_table_0_tr_19_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", variant_r2.name, ": ");
  }
}
function ReturnRequestItemsComponent_table_0_tr_19_div_7_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", variant_r2.value, " ");
  }
}
function ReturnRequestItemsComponent_table_0_tr_19_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, ReturnRequestItemsComponent_table_0_tr_19_div_7_div_1_Template, 2, 1, "div", 25)(2, ReturnRequestItemsComponent_table_0_tr_19_div_7_div_2_Template, 2, 1, "div", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const variant_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", variant_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", variant_r2.value);
  }
}
function ReturnRequestItemsComponent_table_0_tr_19_td_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 28)(1, "div", 19);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const returnEntry_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "returnRequest.itemPrice"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", returnEntry_r1.orderEntry == null ? null : returnEntry_r1.orderEntry.basePrice == null ? null : returnEntry_r1.orderEntry.basePrice.formattedValue, " ");
  }
}
function ReturnRequestItemsComponent_table_0_tr_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 9)(1, "td", 10)(2, "div", 11);
    i0.ɵɵelement(3, "cx-media", 12);
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵtemplate(5, ReturnRequestItemsComponent_table_0_tr_19_div_5_Template, 2, 1, "div", 14)(6, ReturnRequestItemsComponent_table_0_tr_19_div_6_Template, 3, 4, "div", 15)(7, ReturnRequestItemsComponent_table_0_tr_19_div_7_Template, 3, 2, "div", 16);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(8, ReturnRequestItemsComponent_table_0_tr_19_td_8_Template, 6, 4, "td", 17);
    i0.ɵɵelementStart(9, "td", 18)(10, "div", 19);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 20);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "td", 21)(16, "div", 19);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 20);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const returnEntry_r1 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("container", returnEntry_r1.orderEntry == null ? null : returnEntry_r1.orderEntry.product.images == null ? null : returnEntry_r1.orderEntry.product.images.PRIMARY);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", returnEntry_r1.orderEntry == null ? null : returnEntry_r1.orderEntry.product.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", returnEntry_r1.orderEntry == null ? null : returnEntry_r1.orderEntry.product.code);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", returnEntry_r1.orderEntry == null ? null : returnEntry_r1.orderEntry.product.baseOptions[0] == null ? null : returnEntry_r1.orderEntry.product.baseOptions[0].selected == null ? null : returnEntry_r1.orderEntry.product.baseOptions[0].selected.variantOptionQualifiers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", returnEntry_r1.orderEntry == null ? null : returnEntry_r1.orderEntry.basePrice);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 9, "returnRequest.returnQty"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", returnEntry_r1.expectedQuantity, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 11, "returnRequest.total"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", returnEntry_r1.refundAmount == null ? null : returnEntry_r1.refundAmount.formattedValue, " ");
  }
}
function ReturnRequestItemsComponent_table_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 1)(1, "caption", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "thead")(5, "tr")(6, "th", 3);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th", 4);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th", 5);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th", 6);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(18, "tbody", 7);
    i0.ɵɵtemplate(19, ReturnRequestItemsComponent_table_0_tr_19_Template, 21, 13, "tr", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const returnRequest_r3 = ctx.ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "returnRequest.caption"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 8, "returnRequest.item"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 10, "returnRequest.itemPrice"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 12, "returnRequest.returnQty"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 14, "returnRequest.total"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", returnRequest_r3.returnEntries);
  }
}
function ReturnRequestOverviewComponent_ng_container_0_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("click", function ReturnRequestOverviewComponent_ng_container_0_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const returnRequest_r4 = i0.ɵɵnextContext().ngIf;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelReturn(returnRequest_r4.rma));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", i0.ɵɵpipeBind1(1, 2, ctx_r1.isCancelling$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "returnRequest.cancel"), " ");
  }
}
function ReturnRequestOverviewComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "button", 3);
    i0.ɵɵlistener("click", function ReturnRequestOverviewComponent_ng_container_0_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.back());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 2);
    i0.ɵɵtemplate(7, ReturnRequestOverviewComponent_ng_container_0_button_7_Template, 4, 6, "button", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 5)(9, "div", 6)(10, "div", 7);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 8);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 6)(16, "div", 7);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 8);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 6)(22, "div", 7);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 8);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const returnRequest_r4 = ctx.ngIf;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 8, "common.back"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", returnRequest_r4.cancellable);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 10, "returnRequest.returnRequestId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(returnRequest_r4.rma);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 12, "returnRequest.orderCode"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(returnRequest_r4.order == null ? null : returnRequest_r4.order.code);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 14, "returnRequest.status"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 16, "returnRequestList.statusDisplay_" + (returnRequest_r4 == null ? null : returnRequest_r4.status)), " ");
  }
}
function ReturnRequestTotalsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "h4");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 3)(7, "div", 4);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 5);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 3)(13, "div", 4);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 5);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "div", 6)(19, "div", 4);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 5);
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 7);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const returnRequest_r1 = ctx.ngIf;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 8, "returnRequest.summary"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 10, "returnRequest.subtotal"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", returnRequest_r1.subTotal == null ? null : returnRequest_r1.subTotal.formattedValue, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 12, "returnRequest.deliveryCode"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", returnRequest_r1.deliveryCost == null ? null : returnRequest_r1.deliveryCost.formattedValue, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 14, "returnRequest.estimatedRefund"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", returnRequest_r1.totalPrice == null ? null : returnRequest_r1.totalPrice.formattedValue, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 16, "returnRequest.note"), " ");
  }
}
function OrderReturnRequestListComponent_ng_container_0_ng_container_3_thead_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 13)(1, "th", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 14);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 14);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 14);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "returnRequestList.returnRequestId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 6, "returnRequestList.orderId"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 8, "returnRequestList.date"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 10, "returnRequestList.status"));
  }
}
function OrderReturnRequestListComponent_ng_container_0_ng_container_3_thead_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 13)(1, "tr")(2, "th", 14);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 14);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 14);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 14);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "returnRequestList.returnRequestId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, "returnRequestList.orderId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 8, "returnRequestList.date"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 10, "returnRequestList.status"), " ");
  }
}
function OrderReturnRequestListComponent_ng_container_0_ng_container_3_tr_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 15)(2, "div", 16);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "a", 17);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "td", 15)(9, "div", 16);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "a", 17);
    i0.ɵɵpipe(13, "cxUrl");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "td", 18)(16, "div", 16);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "cxDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "td", 19)(22, "div", 16);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const return_r3 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 10, "returnRequestList.returnRequestId"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 12, i0.ɵɵpureFunction1(27, _c32, return_r3)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", return_r3 == null ? null : return_r3.rma, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 14, "returnRequestList.orderId"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(13, 16, i0.ɵɵpureFunction1(29, _c4, return_r3 == null ? null : return_r3.order)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", return_r3 == null ? null : return_r3.order == null ? null : return_r3.order.code, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 18, "returnRequestList.date"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(20, 20, return_r3 == null ? null : return_r3.creationTime, "longDate"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 23, "returnRequestList.status"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 25, "returnRequestList.statusDisplay_" + (return_r3 == null ? null : return_r3.status)), " ");
  }
}
function OrderReturnRequestListComponent_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "label", 4)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "cx-sorting", 5);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function OrderReturnRequestListComponent_ng_container_0_ng_container_3_Template_cx_sorting_sortListEvent_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changeSortCode($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 6)(10, "cx-pagination", 7);
    i0.ɵɵlistener("viewPageEvent", function OrderReturnRequestListComponent_ng_container_0_ng_container_3_Template_cx_pagination_viewPageEvent_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "table", 8);
    i0.ɵɵtemplate(12, OrderReturnRequestListComponent_ng_container_0_ng_container_3_thead_12_Template, 13, 12, "thead", 9)(13, OrderReturnRequestListComponent_ng_container_0_ng_container_3_thead_13_Template, 14, 12, "thead", 9);
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵtemplate(15, OrderReturnRequestListComponent_ng_container_0_ng_container_3_tr_15_Template, 27, 31, "tr", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 11)(17, "label", 4)(18, "span");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "cx-sorting", 5);
    i0.ɵɵpipe(22, "async");
    i0.ɵɵpipe(23, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function OrderReturnRequestListComponent_ng_container_0_ng_container_3_Template_cx_sorting_sortListEvent_21_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changeSortCode($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 6)(25, "cx-pagination", 12);
    i0.ɵɵlistener("viewPageEvent", function OrderReturnRequestListComponent_ng_container_0_ng_container_3_Template_cx_pagination_viewPageEvent_25_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const returnRequests_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 15, "returnRequestList.sortBy"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("sortOptions", returnRequests_r4.sorts)("sortLabels", i0.ɵɵpipeBind1(7, 17, ctx_r1.getSortLabels()))("selectedOption", returnRequests_r4.pagination.sort)("ariaLabel", i0.ɵɵpipeBind1(8, 19, "returnRequestList.sortReturns"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("pagination", returnRequests_r4.pagination);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "!a11yTableHeaderReadout");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yTableHeaderReadout");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", returnRequests_r4.returnRequests);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 21, "returnRequestList.sortBy"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("sortOptions", returnRequests_r4.sorts)("sortLabels", i0.ɵɵpipeBind1(22, 23, ctx_r1.getSortLabels()))("selectedOption", returnRequests_r4.pagination.sort)("ariaLabel", i0.ɵɵpipeBind1(23, 25, "returnRequestList.sortReturns"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("pagination", returnRequests_r4.pagination);
  }
}
function OrderReturnRequestListComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
    i0.ɵɵtemplate(3, OrderReturnRequestListComponent_ng_container_0_ng_container_3_Template, 26, 27, "ng-container", 0);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const returnRequests_r4 = ctx.ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", returnRequests_r4.pagination.totalResults > 0);
  }
}
class AmendOrderActionsComponent {
  constructor(routingService) {
    this.routingService = routingService;
    this.styles = 'row';
  }
  continue(event) {
    if (this.amendOrderForm.valid) {
      this.routingService.go({
        cxRoute: this.forwardRoute,
        params: {
          code: this.orderCode
        }
      });
    } else {
      this.amendOrderForm.markAllAsTouched();
      event.stopPropagation();
    }
  }
  static {
    this.ɵfac = function AmendOrderActionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AmendOrderActionsComponent)(i0.ɵɵdirectiveInject(i2.RoutingService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AmendOrderActionsComponent,
      selectors: [["cx-amend-order-actions"]],
      hostVars: 2,
      hostBindings: function AmendOrderActionsComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styles);
        }
      },
      inputs: {
        orderCode: "orderCode",
        amendOrderForm: "amendOrderForm",
        backRoute: "backRoute",
        forwardRoute: "forwardRoute"
      },
      standalone: false,
      decls: 8,
      vars: 13,
      consts: [[1, "col-xs-12", "col-md-4", "col-lg-3"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"], ["class", "btn btn-block btn-primary", 3, "click", 4, "ngIf"], ["class", "btn btn-block btn-primary", "type", "submit", 4, "ngIf"], [1, "btn", "btn-block", "btn-primary", 3, "click"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"]],
      template: function AmendOrderActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
          i0.ɵɵpipe(2, "cxUrl");
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(5, "div", 0);
          i0.ɵɵtemplate(6, AmendOrderActionsComponent_button_6_Template, 3, 3, "button", 2)(7, AmendOrderActionsComponent_button_7_Template, 4, 6, "button", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpureFunction2(10, _c1, ctx.backRoute, i0.ɵɵpureFunction1(8, _c0, ctx.orderCode))));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, "common.back"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.forwardRoute);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.forwardRoute);
        }
      },
      dependencies: [i2$1.NgIf, i2$2.RouterLink, i3.BtnLikeLinkDirective, i2.UrlPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AmendOrderActionsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-amend-order-actions',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"col-xs-12 col-md-4 col-lg-3\">\n  <a\n    [routerLink]=\"\n      {\n        cxRoute: backRoute,\n        params: { code: orderCode },\n      } | cxUrl\n    \"\n    cxBtnLikeLink\n    class=\"btn btn-block btn-secondary\"\n  >\n    {{ 'common.back' | cxTranslate }}\n  </a>\n</div>\n<div class=\"col-xs-12 col-md-4 col-lg-3\">\n  <button\n    *ngIf=\"forwardRoute\"\n    class=\"btn btn-block btn-primary\"\n    (click)=\"continue($event)\"\n  >\n    {{ 'common.continue' | cxTranslate }}\n  </button>\n\n  <button\n    *ngIf=\"!forwardRoute\"\n    class=\"btn btn-block btn-primary\"\n    type=\"submit\"\n    [attr.aria-label]=\"\n      'orderDetails.cancellationAndReturn.submitDescription' | cxTranslate\n    \"\n  >\n    {{ 'orderDetails.cancellationAndReturn.submit' | cxTranslate }}\n  </button>\n</div>\n"
    }]
  }], () => [{
    type: i2.RoutingService
  }], {
    orderCode: [{
      type: Input
    }],
    amendOrderForm: [{
      type: Input
    }],
    backRoute: [{
      type: Input
    }],
    forwardRoute: [{
      type: Input
    }],
    styles: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AmendOrderActionsModule {
  static {
    this.ɵfac = function AmendOrderActionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AmendOrderActionsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AmendOrderActionsModule,
      declarations: [AmendOrderActionsComponent],
      imports: [CommonModule, RouterModule, UrlModule, I18nModule, BtnLikeLinkModule],
      exports: [AmendOrderActionsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, UrlModule, I18nModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AmendOrderActionsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, UrlModule, I18nModule, BtnLikeLinkModule],
      declarations: [AmendOrderActionsComponent],
      exports: [AmendOrderActionsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var AmendOrderType;
(function (AmendOrderType) {
  AmendOrderType[AmendOrderType["CANCEL"] = 0] = "CANCEL";
  AmendOrderType[AmendOrderType["RETURN"] = 1] = "RETURN";
})(AmendOrderType || (AmendOrderType = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderDetailsService {
  constructor(orderHistoryFacade, routingService) {
    this.orderHistoryFacade = orderHistoryFacade;
    this.routingService = routingService;
    this.orderCode$ = this.routingService.getRouterState().pipe(map(routingData => routingData.state.params.orderCode), distinctUntilChanged());
    this.orderLoad$ = this.orderCode$.pipe(tap(orderCode => {
      if (orderCode) {
        this.orderHistoryFacade.loadOrderDetails(orderCode);
      } else {
        this.orderHistoryFacade.clearOrderDetails();
      }
    }), shareReplay({
      bufferSize: 1,
      refCount: true
    }));
  }
  isOrderDetailsLoading() {
    return this.orderHistoryFacade.getOrderDetailsLoading();
  }
  getOrderDetails() {
    return this.orderLoad$.pipe(switchMap(() => this.orderHistoryFacade.getOrderDetails()));
  }
  static {
    this.ɵfac = function OrderDetailsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderDetailsService)(i0.ɵɵinject(i1.OrderHistoryFacade), i0.ɵɵinject(i2.RoutingService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderDetailsService,
      factory: OrderDetailsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderDetailsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.OrderHistoryFacade
  }, {
    type: i2.RoutingService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function ValidateQuantityToCancel(control) {
  if (!control.value) {
    return null;
  }
  const quantity = Object.values(control.value).reduce((acc, val) => acc + val, 0);
  return quantity > 0 ? null : {
    cxNoSelectedItemToCancel: true
  };
}
class OrderAmendService {
  constructor(orderDetailsService) {
    this.orderDetailsService = orderDetailsService;
  }
  /**
   * Returns entries with an amended quantity.
   */
  getAmendedEntries() {
    return this.getForm().pipe(switchMap(form => {
      return this.getEntries().pipe(map(entries => entries.filter(entry => this.getFormControl(form, entry).value > 0)));
    }));
  }
  getOrder() {
    return this.orderDetailsService.getOrderDetails();
  }
  /**
   * returns the form with form data at runtime
   */
  getForm() {
    return this.getOrder().pipe(tap(order => {
      if (!this.form || this.form.get('orderCode')?.value !== order.code) {
        this.buildForm(order);
      }
    }), map(() => this.form));
  }
  buildForm(order) {
    this.form = new UntypedFormGroup({});
    this.form.addControl('orderCode', new UntypedFormControl(order.code));
    const entryGroup = new UntypedFormGroup({}, {
      validators: [ValidateQuantityToCancel]
    });
    this.form.addControl('entries', entryGroup);
    (order.entries || []).forEach(entry => {
      const key = entry?.entryNumber?.toString() ?? '';
      entryGroup.addControl(key, new UntypedFormControl(0, {
        validators: [Validators.min(0), Validators.max(this.getMaxAmendQuantity(entry))]
      }));
    });
  }
  getFormControl(form, entry) {
    return form.get('entries')?.get(entry.entryNumber?.toString() ?? '');
  }
  /**
   * As discussed, this calculation is moved to SPA side.
   * The calculation and validation should be in backend facade layer.
   */
  getAmendedPrice(entry) {
    const amendedQuantity = this.getFormControl(this.form, entry).value;
    const amendedPrice = Object.assign({}, entry.basePrice);
    amendedPrice.value = Math.round((entry.basePrice?.value ?? 0) * amendedQuantity * 100) / 100;
    amendedPrice.formattedValue = formatCurrency(amendedPrice.value,
    // TODO: user current language
    'en', getCurrencySymbol(amendedPrice.currencyIso ?? '', 'narrow'), amendedPrice.currencyIso);
    return amendedPrice;
  }
  getMaxAmendQuantity(entry) {
    return (this.isCancellation() ? entry.cancellableQuantity : entry.returnableQuantity) || entry.quantity || 0;
  }
  isCancellation() {
    return this.amendType === AmendOrderType.CANCEL;
  }
  static {
    this.ɵfac = function OrderAmendService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderAmendService)(i0.ɵɵinject(OrderDetailsService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderAmendService,
      factory: OrderAmendService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderAmendService, [{
    type: Injectable
  }], () => [{
    type: OrderDetailsService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CancelOrReturnItemsComponent {
  constructor(orderAmendService) {
    this.orderAmendService = orderAmendService;
    this.isConfirmation = false;
    this.form$ = this.orderAmendService.getForm();
  }
  getControl(form, entry) {
    const control = form.get('entries')?.get(entry.entryNumber?.toString() ?? '');
    return control;
  }
  setAll(form) {
    this.entries.forEach(entry => this.getControl(form, entry).setValue(this.getMaxAmendQuantity(entry)));
  }
  getItemPrice(entry) {
    return this.orderAmendService.getAmendedPrice(entry);
  }
  getMaxAmendQuantity(entry) {
    return this.orderAmendService.getMaxAmendQuantity(entry);
  }
  isCancellation() {
    return this.orderAmendService.isCancellation();
  }
  static {
    this.ɵfac = function CancelOrReturnItemsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CancelOrReturnItemsComponent)(i0.ɵɵdirectiveInject(OrderAmendService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CancelOrReturnItemsComponent,
      selectors: [["cx-amend-order-items"]],
      inputs: {
        entries: "entries",
        isConfirmation: "isConfirmation"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], ["class", "btn btn-link cx-action-link", 3, "click", 4, "ngIf"], [1, "cx-amend-order-items"], [1, "cx-visually-hidden"], ["role", "columnheader", 1, "cx-item-list-desc"], ["role", "columnheader", 1, "cx-item-list-price"], ["role", "columnheader", "class", "cx-item-list-amend-qty", 4, "ngIf"], ["role", "columnheader", 1, "cx-item-list-qty"], ["role", "columnheader", "class", "cx-item-list-total", 4, "ngIf"], [1, "cx-item-list-items"], ["class", "cx-item-list-row cx-amend-order-item-row", 4, "ngFor", "ngForOf"], [1, "btn", "btn-link", "cx-action-link", 3, "click"], ["role", "columnheader", 1, "cx-item-list-amend-qty"], ["role", "columnheader", 1, "cx-item-list-total"], [1, "cx-item-list-row", "cx-amend-order-item-row"], ["role", "cell"], [1, "cx-table-item-container"], ["format", "thumbnail", 3, "container"], [1, "cx-info"], [1, "cx-name"], ["class", "cx-code", 4, "ngIf"], ["role", "cell", "class", "cx-price", 4, "ngIf"], ["role", "cell", "class", "cx-request-qty", 4, "ngIf"], ["role", "cell", 1, "cx-quantity"], [1, "cx-mobile-header"], [1, "cx-value"], [3, "min", "max", "control", 4, "ngIf"], ["role", "cell", "class", "cx-total", 4, "ngIf"], [1, "cx-code"], ["class", "cx-property", 4, "ngFor", "ngForOf"], [1, "cx-property"], ["class", "cx-label", 4, "ngIf"], ["class", "cx-value", 4, "ngIf"], [1, "cx-label"], ["role", "cell", 1, "cx-price"], ["role", "cell", 1, "cx-request-qty"], [1, "cx-mobile-header", 3, "title"], [3, "min", "max", "control"], ["role", "cell", 1, "cx-total"]],
      template: function CancelOrReturnItemsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CancelOrReturnItemsComponent_div_0_Template, 21, 16, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.form$));
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.MediaComponent, i3.ItemCounterComponent, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CancelOrReturnItemsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-amend-order-items',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div *ngIf=\"form$ | async as form\">\n  <button\n    *ngIf=\"!isConfirmation\"\n    class=\"btn btn-link cx-action-link\"\n    (click)=\"setAll(form)\"\n  >\n    {{ 'orderDetails.cancellationAndReturn.setAll' | cxTranslate }}\n  </button>\n\n  <table class=\"cx-amend-order-items\">\n    <caption class=\"cx-visually-hidden\">\n      {{\n        'orderDetails.caption' | cxTranslate\n      }}\n    </caption>\n    <thead>\n      <tr>\n        <th role=\"columnheader\" class=\"cx-item-list-desc\">\n          {{ 'orderDetails.cancellationAndReturn.item' | cxTranslate }}\n        </th>\n        <th role=\"columnheader\" class=\"cx-item-list-price\">\n          {{ 'orderDetails.cancellationAndReturn.itemPrice' | cxTranslate }}\n        </th>\n        <th\n          *ngIf=\"!isConfirmation\"\n          role=\"columnheader\"\n          class=\"cx-item-list-amend-qty\"\n        >\n          {{ 'orderDetails.cancellationAndReturn.quantity' | cxTranslate }}\n        </th>\n        <th role=\"columnheader\" class=\"cx-item-list-qty\">\n          {{\n            (isCancellation()\n              ? 'orderDetails.cancellationAndReturn.cancelQty'\n              : 'orderDetails.cancellationAndReturn.returnQty'\n            ) | cxTranslate\n          }}\n        </th>\n        <th\n          *ngIf=\"isConfirmation\"\n          role=\"columnheader\"\n          class=\"cx-item-list-total\"\n        >\n          {{ 'orderDetails.cancellationAndReturn.totalPrice' | cxTranslate }}\n        </th>\n      </tr>\n    </thead>\n    <tbody class=\"cx-item-list-items\">\n      <!--    TODO: This should be a separate component-->\n      <tr\n        *ngFor=\"let item of entries; let i = index\"\n        class=\"cx-item-list-row cx-amend-order-item-row\"\n      >\n        <td role=\"cell\">\n          <div class=\"cx-table-item-container\">\n            <cx-media\n              [container]=\"item.product.images?.PRIMARY\"\n              format=\"thumbnail\"\n            ></cx-media>\n\n            <div class=\"cx-info\">\n              <div class=\"cx-name\">\n                {{ item.product.name }}\n              </div>\n\n              <div *ngIf=\"item.product.code\" class=\"cx-code\">\n                {{ 'cartItems.id' | cxTranslate }} {{ item.product.code }}\n              </div>\n            </div>\n\n            <ng-container *ngIf=\"item.product.baseOptions?.length\">\n              <div\n                *ngFor=\"\n                  let variant of item.product.baseOptions[0]?.selected\n                    ?.variantOptionQualifiers\n                \"\n                class=\"cx-property\"\n              >\n                <div class=\"cx-label\" *ngIf=\"variant.name\">\n                  {{ variant.name }}:\n                </div>\n                <div class=\"cx-value\" *ngIf=\"variant.value\">\n                  {{ variant.value }}\n                </div>\n              </div>\n            </ng-container>\n          </div>\n        </td>\n\n        <td role=\"cell\" class=\"cx-price\" *ngIf=\"item.basePrice\">\n          <div class=\"cx-mobile-header\">\n            {{ 'orderDetails.cancellationAndReturn.itemPrice' | cxTranslate }}\n          </div>\n          <div class=\"cx-value\">\n            {{ item.basePrice?.formattedValue }}\n          </div>\n        </td>\n\n        <td role=\"cell\" *ngIf=\"!isConfirmation\" class=\"cx-request-qty\">\n          <div\n            class=\"cx-mobile-header\"\n            title=\"{{ 'cartItems.quantityTitle' | cxTranslate }}\"\n          >\n            {{ 'orderDetails.cancellationAndReturn.quantity' | cxTranslate }}\n          </div>\n          <div class=\"cx-value\">\n            {{ getMaxAmendQuantity(item) }}\n          </div>\n        </td>\n\n        <td role=\"cell\" class=\"cx-quantity\">\n          <div class=\"cx-mobile-header\">\n            {{\n              (isCancellation()\n                ? 'orderDetails.cancellationAndReturn.cancelQty'\n                : 'orderDetails.cancellationAndReturn.returnQty'\n              ) | cxTranslate\n            }}\n          </div>\n          <div class=\"cx-value\">\n            <ng-container *ngIf=\"isConfirmation\">\n              {{ getControl(form, item).value }}\n            </ng-container>\n            <cx-item-counter\n              *ngIf=\"!isConfirmation\"\n              [min]=\"0\"\n              [max]=\"getMaxAmendQuantity(item)\"\n              [control]=\"getControl(form, item)\"\n            ></cx-item-counter>\n          </div>\n        </td>\n\n        <td role=\"cell\" *ngIf=\"isConfirmation\" class=\"cx-total\">\n          <div class=\"cx-mobile-header\">\n            {{ 'orderDetails.cancellationAndReturn.totalPrice' | cxTranslate }}\n          </div>\n          <div class=\"cx-value\">{{ getItemPrice(item)?.formattedValue }}</div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"
    }]
  }], () => [{
    type: OrderAmendService
  }], {
    entries: [{
      type: Input
    }],
    isConfirmation: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AmendOrderItemsModule {
  static {
    this.ɵfac = function AmendOrderItemsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AmendOrderItemsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AmendOrderItemsModule,
      declarations: [CancelOrReturnItemsComponent],
      imports: [CommonModule, ReactiveFormsModule, I18nModule, MediaModule, ItemCounterModule, FormErrorsModule],
      exports: [CancelOrReturnItemsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, ReactiveFormsModule, I18nModule, MediaModule, ItemCounterModule, FormErrorsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AmendOrderItemsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, I18nModule, MediaModule, ItemCounterModule, FormErrorsModule],
      declarations: [CancelOrReturnItemsComponent],
      exports: [CancelOrReturnItemsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CancelOrderConfirmationComponent {
  constructor(orderAmendService) {
    this.orderAmendService = orderAmendService;
    this.form$ = this.orderAmendService.getForm().pipe(tap(form => this.orderCode = form.value.orderCode));
    this.entries$ = this.orderAmendService.getAmendedEntries();
  }
  submit(form) {
    if (form.valid) {
      this.orderAmendService.save();
    } else {
      form.markAllAsTouched();
    }
  }
  static {
    this.ɵfac = function CancelOrderConfirmationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CancelOrderConfirmationComponent)(i0.ɵɵdirectiveInject(OrderAmendService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CancelOrderConfirmationComponent,
      selectors: [["cx-cancel-order-confirmation"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["actions", ""], [3, "formGroup", "ngSubmit", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [4, "ngTemplateOutlet"], [3, "entries", "isConfirmation", 4, "ngIf"], [3, "entries", "isConfirmation"], ["backRoute", "orderCancel", 3, "orderCode", "amendOrderForm", 4, "ngIf"], ["backRoute", "orderCancel", 3, "orderCode", "amendOrderForm"]],
      template: function CancelOrderConfirmationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CancelOrderConfirmationComponent_form_0_Template, 7, 6, "form", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.form$));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.NgTemplateOutlet, i3$1.ɵNgNoValidate, i3$1.NgControlStatusGroup, i3$1.FormGroupDirective, CancelOrReturnItemsComponent, AmendOrderActionsComponent, i2$1.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CancelOrderConfirmationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cancel-order-confirmation',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<form\n  *ngIf=\"form$ | async as form\"\n  [formGroup]=\"form\"\n  (ngSubmit)=\"submit(form)\"\n>\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n\n  <cx-amend-order-items\n    *ngIf=\"entries$ | async as entries\"\n    [entries]=\"entries\"\n    [isConfirmation]=\"true\"\n  >\n  </cx-amend-order-items>\n\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n\n  <ng-template #actions>\n    <cx-amend-order-actions\n      *ngIf=\"orderCode\"\n      [orderCode]=\"orderCode\"\n      [amendOrderForm]=\"form\"\n      backRoute=\"orderCancel\"\n    ></cx-amend-order-actions>\n  </ng-template>\n</form>\n"
    }]
  }], () => [{
    type: OrderAmendService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderCancellationService extends OrderAmendService {
  constructor(orderDetailsService, orderHistoryFacade, routing, globalMessageService) {
    super(orderDetailsService);
    this.orderDetailsService = orderDetailsService;
    this.orderHistoryFacade = orderHistoryFacade;
    this.routing = routing;
    this.globalMessageService = globalMessageService;
    this.amendType = AmendOrderType.CANCEL;
  }
  /**
   * Return cancellable order entries.
   */
  getEntries() {
    return this.getOrder().pipe(filter(order => !!order?.entries), map(order => order.entries?.filter(entry => entry.entryNumber !== -1 && entry.cancellableQuantity && entry.cancellableQuantity > 0) ?? []));
  }
  save() {
    const orderCode = this.form.value.orderCode;
    const entries = this.form.value.entries;
    const inputs = Object.keys(entries).filter(entryNumber => entries[entryNumber] > 0).map(entryNumber => ({
      orderEntryNumber: Number(entryNumber),
      quantity: entries[entryNumber]
    }));
    this.form.reset();
    this.orderHistoryFacade.cancelOrder(orderCode, {
      cancellationRequestEntryInputs: inputs
    });
    this.orderHistoryFacade.getCancelOrderSuccess().pipe(first(Boolean)).subscribe(() => this.afterSave(orderCode));
  }
  afterSave(orderCode) {
    this.orderHistoryFacade.resetCancelOrderProcessState();
    this.globalMessageService.add({
      key: 'orderDetails.cancellationAndReturn.cancelSuccess',
      params: {
        orderCode
      }
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.routing.go({
      cxRoute: 'orders'
    });
  }
  static {
    this.ɵfac = function OrderCancellationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderCancellationService)(i0.ɵɵinject(OrderDetailsService), i0.ɵɵinject(i1.OrderHistoryFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.GlobalMessageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderCancellationService,
      factory: OrderCancellationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderCancellationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: OrderDetailsService
  }, {
    type: i1.OrderHistoryFacade
  }, {
    type: i2.RoutingService
  }, {
    type: i2.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderCancellationGuard {
  constructor(orderAmendService, semanticPathService, router) {
    this.orderAmendService = orderAmendService;
    this.semanticPathService = semanticPathService;
    this.router = router;
  }
  canActivate() {
    return this.orderAmendService.getForm().pipe(map(form => {
      if (!form.valid) {
        // the order code is not available in the route
        // as long as we're inside a guard, hence we redirect
        // to the common orders page.
        return this.router.parseUrl(this.semanticPathService.get('orders') ?? '');
      } else {
        return true;
      }
    }));
  }
  static {
    this.ɵfac = function OrderCancellationGuard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderCancellationGuard)(i0.ɵɵinject(OrderCancellationService), i0.ɵɵinject(i2.SemanticPathService), i0.ɵɵinject(i2$2.Router));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderCancellationGuard,
      factory: OrderCancellationGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderCancellationGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: OrderCancellationService
  }, {
    type: i2.SemanticPathService
  }, {
    type: i2$2.Router
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CancelOrderConfirmationModule {
  static {
    this.ɵfac = function CancelOrderConfirmationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CancelOrderConfirmationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CancelOrderConfirmationModule,
      declarations: [CancelOrderConfirmationComponent],
      imports: [CommonModule, ReactiveFormsModule, AmendOrderItemsModule, AmendOrderActionsModule],
      exports: [CancelOrderConfirmationComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CancelOrderConfirmationComponent: {
            component: CancelOrderConfirmationComponent,
            guards: [AuthGuard, OrderCancellationGuard],
            providers: [{
              provide: OrderAmendService,
              useExisting: OrderCancellationService
            }]
          }
        }
      })],
      imports: [CommonModule, ReactiveFormsModule, AmendOrderItemsModule, AmendOrderActionsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CancelOrderConfirmationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, AmendOrderItemsModule, AmendOrderActionsModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CancelOrderConfirmationComponent: {
            component: CancelOrderConfirmationComponent,
            guards: [AuthGuard, OrderCancellationGuard],
            providers: [{
              provide: OrderAmendService,
              useExisting: OrderCancellationService
            }]
          }
        }
      })],
      declarations: [CancelOrderConfirmationComponent],
      exports: [CancelOrderConfirmationComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CancelOrderComponent {
  constructor(orderAmendService) {
    this.orderAmendService = orderAmendService;
    this.globalMessageType = GlobalMessageType;
    this.form$ = this.orderAmendService.getForm().pipe(tap(form => this.orderCode = form.value.orderCode));
    this.entries$ = this.orderAmendService.getEntries();
  }
  static {
    this.ɵfac = function CancelOrderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CancelOrderComponent)(i0.ɵɵdirectiveInject(OrderAmendService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CancelOrderComponent,
      selectors: [["cx-cancel-order"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["actions", ""], [4, "ngIf"], ["role", "alert", 3, "text", "isVisibleCloseButton", "type", 4, "ngIf"], [4, "ngTemplateOutlet"], [3, "entries", 4, "ngIf"], [3, "control", 4, "cxFeature"], ["role", "alert", 3, "text", "isVisibleCloseButton", "type"], [3, "entries"], [3, "control"], ["backRoute", "orderDetails", "forwardRoute", "orderCancelConfirmation", 3, "orderCode", "amendOrderForm", 4, "ngIf"], ["backRoute", "orderDetails", "forwardRoute", "orderCancelConfirmation", 3, "orderCode", "amendOrderForm"]],
      template: function CancelOrderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CancelOrderComponent_ng_container_0_Template, 9, 7, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.form$));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.NgTemplateOutlet, CancelOrReturnItemsComponent, AmendOrderActionsComponent, i3.FormErrorsComponent, i3.MessageComponent, i2.FeatureDirective, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CancelOrderComponent, [{
    type: Component,
    args: [{
      selector: 'cx-cancel-order',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"form$ | async as form\">\n  <cx-message\n    role=\"alert\"\n    *ngIf=\"!form.get('entries').valid && form.get('entries').touched\"\n    [text]=\"'formErrors.cxNoSelectedItemToCancel' | cxTranslate\"\n    [isVisibleCloseButton]=\"false\"\n    [type]=\"globalMessageType.MSG_TYPE_ERROR\"\n  >\n  </cx-message>\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n  <cx-amend-order-items *ngIf=\"entries$ | async as entries\" [entries]=\"entries\">\n  </cx-amend-order-items>\n\n  <cx-form-errors\n    *cxFeature=\"'!a11yRepeatedCancelOrderError'\"\n    [control]=\"form.get('entries')\"\n  ></cx-form-errors>\n\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n\n  <ng-template #actions>\n    <cx-amend-order-actions\n      *ngIf=\"orderCode\"\n      [orderCode]=\"orderCode\"\n      [amendOrderForm]=\"form\"\n      backRoute=\"orderDetails\"\n      forwardRoute=\"orderCancelConfirmation\"\n    ></cx-amend-order-actions>\n  </ng-template>\n</ng-container>\n"
    }]
  }], () => [{
    type: OrderAmendService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CancelOrderModule {
  static {
    this.ɵfac = function CancelOrderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CancelOrderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CancelOrderModule,
      declarations: [CancelOrderComponent],
      imports: [CommonModule, I18nModule, AmendOrderItemsModule, AmendOrderActionsModule, FormErrorsModule, MessageComponentModule, FeaturesConfigModule],
      exports: [CancelOrderComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CancelOrderComponent: {
            component: CancelOrderComponent,
            guards: [AuthGuard],
            providers: [{
              provide: OrderAmendService,
              useExisting: OrderCancellationService
            }]
          }
        }
      })],
      imports: [CommonModule, I18nModule, AmendOrderItemsModule, AmendOrderActionsModule, FormErrorsModule, MessageComponentModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CancelOrderModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, AmendOrderItemsModule, AmendOrderActionsModule, FormErrorsModule, MessageComponentModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CancelOrderComponent: {
            component: CancelOrderComponent,
            guards: [AuthGuard],
            providers: [{
              provide: OrderAmendService,
              useExisting: OrderCancellationService
            }]
          }
        }
      })],
      declarations: [CancelOrderComponent],
      exports: [CancelOrderComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderCancellationModule {
  static {
    this.ɵfac = function OrderCancellationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderCancellationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrderCancellationModule,
      imports: [CancelOrderModule, CancelOrderConfirmationModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CancelOrderModule, CancelOrderConfirmationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderCancellationModule, [{
    type: NgModule,
    args: [{
      imports: [CancelOrderModule, CancelOrderConfirmationModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderReturnService extends OrderAmendService {
  constructor(orderDetailsService, returnRequestService, routing, globalMessageService) {
    super(orderDetailsService);
    this.orderDetailsService = orderDetailsService;
    this.returnRequestService = returnRequestService;
    this.routing = routing;
    this.globalMessageService = globalMessageService;
    this.amendType = AmendOrderType.RETURN;
  }
  getEntries() {
    return this.getOrder().pipe(filter(order => !!order.entries), map(order => order.entries?.filter(entry => entry.entryNumber !== -1 && entry.returnableQuantity && entry.returnableQuantity > 0) ?? []));
  }
  save() {
    const orderCode = this.form.value.orderCode;
    const entries = this.form.value.entries;
    const inputs = Object.keys(entries).filter(entryNumber => entries[entryNumber] > 0).map(entryNumber => ({
      orderEntryNumber: Number(entryNumber),
      quantity: entries[entryNumber]
    }));
    this.form.reset();
    this.returnRequestService.createOrderReturnRequest({
      orderCode,
      returnRequestEntryInputs: inputs
    });
    this.returnRequestService.getReturnRequestSuccess().pipe(first(Boolean)).subscribe(() => this.afterSave());
  }
  afterSave() {
    this.returnRequestService.getOrderReturnRequest().pipe(first(r => !!r)).subscribe(returnRequest => {
      const rma = returnRequest.rma;
      this.globalMessageService.add({
        key: 'orderDetails.cancellationAndReturn.returnSuccess',
        params: {
          rma
        }
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      this.routing.go({
        cxRoute: 'returnRequestDetails',
        params: {
          rma
        }
      });
    });
  }
  static {
    this.ɵfac = function OrderReturnService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderReturnService)(i0.ɵɵinject(OrderDetailsService), i0.ɵɵinject(i1.OrderReturnRequestFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.GlobalMessageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderReturnService,
      factory: OrderReturnService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderReturnService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: OrderDetailsService
  }, {
    type: i1.OrderReturnRequestFacade
  }, {
    type: i2.RoutingService
  }, {
    type: i2.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderReturnGuard {
  constructor(orderAmendService, semanticPathService, router) {
    this.orderAmendService = orderAmendService;
    this.semanticPathService = semanticPathService;
    this.router = router;
  }
  canActivate() {
    return this.orderAmendService.getForm().pipe(map(form => {
      if (!form.valid) {
        // the order code is not available in the route
        // as long as we're inside a guard, hence we redirect
        // to the common orders page.
        return this.router.parseUrl(this.semanticPathService.get('orders') ?? '');
      } else {
        return true;
      }
    }));
  }
  static {
    this.ɵfac = function OrderReturnGuard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderReturnGuard)(i0.ɵɵinject(OrderReturnService), i0.ɵɵinject(i2.SemanticPathService), i0.ɵɵinject(i2$2.Router));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderReturnGuard,
      factory: OrderReturnGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderReturnGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: OrderReturnService
  }, {
    type: i2.SemanticPathService
  }, {
    type: i2$2.Router
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReturnOrderConfirmationComponent {
  constructor(orderAmendService) {
    this.orderAmendService = orderAmendService;
    this.form$ = this.orderAmendService.getForm().pipe(tap(form => this.orderCode = form.value.orderCode));
    this.entries$ = this.orderAmendService.getAmendedEntries();
  }
  submit(form) {
    form.disable();
    this.orderAmendService.save();
  }
  static {
    this.ɵfac = function ReturnOrderConfirmationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnOrderConfirmationComponent)(i0.ɵɵdirectiveInject(OrderAmendService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReturnOrderConfirmationComponent,
      selectors: [["cx-return-order-confirmation"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["actions", ""], [3, "formGroup", "ngSubmit", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [4, "ngTemplateOutlet"], [3, "entries", "isConfirmation", 4, "ngIf"], [3, "entries", "isConfirmation"], ["backRoute", "orderReturn", 3, "orderCode", "amendOrderForm", 4, "ngIf"], ["backRoute", "orderReturn", 3, "orderCode", "amendOrderForm"]],
      template: function ReturnOrderConfirmationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ReturnOrderConfirmationComponent_form_0_Template, 7, 6, "form", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.form$));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.NgTemplateOutlet, CancelOrReturnItemsComponent, i3$1.ɵNgNoValidate, i3$1.NgControlStatusGroup, i3$1.FormGroupDirective, AmendOrderActionsComponent, i2$1.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnOrderConfirmationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-return-order-confirmation',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<form\n  *ngIf=\"form$ | async as form\"\n  [formGroup]=\"form\"\n  (ngSubmit)=\"submit(form)\"\n>\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n\n  <cx-amend-order-items\n    *ngIf=\"entries$ | async as entries\"\n    [entries]=\"entries\"\n    [isConfirmation]=\"true\"\n  >\n  </cx-amend-order-items>\n\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n\n  <ng-template #actions>\n    <cx-amend-order-actions\n      *ngIf=\"orderCode\"\n      [orderCode]=\"orderCode\"\n      [amendOrderForm]=\"form\"\n      backRoute=\"orderReturn\"\n    ></cx-amend-order-actions>\n  </ng-template>\n</form>\n"
    }]
  }], () => [{
    type: OrderAmendService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReturnOrderConfirmationModule {
  static {
    this.ɵfac = function ReturnOrderConfirmationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnOrderConfirmationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ReturnOrderConfirmationModule,
      declarations: [ReturnOrderConfirmationComponent],
      imports: [CommonModule, AmendOrderItemsModule, I18nModule, ReactiveFormsModule, AmendOrderActionsModule],
      exports: [ReturnOrderConfirmationComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturnOrderConfirmationComponent: {
            component: ReturnOrderConfirmationComponent,
            guards: [AuthGuard, OrderReturnGuard],
            providers: [{
              provide: OrderAmendService,
              useExisting: OrderReturnService
            }]
          }
        }
      })],
      imports: [CommonModule, AmendOrderItemsModule, I18nModule, ReactiveFormsModule, AmendOrderActionsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnOrderConfirmationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, AmendOrderItemsModule, I18nModule, ReactiveFormsModule, AmendOrderActionsModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturnOrderConfirmationComponent: {
            component: ReturnOrderConfirmationComponent,
            guards: [AuthGuard, OrderReturnGuard],
            providers: [{
              provide: OrderAmendService,
              useExisting: OrderReturnService
            }]
          }
        }
      })],
      declarations: [ReturnOrderConfirmationComponent],
      exports: [ReturnOrderConfirmationComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReturnOrderComponent {
  constructor(orderAmendService) {
    this.orderAmendService = orderAmendService;
    this.form$ = this.orderAmendService.getForm().pipe(tap(form => this.orderCode = form.value.orderCode));
    this.entries$ = this.orderAmendService.getEntries();
  }
  static {
    this.ɵfac = function ReturnOrderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnOrderComponent)(i0.ɵɵdirectiveInject(OrderAmendService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReturnOrderComponent,
      selectors: [["cx-return-order"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["actions", ""], [4, "ngIf"], [4, "ngTemplateOutlet"], [3, "entries", 4, "ngIf"], [3, "control"], [3, "entries"], ["backRoute", "orderDetails", "forwardRoute", "orderReturnConfirmation", 3, "orderCode", "amendOrderForm", 4, "ngIf"], ["backRoute", "orderDetails", "forwardRoute", "orderReturnConfirmation", 3, "orderCode", "amendOrderForm"]],
      template: function ReturnOrderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ReturnOrderComponent_ng_container_0_Template, 8, 6, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.form$));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.NgTemplateOutlet, CancelOrReturnItemsComponent, AmendOrderActionsComponent, i3.FormErrorsComponent, i2$1.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnOrderComponent, [{
    type: Component,
    args: [{
      selector: 'cx-return-order',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"form$ | async as form\">\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n\n  <cx-amend-order-items *ngIf=\"entries$ | async as entries\" [entries]=\"entries\">\n  </cx-amend-order-items>\n\n  <cx-form-errors [control]=\"form.get('entries')\"></cx-form-errors>\n\n  <ng-container *ngTemplateOutlet=\"actions\"></ng-container>\n\n  <ng-template #actions>\n    <cx-amend-order-actions\n      *ngIf=\"orderCode\"\n      [orderCode]=\"orderCode\"\n      [amendOrderForm]=\"form\"\n      backRoute=\"orderDetails\"\n      forwardRoute=\"orderReturnConfirmation\"\n    ></cx-amend-order-actions>\n  </ng-template>\n</ng-container>\n"
    }]
  }], () => [{
    type: OrderAmendService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReturnOrderModule {
  static {
    this.ɵfac = function ReturnOrderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnOrderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ReturnOrderModule,
      declarations: [ReturnOrderComponent],
      imports: [CommonModule, AmendOrderItemsModule, AmendOrderActionsModule, FormErrorsModule],
      exports: [ReturnOrderComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturnOrderComponent: {
            component: ReturnOrderComponent,
            guards: [AuthGuard],
            providers: [{
              provide: OrderAmendService,
              useExisting: OrderReturnService
            }]
          }
        }
      })],
      imports: [CommonModule, AmendOrderItemsModule, AmendOrderActionsModule, FormErrorsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnOrderModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, AmendOrderItemsModule, AmendOrderActionsModule, FormErrorsModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturnOrderComponent: {
            component: ReturnOrderComponent,
            guards: [AuthGuard],
            providers: [{
              provide: OrderAmendService,
              useExisting: OrderReturnService
            }]
          }
        }
      })],
      declarations: [ReturnOrderComponent],
      exports: [ReturnOrderComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderReturnModule {
  static {
    this.ɵfac = function OrderReturnModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderReturnModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrderReturnModule,
      imports: [ReturnOrderModule, ReturnOrderConfirmationModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ReturnOrderModule, ReturnOrderConfirmationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderReturnModule, [{
    type: NgModule,
    args: [{
      imports: [ReturnOrderModule, ReturnOrderConfirmationModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderConfirmationGuard {
  constructor(orderFacade, router, semanticPathService) {
    this.orderFacade = orderFacade;
    this.router = router;
    this.semanticPathService = semanticPathService;
  }
  canActivate() {
    return this.orderFacade.getOrderDetails().pipe(map(orderDetails => {
      if (orderDetails && Object.keys(orderDetails).length !== 0) {
        return true;
      } else {
        return this.router.parseUrl(this.semanticPathService.get('orders') ?? '');
      }
    }));
  }
  static {
    this.ɵfac = function OrderConfirmationGuard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderConfirmationGuard)(i0.ɵɵinject(i1.OrderFacade), i0.ɵɵinject(i2$2.Router), i0.ɵɵinject(i2.SemanticPathService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderConfirmationGuard,
      factory: OrderConfirmationGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderConfirmationGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.OrderFacade
  }, {
    type: i2$2.Router
  }, {
    type: i2.SemanticPathService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2OrdersComponent {
  constructor() {
    this.service = inject(MyAccountV2OrderHistoryService);
    this.PAGE_SIZE = 3;
    this.orders$ = this.service.getOrderHistoryList(this.PAGE_SIZE).pipe(tap(() => this.isLoaded$.next(true)));
    this.isLoaded$ = new BehaviorSubject(false);
  }
  getProduct(order) {
    if (order.entries) {
      for (const entry of order.entries) {
        if (entry.product && entry.product.name && entry.product.images) {
          return entry.product;
        }
      }
      return order.entries[0].product;
    }
  }
  ngOnDestroy() {
    this.isLoaded$.next(false);
    this.service.clearOrderList();
  }
  static {
    this.ɵfac = function MyAccountV2OrdersComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2OrdersComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2OrdersComponent,
      selectors: [["cx-my-account-v2-orders"]],
      standalone: false,
      decls: 17,
      vars: 20,
      consts: [["noOrder", ""], ["loading", ""], [1, "cx-my-account-view-header"], ["role", "heading", "aria-level", "4", 1, "cx-my-account-view-heading"], [1, "cx-my-account-view-show-more"], ["id", "show-more-orders", 1, "btn-link", "cx-action-link", 3, "routerLink"], [4, "ngIf", "ngIfElse"], [1, "cx-my-account-view-body"], [4, "ngFor", "ngForOf"], [1, "cx-my-account-view-order"], [1, "cx-my-account-view-order-header"], ["class", "cx-my-account-view-status", 4, "ngIf"], [1, "cx-my-account-view-code"], [1, "cx-my-account-view-order-body"], [4, "ngIf"], [1, "cx-my-account-view-status"], [1, "cx-my-account-view-order-column-1"], [1, "cx-my-account-view-order-column-1-image"], ["format", "thumbnail", "role", "presentation", 1, "cx-my-account-view-order-img", 3, "container"], [1, "cx-my-account-view-order-column-1-details"], [1, "cx-my-account-view-order-column-1-details-top"], [1, "cx-my-account-view-product-name"], [1, "cx-my-account-view-purchased-on"], [1, "cx-my-account-view-item-count"], [1, "cx-my-account-view-order-column-1-details-bottom"], [1, "cx-my-account-view-total-price"], [1, "cx-my-account-view-order-column-2"], [1, "btn-link", "cx-action-link", 3, "routerLink"], ["class", "cx-my-account-no-order", 4, "ngIf", "ngIfElse"], [1, "cx-my-account-no-order"], ["routerLinkActive", "active", 1, "cx-no-order", 3, "routerLink"], [1, "cx-spinner"]],
      template: function MyAccountV2OrdersComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
          i0.ɵɵpipe(2, "cxTranslate");
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4)(6, "a", 5);
          i0.ɵɵpipe(7, "cxUrl");
          i0.ɵɵpipe(8, "cxTranslate");
          i0.ɵɵtext(9);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(11, MyAccountV2OrdersComponent_div_11_Template, 2, 2, "div", 6);
          i0.ɵɵpipe(12, "async");
          i0.ɵɵtemplate(13, MyAccountV2OrdersComponent_ng_template_13_Template, 2, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(15, MyAccountV2OrdersComponent_ng_template_15_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const noOrder_r5 = i0.ɵɵreference(14);
          i0.ɵɵadvance();
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 7, "myAccountV2OrderHistory.orderListResults"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, "myAccountV2Orders.heading"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(7, 11, i0.ɵɵpureFunction0(19, _c2)));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 13, "myAccountV2Orders.showMoreLabel"));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 15, "myAccountV2Orders.showMore"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(12, 17, ctx.orders$))("ngIfElse", noOrder_r5);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$2.RouterLink, i2$2.RouterLinkActive, i3.SpinnerComponent, i3.MediaComponent, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2OrdersComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-orders',
      standalone: false,
      template: "<div class=\"cx-my-account-view-header\">\n  <!-- HEADER -->\n  <div\n    class=\"cx-my-account-view-heading\"\n    role=\"heading\"\n    aria-level=\"4\"\n    [attr.aria-label]=\"'myAccountV2OrderHistory.orderListResults' | cxTranslate\"\n  >\n    {{ 'myAccountV2Orders.heading' | cxTranslate }}\n  </div>\n\n  <!-- SHOW MORE -->\n  <div class=\"cx-my-account-view-show-more\">\n    <a\n      id=\"show-more-orders\"\n      [attr.aria-label]=\"'myAccountV2Orders.showMoreLabel' | cxTranslate\"\n      class=\"btn-link cx-action-link\"\n      [routerLink]=\"\n        {\n          cxRoute: 'orders',\n        } | cxUrl\n      \"\n    >\n      {{ 'myAccountV2Orders.showMore' | cxTranslate }}\n    </a>\n  </div>\n</div>\n\n<div *ngIf=\"orders$ | async as orderHistory; else noOrder\">\n  <!-- BODY -->\n  <ng-container *ngIf=\"orderHistory.pagination.totalResults > 0; else noOrder\">\n    <div class=\"cx-my-account-view-body\">\n      <ng-container *ngFor=\"let order of orderHistory.orders\">\n        <div class=\"cx-my-account-view-order\">\n          <div class=\"cx-my-account-view-order-header\">\n            <div\n              class=\"cx-my-account-view-status\"\n              *ngIf=\"order.statusDisplay\"\n              [attr.aria-label]=\"\n                'myAccountV2Orders.orderStatusLabel' | cxTranslate\n              \"\n            >\n              {{\n                'orderDetails.statusDisplay_' + order.statusDisplay\n                  | cxTranslate\n              }}\n            </div>\n            <div\n              class=\"cx-my-account-view-code\"\n              [attr.aria-label]=\"\n                'myAccountV2OrderHistory.orderCodeLabel' | cxTranslate\n              \"\n            >\n              {{\n                'myAccountV2Orders.orderNumber'\n                  | cxTranslate: { value: order.code }\n              }}\n            </div>\n          </div>\n          <div class=\"cx-my-account-view-order-body\">\n            <ng-container *ngIf=\"getProduct(order) as product\">\n              <div class=\"cx-my-account-view-order-column-1\">\n                <div class=\"cx-my-account-view-order-column-1-image\">\n                  <cx-media\n                    [container]=\"product.images?.PRIMARY\"\n                    class=\"cx-my-account-view-order-img\"\n                    format=\"thumbnail\"\n                    role=\"presentation\"\n                  ></cx-media>\n                </div>\n                <div class=\"cx-my-account-view-order-column-1-details\">\n                  <div class=\"cx-my-account-view-order-column-1-details-top\">\n                    <div class=\"cx-my-account-view-product-name\">\n                      {{ product.name }}\n                      <span *ngIf=\"order.totalItems - 1 > 1\">\n                        +\n                        {{\n                          'myAccountV2Orders.items'\n                            | cxTranslate: { value: order.totalItems - 1 }\n                        }}\n                      </span>\n                      <span *ngIf=\"order.totalItems - 1 === 1\">\n                        +\n                        {{\n                          'myAccountV2Orders.item' | cxTranslate: { value: 1 }\n                        }}\n                      </span>\n                    </div>\n                    <div class=\"cx-my-account-view-purchased-on\">\n                      {{\n                        'myAccountV2Orders.purchasedOn'\n                          | cxTranslate\n                            : {\n                                value: order.placed | cxDate: 'd, MMMM, yyyy',\n                              }\n                      }}\n                    </div>\n                    <div class=\"cx-my-account-view-item-count\">\n                      {{\n                        'myAccountV2Orders.orderedItems'\n                          | cxTranslate: { value: order.totalItems }\n                      }}\n                    </div>\n                  </div>\n                  <div class=\"cx-my-account-view-order-column-1-details-bottom\">\n                    <div class=\"cx-my-account-view-total-price\">\n                      {{\n                        'myAccountV2Orders.totalPrice'\n                          | cxTranslate: { value: order.total?.formattedValue }\n                      }}\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"cx-my-account-view-order-column-2\">\n                <!-- order details -->\n                <span>\n                  <a\n                    class=\"btn-link cx-action-link\"\n                    [attr.aria-label]=\"\n                      'myAccountV2Orders.orderDetailsLabel'\n                        | cxTranslate: { value: order.code }\n                    \"\n                    [routerLink]=\"\n                      {\n                        cxRoute: 'orderDetails',\n                        params: order,\n                      } | cxUrl\n                    \"\n                  >\n                    {{ 'myAccountV2Orders.orderDetails' | cxTranslate }}\n                  </a>\n                </span>\n                <!-- return order -->\n                <span *ngIf=\"order.returnable\">\n                  {{ ' | '\n                  }}<a\n                    class=\"btn-link cx-action-link\"\n                    [routerLink]=\"\n                      {\n                        cxRoute: 'orderReturn',\n                        params: order,\n                      } | cxUrl\n                    \"\n                  >\n                    {{ 'myAccountV2Orders.returnOrder' | cxTranslate }}\n                  </a>\n                </span>\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n  </ng-container>\n</div>\n<!-- NO ORDER CONTAINER -->\n<ng-template #noOrder>\n  <div class=\"cx-my-account-no-order\" *ngIf=\"isLoaded$ | async; else loading\">\n    <div [attr.aria-label]=\"'orderHistory.notFound' | cxTranslate\">\n      {{ 'orderHistory.noOrders' | cxTranslate }}\n    </div>\n    <a\n      [routerLink]=\"{ cxRoute: 'home' } | cxUrl\"\n      routerLinkActive=\"active\"\n      class=\"cx-no-order\"\n      >{{ 'orderHistory.startShopping' | cxTranslate }}</a\n    >\n  </div>\n</ng-template>\n\n<!-- ORDER HISTORY DATA STILL LOADING -->\n<ng-template #loading>\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</ng-template>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2OrdersModule {
  static {
    this.ɵfac = function MyAccountV2OrdersModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2OrdersModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MyAccountV2OrdersModule,
      declarations: [MyAccountV2OrdersComponent],
      imports: [CommonModule, RouterModule, FormsModule, SpinnerModule, UrlModule, I18nModule, MediaModule],
      exports: [MyAccountV2OrdersComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyAccountViewOrderComponent: {
            component: MyAccountV2OrdersComponent,
            guards: [AuthGuard]
          }
        }
      })],
      imports: [CommonModule, RouterModule, FormsModule, SpinnerModule, UrlModule, I18nModule, MediaModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2OrdersModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, FormsModule, SpinnerModule, UrlModule, I18nModule, MediaModule],
      declarations: [MyAccountV2OrdersComponent],
      exports: [MyAccountV2OrdersComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyAccountViewOrderComponent: {
            component: MyAccountV2OrdersComponent,
            guards: [AuthGuard]
          }
        }
      })]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderDetailBillingComponent {
  constructor(orderDetailsService, translationService) {
    this.orderDetailsService = orderDetailsService;
    this.translationService = translationService;
    this.order$ = this.orderDetailsService.getOrderDetails();
  }
  getPaymentMethodCard(paymentDetails) {
    return combineLatest([this.translationService.translate('paymentForm.payment'), this.translationService.translate('paymentCard.expires', {
      month: paymentDetails.expiryMonth,
      year: paymentDetails.expiryYear
    })]).pipe(map(([textTitle, textExpires]) => paymentMethodCard(textTitle, textExpires, paymentDetails)));
  }
  getBillingAddressCard(paymentDetails) {
    return combineLatest([this.translationService.translate('paymentForm.billingAddress'), this.translationService.translate('addressCard.billTo')]).pipe(map(([billingAddress, billTo]) => billingAddressCard(billingAddress, billTo, paymentDetails)));
  }
  isPaymentInfoCardFull(payment) {
    return !!payment?.cardNumber && !!payment?.expiryMonth && !!payment?.expiryYear;
  }
  static {
    this.ɵfac = function OrderDetailBillingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderDetailBillingComponent)(i0.ɵɵdirectiveInject(OrderDetailsService), i0.ɵɵdirectiveInject(i2.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderDetailBillingComponent,
      selectors: [["cx-order-detail-billing"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["class", "cx-order-items", 4, "ngIf"], [1, "cx-order-items"], ["class", "cx-review-summary", 4, "ngIf"], [1, "cx-review-summary"], ["class", "cx-review-summary-card cx-review-summary-payment-card", 4, "ngIf"], [1, "cx-review-summary-card", "cx-review-summary-payment-card"], [3, "content"]],
      template: function OrderDetailBillingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderDetailBillingComponent_div_0_Template, 2, 1, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i3.CardComponent, i2$1.NgIf, i2$1.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderDetailBillingComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-detail-billing',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"cx-order-items\" *ngIf=\"order$ | async as order\">\n  <div class=\"cx-review-summary\" *ngIf=\"order.paymentInfo as paymentDetails\">\n    <div\n      class=\"cx-review-summary-card cx-review-summary-payment-card\"\n      *ngIf=\"isPaymentInfoCardFull(paymentDetails)\"\n    >\n      <cx-card\n        [content]=\"getPaymentMethodCard(paymentDetails) | async\"\n      ></cx-card>\n    </div>\n    <div\n      class=\"cx-review-summary-card cx-review-summary-payment-card\"\n      *ngIf=\"paymentDetails?.billingAddress\"\n    >\n      <cx-card\n        [content]=\"getBillingAddressCard(paymentDetails) | async\"\n      ></cx-card>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: OrderDetailsService
  }, {
    type: i2.TranslationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderOverviewComponentService {
  shouldShowDeliveryMode(mode) {
    return mode !== undefined;
  }
  static {
    this.ɵfac = function OrderOverviewComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderOverviewComponentService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderOverviewComponentService,
      factory: OrderOverviewComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderOverviewComponentService, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderOverviewComponent {
  constructor(translation, orderDetailsService, component) {
    this.translation = translation;
    this.orderDetailsService = orderDetailsService;
    this.component = component;
    this.orderOverviewComponentService = inject(OrderOverviewComponentService);
    this.orderConfig = inject(OrderConfig);
    this.cartOutlets = CartOutlets;
    this.orderOutlets = OrderOutlets;
    this.order$ = this.orderDetailsService.getOrderDetails();
    this.isOrderLoading$ = typeof this.orderDetailsService.isOrderDetailsLoading === 'function' ? this.orderDetailsService.isOrderDetailsLoading() : of(false);
    this.simple$ = this.component.data$.pipe(map(data => data.simple));
  }
  getReplenishmentCodeCardContent(orderCode) {
    return this.translation.translate('orderDetails.replenishmentId').pipe(filter(() => Boolean(orderCode)), map(textTitle => ({
      title: textTitle,
      text: [orderCode]
    })));
  }
  getReplenishmentActiveCardContent(active) {
    return combineLatest([this.translation.translate('orderDetails.status'), this.translation.translate('orderDetails.active'), this.translation.translate('orderDetails.cancelled')]).pipe(map(([textTitle, textActive, textCancelled]) => ({
      title: textTitle,
      text: [active ? textActive : textCancelled]
    })));
  }
  getReplenishmentStartOnCardContent(isoDate) {
    return this.translation.translate('orderDetails.startOn').pipe(filter(() => Boolean(isoDate)), map(textTitle => {
      return {
        title: textTitle,
        text: [isoDate]
      };
    }));
  }
  getReplenishmentFrequencyCardContent(frequency) {
    return this.translation.translate('orderDetails.frequency').pipe(filter(() => Boolean(frequency)), map(textTitle => ({
      title: textTitle,
      text: [frequency]
    })));
  }
  getReplenishmentNextDateCardContent(isoDate) {
    return this.translation.translate('orderDetails.nextOrderDate').pipe(filter(() => Boolean(isoDate)), map(textTitle => {
      return {
        title: textTitle,
        text: [isoDate]
      };
    }));
  }
  getOrderCodeCardContent(orderCode) {
    return this.translation.translate('orderDetails.orderNumber').pipe(filter(() => Boolean(orderCode)), map(textTitle => ({
      title: textTitle,
      text: [orderCode]
    })));
  }
  getOrderCurrentDateCardContent(isoDate) {
    return this.translation.translate('orderDetails.placedOn').pipe(filter(() => Boolean(isoDate)), map(textTitle => {
      return {
        title: textTitle,
        text: [isoDate]
      };
    }));
  }
  getOrderStatusCardContent(status) {
    return combineLatest([this.translation.translate('orderDetails.status'), this.translation.translate('orderDetails.statusDisplay_' + status)]).pipe(map(([textTitle, textStatus]) => ({
      title: textTitle,
      text: [textStatus]
    })));
  }
  getPurchaseOrderNumber(poNumber) {
    return combineLatest([this.translation.translate('orderDetails.purchaseOrderNumber'), this.translation.translate('orderDetails.emptyPurchaseOrderId')]).pipe(map(([textTitle, noneTextTitle]) => ({
      title: textTitle,
      text: [poNumber ? poNumber : noneTextTitle]
    })));
  }
  getMethodOfPaymentCardContent(hasPaymentInfo) {
    return combineLatest([this.translation.translate('orderDetails.methodOfPayment'), this.translation.translate('paymentTypes.paymentType_ACCOUNT'), this.translation.translate('paymentTypes.paymentType_CARD')]).pipe(map(([textTitle, textAccount, textCard]) => ({
      title: textTitle,
      text: [Boolean(hasPaymentInfo) ? textCard : textAccount]
    })));
  }
  getCostCenterCardContent(costCenter) {
    return this.translation.translate('orderDetails.costCenter').pipe(filter(() => Boolean(costCenter)), map(textTitle => ({
      title: textTitle,
      textBold: costCenter?.name,
      text: ['(' + costCenter?.unit?.name + ')']
    })));
  }
  getAddressCardContent(deliveryAddress) {
    return this.translation.translate('addressCard.shipTo').pipe(filter(() => Boolean(deliveryAddress)), map(textTitle => {
      const formattedAddress = this.normalizeFormattedAddress(deliveryAddress.formattedAddress ?? '');
      return {
        title: textTitle,
        textBold: `${deliveryAddress.firstName} ${deliveryAddress.lastName}`,
        text: [formattedAddress, deliveryAddress.country?.name]
      };
    }));
  }
  shouldShowDeliveryMode(mode) {
    return this.orderOverviewComponentService.shouldShowDeliveryMode(mode);
  }
  getDeliveryModeCardContent(deliveryMode) {
    return this.translation.translate('orderDetails.shippingMethod').pipe(filter(() => Boolean(deliveryMode)), map(textTitle => ({
      title: textTitle,
      textBold: deliveryMode.name,
      text: [deliveryMode.description, deliveryMode.deliveryCost?.formattedValue ? deliveryMode.deliveryCost?.formattedValue : '']
    })));
  }
  getPaymentInfoCardContent(payment) {
    return combineLatest([this.translation.translate('paymentForm.payment'), this.translation.translate('paymentCard.expires', {
      month: Boolean(payment) ? payment.expiryMonth : '',
      year: Boolean(payment) ? payment.expiryYear : ''
    })]).pipe(filter(() => Boolean(payment)), map(([textTitle, textExpires]) => paymentMethodCard(textTitle, textExpires, payment)));
  }
  isPaymentInfoCardFull(payment) {
    return !!payment?.cardNumber && !!payment?.expiryMonth && !!payment?.expiryYear;
  }
  getBillingAddressCardContent(billingAddress) {
    return this.translation.translate('paymentForm.billingAddress').pipe(filter(() => Boolean(billingAddress)), map(textTitle => ({
      title: textTitle,
      textBold: `${billingAddress.firstName} ${billingAddress.lastName}`,
      text: [billingAddress.formattedAddress, billingAddress.country?.name]
    })));
  }
  normalizeFormattedAddress(formattedAddress) {
    const addresses = formattedAddress.split(',').map(address => address.trim());
    return addresses.filter(Boolean).join(', ');
  }
  static {
    this.ɵfac = function OrderOverviewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderOverviewComponent)(i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(OrderDetailsService), i0.ɵɵdirectiveInject(i3.CmsComponentData));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderOverviewComponent,
      selectors: [["cx-order-overview"]],
      standalone: false,
      decls: 4,
      vars: 3,
      consts: [["showQuoteCode", ""], ["otherOrder", ""], ["class", "cx-order-summary", 4, "ngIf"], [1, "cx-order-summary"], [4, "ngIf"], ["class", "container", 4, "ngIf"], [1, "container"], [4, "ngIf", "ngIfElse"], [1, "cx-summary-card"], [3, "cxOutlet", "cxOutletContext"], [3, "content"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "cx-summary-card", 4, "ngIf"], [1, "cx-order-details-cards"], ["id", "quote-container", "class", "card-body cx-card-body", 4, "ngIf"], ["id", "quote-container", 1, "card-body", "cx-card-body"], [1, "cx-card-title"], [1, "cx-card-actions", 3, "routerLink"]],
      template: function OrderOverviewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderOverviewComponent_div_0_Template, 3, 3, "div", 2);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, OrderOverviewComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i3.CardComponent, i2$1.NgIf, i2$1.NgTemplateOutlet, i2$2.RouterLink, i3.OutletDirective, OrderDetailBillingComponent, i2$1.AsyncPipe, i2.TranslatePipe, i2.CxDatePipe, i2.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderOverviewComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-overview',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"cx-order-summary\" *ngIf=\"order$ | async as order\">\n  <ng-container *ngIf=\"!(isOrderLoading$ | async)\">\n    <div *ngIf=\"!(simple$ | async)\" class=\"container\">\n      <ng-container *ngIf=\"order.replenishmentOrderCode; else otherOrder\">\n        <div class=\"cx-summary-card\">\n          <cx-card\n            [content]=\"\n              getReplenishmentCodeCardContent(order?.replenishmentOrderCode)\n                | async\n            \"\n          ></cx-card>\n\n          <cx-card\n            [content]=\"getReplenishmentActiveCardContent(order?.active) | async\"\n          ></cx-card>\n        </div>\n\n        <div class=\"cx-summary-card\">\n          <cx-card\n            [content]=\"\n              getReplenishmentStartOnCardContent(order?.firstDate | cxDate)\n                | async\n            \"\n          ></cx-card>\n\n          <cx-card\n            [content]=\"\n              getReplenishmentFrequencyCardContent(\n                order?.trigger?.displayTimeTable\n              ) | async\n            \"\n          ></cx-card>\n\n          <cx-card\n            [content]=\"\n              getReplenishmentNextDateCardContent(\n                order?.trigger?.activationTime | cxDate\n              ) | async\n            \"\n          ></cx-card>\n\n          <ng-template\n            [cxOutlet]=\"cartOutlets.ORDER_OVERVIEW\"\n            [cxOutletContext]=\"{ item: order, readonly: true }\"\n          >\n          </ng-template>\n        </div>\n      </ng-container>\n\n      <ng-template #otherOrder>\n        <div class=\"cx-summary-card\">\n          <cx-card\n            [content]=\"getOrderCodeCardContent(order?.code) | async\"\n          ></cx-card>\n\n          <cx-card\n            [content]=\"\n              getOrderCurrentDateCardContent(order?.created | cxDate) | async\n            \"\n          ></cx-card>\n\n          <cx-card\n            [content]=\"getOrderStatusCardContent(order.statusDisplay) | async\"\n          ></cx-card>\n\n          <ng-container\n            *ngTemplateOutlet=\"\n              showQuoteCode;\n              context: { sapQuoteCode: order.sapQuoteCode }\n            \"\n          ></ng-container>\n\n          <ng-template\n            [cxOutlet]=\"cartOutlets.ORDER_OVERVIEW\"\n            [cxOutletContext]=\"{ item: order, readonly: true }\"\n          >\n          </ng-template>\n        </div>\n      </ng-template>\n\n      <ng-container\n        *ngIf=\"order.purchaseOrderNumber || order.purchaseOrderNumber === ''\"\n      >\n        <div class=\"cx-summary-card\">\n          <cx-card\n            [content]=\"\n              getPurchaseOrderNumber(order?.purchaseOrderNumber) | async\n            \"\n          ></cx-card>\n\n          <cx-card\n            [content]=\"getMethodOfPaymentCardContent(order.paymentInfo) | async\"\n          ></cx-card>\n\n          <ng-container *ngIf=\"order.costCenter\">\n            <cx-card\n              [content]=\"getCostCenterCardContent(order?.costCenter) | async\"\n            ></cx-card>\n          </ng-container>\n        </div>\n      </ng-container>\n\n      <div class=\"cx-summary-card\">\n        <ng-container *ngIf=\"order.deliveryAddress\">\n          <cx-card\n            [content]=\"getAddressCardContent(order?.deliveryAddress) | async\"\n          ></cx-card>\n        </ng-container>\n\n        <ng-container *ngIf=\"shouldShowDeliveryMode(order.deliveryMode)\">\n          <cx-card\n            [content]=\"getDeliveryModeCardContent(order?.deliveryMode) | async\"\n          ></cx-card>\n        </ng-container>\n\n        <ng-template\n          [cxOutlet]=\"orderOutlets.SERVICE_DETAILS\"\n          [cxOutletContext]=\"{ item: order, readonly: true }\"\n        >\n        </ng-template>\n      </div>\n\n      <ng-container *ngIf=\"order.paymentInfo\">\n        <div\n          class=\"cx-summary-card\"\n          *ngIf=\"\n            order?.paymentInfo?.billingAddress ||\n            isPaymentInfoCardFull(order?.paymentInfo)\n          \"\n        >\n          <ng-container *ngIf=\"isPaymentInfoCardFull(order?.paymentInfo)\">\n            <cx-card\n              [content]=\"getPaymentInfoCardContent(order?.paymentInfo) | async\"\n            ></cx-card>\n          </ng-container>\n\n          <cx-card\n            [content]=\"\n              getBillingAddressCardContent(order?.paymentInfo?.billingAddress)\n                | async\n            \"\n          ></cx-card>\n        </div>\n      </ng-container>\n    </div>\n\n    <div *ngIf=\"simple$ | async\" class=\"container\">\n      <div class=\"cx-order-details-cards\">\n        <cx-card\n          [content]=\"getOrderCodeCardContent(order?.code) | async\"\n        ></cx-card>\n\n        <cx-card\n          [content]=\"\n            getOrderCurrentDateCardContent(order?.created | cxDate) | async\n          \"\n        ></cx-card>\n\n        <cx-card\n          [content]=\"getOrderStatusCardContent(order.statusDisplay) | async\"\n        ></cx-card>\n\n        <ng-container\n          *ngTemplateOutlet=\"\n            showQuoteCode;\n            context: { sapQuoteCode: order.sapQuoteCode }\n          \"\n        ></ng-container>\n\n        <ng-template\n          [cxOutlet]=\"cartOutlets.ORDER_OVERVIEW\"\n          [cxOutletContext]=\"{ item: order, readonly: true }\"\n        >\n        </ng-template>\n      </div>\n      <cx-order-detail-billing\n        *ngIf=\"\n          isPaymentInfoCardFull(order?.paymentInfo) ||\n          order?.paymentInfo?.billingAddress\n        \"\n      ></cx-order-detail-billing>\n    </div>\n  </ng-container>\n</div>\n\n<ng-template #showQuoteCode let-quoteCode=\"sapQuoteCode\">\n  <div\n    id=\"quote-container\"\n    class=\"card-body cx-card-body\"\n    *ngIf=\"orderConfig.showOrderQuoteLink && quoteCode\"\n  >\n    <div class=\"cx-card-title\">\n      {{ 'orderDetails.quoteCode' | cxTranslate: { id: quoteCode } }}\n    </div>\n    <a\n      [routerLink]=\"\n        { cxRoute: 'quoteDetails', params: { quoteId: quoteCode } } | cxUrl\n      \"\n      class=\"cx-card-actions\"\n    >\n      {{ 'orderDetails.quoteDetail' | cxTranslate }}\n    </a>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i2.TranslationService
  }, {
    type: OrderDetailsService
  }, {
    type: i3.CmsComponentData
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderConfirmationOrderEntriesContext {
  constructor(orderFacade) {
    this.orderFacade = orderFacade;
    this.type = OrderEntriesSource.ORDER_CONFIRMATION;
  }
  getEntries() {
    return this.orderFacade.getOrderDetails().pipe(map(order => order?.entries ?? []));
  }
  static {
    this.ɵfac = function OrderConfirmationOrderEntriesContext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderConfirmationOrderEntriesContext)(i0.ɵɵinject(i1.OrderFacade));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderConfirmationOrderEntriesContext,
      factory: OrderConfirmationOrderEntriesContext.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderConfirmationOrderEntriesContext, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.OrderFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderConfirmationItemsComponent {
  constructor(orderFacade) {
    this.orderFacade = orderFacade;
    this.cartOutlets = CartOutlets;
    this.abstractOrderType = AbstractOrderType;
    this.promotionLocation = PromotionLocation.Checkout;
    this.order$ = this.orderFacade.getOrderDetails();
  }
  ngOnDestroy() {
    this.orderFacade.clearPlacedOrder();
  }
  static {
    this.ɵfac = function OrderConfirmationItemsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderConfirmationItemsComponent)(i0.ɵɵdirectiveInject(i1.OrderFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderConfirmationItemsComponent,
      selectors: [["cx-order-confirmation-items"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["class", "cx-order-items container", 4, "ngIf"], [1, "cx-order-items", "container"], [1, "cx-order-items-header"], [3, "promotions"], [3, "cxAbstractOrderContext", "cxOutlet", "cxOutletContext"]],
      template: function OrderConfirmationItemsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderConfirmationItemsComponent_div_0_Template, 6, 14, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i2$1.NgIf, i3.PromotionsComponent, i3.OutletDirective, i5.AbstractOrderContextDirective, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderConfirmationItemsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-confirmation-items',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"cx-order-items container\" *ngIf=\"order$ | async as order\">\n  <h3 class=\"cx-order-items-header\">\n    {{ 'checkoutOrderConfirmation.orderItems' | cxTranslate }}\n  </h3>\n  <cx-promotions\n    [promotions]=\"order.appliedOrderPromotions || []\"\n  ></cx-promotions>\n\n  <ng-template\n    [cxAbstractOrderContext]=\"{\n      id: order.code,\n      type: abstractOrderType.ORDER,\n    }\"\n    [cxOutlet]=\"cartOutlets.CART_ITEM_LIST\"\n    [cxOutletContext]=\"{\n      items: order.entries,\n      readonly: true,\n      promotionLocation: promotionLocation,\n    }\"\n  >\n  </ng-template>\n</div>\n"
    }]
  }], () => [{
    type: i1.OrderFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderConfirmationShippingComponent {
  constructor(orderFacade, translationService, cd, outlet) {
    this.orderFacade = orderFacade;
    this.translationService = translationService;
    this.cd = cd;
    this.outlet = outlet;
    this.showItemList = true;
    this.cartOutlets = CartOutlets;
    this.abstractOrderType = AbstractOrderType;
    this.order$ = this.orderFacade.getOrderDetails().pipe(tap(order => {
      this.entries = order?.entries?.filter(entry => !entry.deliveryPointOfService);
    }));
    this.subscription = new Subscription();
  }
  ngOnInit() {
    this.subscription.add(this.outlet?.context$.subscribe(context => {
      if (context.showItemList !== undefined) {
        this.showItemList = context.showItemList;
      }
      if (context.order) {
        this.order$ = of(context.order);
      }
      this.cd.markForCheck();
    }));
  }
  getDeliveryAddressCard(deliveryAddress, countryName) {
    return combineLatest([this.translationService.translate('addressCard.shipTo'), this.translationService.translate('addressCard.phoneNumber'), this.translationService.translate('addressCard.mobileNumber')]).pipe(map(([textTitle, textPhone, textMobile]) => deliveryAddressCard(textTitle, textPhone, textMobile, deliveryAddress, countryName)));
  }
  getDeliveryModeCard(deliveryMode) {
    return combineLatest([this.translationService.translate('checkoutMode.deliveryMethod')]).pipe(map(([textTitle]) => deliveryModeCard(textTitle, deliveryMode)));
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function OrderConfirmationShippingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderConfirmationShippingComponent)(i0.ɵɵdirectiveInject(i1.OrderFacade), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.OutletContextData, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderConfirmationShippingComponent,
      selectors: [["cx-order-confirmation-shipping"]],
      inputs: {
        showItemList: "showItemList"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["class", "cx-order-items", 4, "ngIf"], [1, "cx-order-items"], [4, "ngIf"], [1, "cx-review-header"], [1, "cx-review-summary", "cx-review-shipping-summary"], [1, "cx-review-summary-card-container"], [1, "cx-review-summary-card", "cx-review-card-address"], [3, "content"], ["class", "cx-review-cart-item", 4, "ngIf"], [1, "cx-review-cart-item"], [3, "cxAbstractOrderContext", "cxOutlet", "cxOutletContext"]],
      template: function OrderConfirmationShippingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderConfirmationShippingComponent_div_0_Template, 2, 1, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i2$1.NgIf, i3.CardComponent, i3.OutletDirective, i5.AbstractOrderContextDirective, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderConfirmationShippingComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-confirmation-shipping',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"cx-order-items\" *ngIf=\"order$ | async as order\">\n  <ng-container *ngIf=\"!showItemList || entries?.length > 0\">\n    <h2 class=\"cx-review-header\">\n      {{ 'checkoutMode.deliveryEntries' | cxTranslate }}\n    </h2>\n\n    <div class=\"cx-review-summary cx-review-shipping-summary\">\n      <!-- DELIVERY ADDRESS SECTION -->\n      <div class=\"cx-review-summary-card-container\">\n        <div class=\"cx-review-summary-card cx-review-card-address\">\n          <cx-card\n            [content]=\"getDeliveryAddressCard(order.deliveryAddress) | async\"\n          ></cx-card>\n        </div>\n      </div>\n\n      <!-- DELIVERY MODE SECTION -->\n      <div class=\"cx-review-summary-card-container\">\n        <div class=\"cx-review-summary-card cx-review-card-address\">\n          <cx-card\n            [content]=\"getDeliveryModeCard(order.deliveryMode) | async\"\n          ></cx-card>\n        </div>\n      </div>\n    </div>\n\n    <!-- CART ITEM SECTION -->\n    <div *ngIf=\"showItemList\" class=\"cx-review-cart-item\">\n      <ng-template\n        [cxAbstractOrderContext]=\"{\n          id: order.code,\n          type: abstractOrderType.ORDER,\n        }\"\n        [cxOutlet]=\"cartOutlets.CART_ITEM_LIST\"\n        [cxOutletContext]=\"{\n          items: entries,\n          readonly: true,\n        }\"\n      >\n      </ng-template>\n    </div>\n  </ng-container>\n</div>\n"
    }]
  }], () => [{
    type: i1.OrderFacade
  }, {
    type: i2.TranslationService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i3.OutletContextData,
    decorators: [{
      type: Optional
    }]
  }], {
    showItemList: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderGuestRegisterFormComponent {
  constructor(userRegisterFacade, routingService, authService, fb) {
    this.userRegisterFacade = userRegisterFacade;
    this.routingService = routingService;
    this.authService = authService;
    this.fb = fb;
    this.featureConfigService = inject(FeatureConfigService);
    this.passwordValidators = this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidators : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? [...CustomFormValidators.passwordValidators, CustomFormValidators.noConsecutiveCharacters] : CustomFormValidators.passwordValidators;
    this.guestRegisterForm = this.fb.group({
      password: ['', [Validators.required, ...this.passwordValidators]],
      passwordconf: ['', Validators.required]
    }, {
      validators: CustomFormValidators.passwordsMustMatch('password', 'passwordconf')
    });
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }
  submit() {
    if (this.guestRegisterForm.valid) {
      this.userRegisterFacade.registerGuest(this.guid, this.guestRegisterForm.value.password);
      if (!this.subscription) {
        this.subscription = this.authService.isUserLoggedIn().subscribe(isLoggedIn => {
          if (isLoggedIn) {
            this.routingService.go({
              cxRoute: 'home'
            });
          }
        });
      }
    } else {
      this.guestRegisterForm.markAllAsTouched();
    }
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function OrderGuestRegisterFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderGuestRegisterFormComponent)(i0.ɵɵdirectiveInject(i1$1.UserRegisterFacade), i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i2.AuthService), i0.ɵɵdirectiveInject(i3$1.UntypedFormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderGuestRegisterFormComponent,
      selectors: [["cx-guest-register-form"]],
      inputs: {
        guid: "guid",
        email: "email"
      },
      standalone: false,
      decls: 35,
      vars: 47,
      consts: [[1, "register-guest"], [1, "col-md-6", "col-lg-4"], [3, "ngSubmit", "formGroup"], [1, "form-group"], [1, "label-content"], ["required", "true", "type", "password", "name", "password", "formControlName", "password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", 3, "translationParams", "control"], ["required", "true", "type", "password", "name", "passwordconf", "formControlName", "passwordconf", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordconfError", 3, "translationParams", "control"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"]],
      template: function OrderGuestRegisterFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3");
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "p");
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "form", 2);
          i0.ɵɵlistener("ngSubmit", function OrderGuestRegisterFormComponent_Template_form_ngSubmit_8_listener() {
            return ctx.submit();
          });
          i0.ɵɵelement(9, "cx-form-required-legend");
          i0.ɵɵelementStart(10, "div", 3)(11, "label")(12, "span", 4);
          i0.ɵɵtext(13);
          i0.ɵɵpipe(14, "cxTranslate");
          i0.ɵɵelement(15, "cx-form-required-asterisks");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(16, "input", 5);
          i0.ɵɵpipe(17, "cxTranslate");
          i0.ɵɵpipe(18, "cxTranslate");
          i0.ɵɵelement(19, "cx-form-errors", 6);
          i0.ɵɵpipe(20, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(21, "div", 3)(22, "label")(23, "span", 4);
          i0.ɵɵtext(24);
          i0.ɵɵpipe(25, "cxTranslate");
          i0.ɵɵelement(26, "cx-form-required-asterisks");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(27, "input", 7);
          i0.ɵɵpipe(28, "cxTranslate");
          i0.ɵɵpipe(29, "cxTranslate");
          i0.ɵɵelement(30, "cx-form-errors", 8);
          i0.ɵɵpipe(31, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(32, "button", 9);
          i0.ɵɵtext(33);
          i0.ɵɵpipe(34, "cxTranslate");
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          let tmp_6_0;
          let tmp_13_0;
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 18, "checkoutOrderConfirmation.createAccount"));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 20, "checkoutOrderConfirmation.createAccountForNext", i0.ɵɵpureFunction1(41, _c17, ctx.email)), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.guestRegisterForm);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 23, "register.password.label"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(17, 25, "register.password.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(18, 27, "register.password.placeholder"))("aria-invalid", ((tmp_6_0 = ctx.guestRegisterForm.get("password")) == null ? null : tmp_6_0.touched) && ((tmp_6_0 = ctx.guestRegisterForm.get("password")) == null ? null : tmp_6_0.invalid))("aria-errormessage", "passwordError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(43, _c18, i0.ɵɵpipeBind1(20, 29, "register.password.label")))("control", ctx.guestRegisterForm.get("password"));
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 31, "register.confirmPassword.label"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(28, 33, "register.confirmPassword.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(29, 35, "register.confirmPassword.placeholder"))("aria-invalid", ((tmp_13_0 = ctx.guestRegisterForm.get("passwordconf")) == null ? null : tmp_13_0.touched) && ((tmp_13_0 = ctx.guestRegisterForm.get("passwordconf")) == null ? null : tmp_13_0.invalid))("aria-errormessage", "passwordconfError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(45, _c18, i0.ɵɵpipeBind1(31, 37, "register.confirmPassword.label")))("control", ctx.guestRegisterForm.get("passwordconf"));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(34, 39, "common.submit"), " ");
        }
      },
      dependencies: [i3$1.ɵNgNoValidate, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.NgControlStatusGroup, i3$1.RequiredValidator, i3$1.FormGroupDirective, i3$1.FormControlName, i3.FormErrorsComponent, i3.PasswordVisibilityToggleDirective, i3.FormRequiredAsterisksComponent, i3.FormRequiredLegendComponent, i2.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderGuestRegisterFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-guest-register-form',
      standalone: false,
      template: "<div class=\"register-guest\">\n  <div class=\"col-md-6 col-lg-4\">\n    <h3>{{ 'checkoutOrderConfirmation.createAccount' | cxTranslate }}</h3>\n    <p>\n      {{\n        'checkoutOrderConfirmation.createAccountForNext'\n          | cxTranslate: { email: email }\n      }}\n    </p>\n\n    <form (ngSubmit)=\"submit()\" [formGroup]=\"guestRegisterForm\">\n      <cx-form-required-legend />\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\">\n            {{ 'register.password.label' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            required=\"true\"\n            class=\"form-control\"\n            type=\"password\"\n            name=\"password\"\n            placeholder=\"{{ 'register.password.placeholder' | cxTranslate }}\"\n            formControlName=\"password\"\n            [attr.aria-label]=\"'register.password.placeholder' | cxTranslate\"\n            [attr.aria-invalid]=\"\n              guestRegisterForm.get('password')?.touched &&\n              guestRegisterForm.get('password')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'passwordError'\"\n            cxPasswordVisibilitySwitch\n          />\n\n          <cx-form-errors\n            id=\"passwordError\"\n            [translationParams]=\"{\n              label: 'register.password.label' | cxTranslate,\n            }\"\n            [control]=\"guestRegisterForm.get('password')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\">\n            {{ 'register.confirmPassword.label' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            required=\"true\"\n            class=\"form-control\"\n            type=\"password\"\n            name=\"passwordconf\"\n            placeholder=\"{{\n              'register.confirmPassword.placeholder' | cxTranslate\n            }}\"\n            formControlName=\"passwordconf\"\n            [attr.aria-label]=\"\n              'register.confirmPassword.placeholder' | cxTranslate\n            \"\n            [attr.aria-invalid]=\"\n              guestRegisterForm.get('passwordconf')?.touched &&\n              guestRegisterForm.get('passwordconf')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'passwordconfError'\"\n            cxPasswordVisibilitySwitch\n          />\n\n          <cx-form-errors\n            id=\"passwordconfError\"\n            [translationParams]=\"{\n              label: 'register.confirmPassword.label' | cxTranslate,\n            }\"\n            [control]=\"guestRegisterForm.get('passwordconf')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n\n      <button type=\"submit\" class=\"btn btn-block btn-primary\">\n        {{ 'common.submit' | cxTranslate }}\n      </button>\n    </form>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1$1.UserRegisterFacade
  }, {
    type: i2.RoutingService
  }, {
    type: i2.AuthService
  }, {
    type: i3$1.UntypedFormBuilder
  }], {
    guid: [{
      type: Input
    }],
    email: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderConfirmationThankYouMessageComponent {
  constructor(orderFacade, globalMessageService, translationService) {
    this.orderFacade = orderFacade;
    this.globalMessageService = globalMessageService;
    this.translationService = translationService;
    this.isGuestCustomer = false;
  }
  ngOnInit() {
    this.order$ = this.orderFacade.getOrderDetails().pipe(tap(order => {
      this.isGuestCustomer = order && 'guestCustomer' in order ? order.guestCustomer ?? false : false;
      this.orderGuid = order?.guid;
    }));
  }
  ngAfterViewInit() {
    this.addThankYouMessage();
  }
  ngOnDestroy() {
    this.orderFacade.clearPlacedOrder();
  }
  addThankYouMessage() {
    this.getThankYouAssistiveMessage().pipe(take(1)).subscribe(([order, confirmationOfOrderMessage, thankYouMessage, invoiceHasBeenSentByEmailMessage]) => {
      const code = order.replenishmentOrderCode ?? order.code;
      const message = `${confirmationOfOrderMessage} ${code}. ${thankYouMessage} ${invoiceHasBeenSentByEmailMessage}`;
      this.globalMessageService.add(message, GlobalMessageType.MSG_TYPE_ASSISTIVE);
    });
  }
  getThankYouAssistiveMessage() {
    const confirmationOfOrderMessage$ = this.translationService.translate('checkoutOrderConfirmation.confirmationOfOrder');
    const thankYouMessage$ = this.translationService.translate('checkoutOrderConfirmation.thankYou');
    const invoiceHasBeenSentByEmailMessage$ = this.translationService.translate('checkoutOrderConfirmation.invoiceHasBeenSentByEmail');
    return this.order$.pipe(filter(order => !!order), withLatestFrom(confirmationOfOrderMessage$, thankYouMessage$, invoiceHasBeenSentByEmailMessage$));
  }
  static {
    this.ɵfac = function OrderConfirmationThankYouMessageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderConfirmationThankYouMessageComponent)(i0.ɵɵdirectiveInject(i1.OrderFacade), i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i2.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderConfirmationThankYouMessageComponent,
      selectors: [["cx-order-confirmation-thank-you-message"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "cx-page-header"], [1, "cx-page-title"], [1, "cx-order-confirmation-message"], [3, "guid", "email"]],
      template: function OrderConfirmationThankYouMessageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderConfirmationThankYouMessageComponent_ng_container_0_Template, 14, 11, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i2$1.NgIf, i3.AddToHomeScreenBannerComponent, OrderGuestRegisterFormComponent, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderConfirmationThankYouMessageComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-confirmation-thank-you-message',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"order$ | async as order\">\n  <div class=\"cx-page-header\">\n    <span class=\"cx-page-title\">\n      {{ 'checkoutOrderConfirmation.confirmationOfOrder' | cxTranslate }}\n      {{ order.replenishmentOrderCode ?? order.code }}\n    </span>\n  </div>\n\n  <div class=\"cx-order-confirmation-message\">\n    <h2>{{ 'checkoutOrderConfirmation.thankYou' | cxTranslate }}</h2>\n    <p>\n      {{ 'checkoutOrderConfirmation.invoiceHasBeenSentByEmail' | cxTranslate }}\n    </p>\n  </div>\n  <div\n    *ngIf=\"\n      isGuestCustomer && orderGuid && order?.paymentInfo?.billingAddress?.email\n    \"\n  >\n    <cx-guest-register-form\n      [guid]=\"orderGuid\"\n      [email]=\"order.paymentInfo.billingAddress.email\"\n    ></cx-guest-register-form>\n  </div>\n\n  <cx-add-to-home-screen-banner></cx-add-to-home-screen-banner>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.OrderFacade
  }, {
    type: i2.GlobalMessageService
  }, {
    type: i2.TranslationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderConfirmationTotalsComponent {
  constructor(orderFacade) {
    this.orderFacade = orderFacade;
    this.cartOutlets = CartOutlets;
    this.order$ = this.orderFacade.getOrderDetails();
    useFeatureStyles('a11yWideScreenImprovements');
  }
  ngOnDestroy() {
    this.orderFacade.clearPlacedOrder();
  }
  static {
    this.ɵfac = function OrderConfirmationTotalsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderConfirmationTotalsComponent)(i0.ɵɵdirectiveInject(i1.OrderFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderConfirmationTotalsComponent,
      selectors: [["cx-order-confirmation-totals"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["class", "cx-order-summary container", 4, "ngIf"], [1, "cx-order-summary", "container"], [1, "row", "justify-content-end"], [1, "col-sm-12", "col-md-6", "col-lg-5", "col-xl-4"], [3, "cxOutlet", "cxOutletContext"]],
      template: function OrderConfirmationTotalsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderConfirmationTotalsComponent_div_0_Template, 4, 2, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i2$1.NgIf, i3.OutletDirective, i2$1.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderConfirmationTotalsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-confirmation-totals',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"cx-order-summary container\" *ngIf=\"order$ | async as order\">\n  <div class=\"row justify-content-end\">\n    <div class=\"col-sm-12 col-md-6 col-lg-5 col-xl-4\">\n      <ng-template\n        [cxOutlet]=\"cartOutlets.ORDER_SUMMARY\"\n        [cxOutletContext]=\"order\"\n      >\n      </ng-template>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.OrderFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const orderConfirmationComponents = [OrderConfirmationItemsComponent, OrderConfirmationThankYouMessageComponent, OrderConfirmationTotalsComponent, OrderGuestRegisterFormComponent, OrderConfirmationShippingComponent];
class OrderConfirmationModule {
  static {
    this.ɵfac = function OrderConfirmationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderConfirmationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrderConfirmationModule,
      declarations: [OrderConfirmationItemsComponent, OrderConfirmationThankYouMessageComponent, OrderConfirmationTotalsComponent, OrderGuestRegisterFormComponent, OrderConfirmationShippingComponent],
      imports: [CommonModule, CardModule, PwaModule, PromotionsModule, I18nModule, ReactiveFormsModule, FormErrorsModule, i3.OutletModule, PasswordVisibilityToggleModule, AbstractOrderContextModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent],
      exports: [OrderConfirmationItemsComponent, OrderConfirmationThankYouMessageComponent, OrderConfirmationTotalsComponent, OrderGuestRegisterFormComponent, OrderConfirmationShippingComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          OrderConfirmationThankMessageComponent: {
            component: OrderConfirmationThankYouMessageComponent,
            guards: [OrderConfirmationGuard]
          },
          ReplenishmentConfirmationMessageComponent: {
            component: OrderConfirmationThankYouMessageComponent,
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationItemsComponent: {
            component: OrderConfirmationItemsComponent,
            guards: [OrderConfirmationGuard]
          },
          ReplenishmentConfirmationItemsComponent: {
            component: OrderConfirmationItemsComponent,
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationTotalsComponent: {
            component: OrderConfirmationTotalsComponent,
            guards: [OrderConfirmationGuard]
          },
          ReplenishmentConfirmationTotalsComponent: {
            component: OrderConfirmationTotalsComponent,
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationOverviewComponent: {
            component: OrderOverviewComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: OrderFacade
            }],
            guards: [OrderConfirmationGuard]
          },
          ReplenishmentConfirmationOverviewComponent: {
            component: OrderOverviewComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: OrderFacade
            }],
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationShippingComponent: {
            component: OrderConfirmationShippingComponent,
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationBillingComponent: {
            component: OrderDetailBillingComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: OrderFacade
            }],
            guards: [OrderConfirmationGuard]
          }
        }
      }), {
        provide: OrderConfirmationOrderEntriesContextToken,
        useExisting: OrderConfirmationOrderEntriesContext
      }, provideOutlet({
        id: OrderOutlets.CONSIGNMENT_DELIVERY_INFO,
        component: OrderConfirmationShippingComponent
      })],
      imports: [CommonModule, CardModule, PwaModule, PromotionsModule, I18nModule, ReactiveFormsModule, FormErrorsModule, OutletModule.forChild(), PasswordVisibilityToggleModule, AbstractOrderContextModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderConfirmationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, CardModule, PwaModule, PromotionsModule, I18nModule, ReactiveFormsModule, FormErrorsModule, OutletModule.forChild(), PasswordVisibilityToggleModule, AbstractOrderContextModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          OrderConfirmationThankMessageComponent: {
            component: OrderConfirmationThankYouMessageComponent,
            guards: [OrderConfirmationGuard]
          },
          ReplenishmentConfirmationMessageComponent: {
            component: OrderConfirmationThankYouMessageComponent,
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationItemsComponent: {
            component: OrderConfirmationItemsComponent,
            guards: [OrderConfirmationGuard]
          },
          ReplenishmentConfirmationItemsComponent: {
            component: OrderConfirmationItemsComponent,
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationTotalsComponent: {
            component: OrderConfirmationTotalsComponent,
            guards: [OrderConfirmationGuard]
          },
          ReplenishmentConfirmationTotalsComponent: {
            component: OrderConfirmationTotalsComponent,
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationOverviewComponent: {
            component: OrderOverviewComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: OrderFacade
            }],
            guards: [OrderConfirmationGuard]
          },
          ReplenishmentConfirmationOverviewComponent: {
            component: OrderOverviewComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: OrderFacade
            }],
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationShippingComponent: {
            component: OrderConfirmationShippingComponent,
            guards: [OrderConfirmationGuard]
          },
          OrderConfirmationBillingComponent: {
            component: OrderDetailBillingComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: OrderFacade
            }],
            guards: [OrderConfirmationGuard]
          }
        }
      }), {
        provide: OrderConfirmationOrderEntriesContextToken,
        useExisting: OrderConfirmationOrderEntriesContext
      }, provideOutlet({
        id: OrderOutlets.CONSIGNMENT_DELIVERY_INFO,
        component: OrderConfirmationShippingComponent
      })],
      declarations: [...orderConfirmationComponents],
      exports: [...orderConfirmationComponents]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderDetailActionsComponent {
  constructor(orderDetailsService) {
    this.orderDetailsService = orderDetailsService;
    this.order$ = this.orderDetailsService.getOrderDetails();
  }
  static {
    this.ɵfac = function OrderDetailActionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderDetailActionsComponent)(i0.ɵɵdirectiveInject(OrderDetailsService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderDetailActionsComponent,
      selectors: [["cx-order-details-actions"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "cx-nav", "row"], [1, "col-xs-12", "col-md-4", "col-lg-3"], [1, "btn", "btn-block", "btn-secondary", 3, "routerLink"], ["cxBtnLikeLink", "", "class", "btn btn-block btn-secondary", 3, "routerLink", 4, "ngIf"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"]],
      template: function OrderDetailActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderDetailActionsComponent_ng_container_0_Template, 10, 9, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i2$1.NgIf, i2$2.RouterLink, i3.BtnLikeLinkDirective, i2$1.AsyncPipe, i2.TranslatePipe, i2.UrlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderDetailActionsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-details-actions',
      standalone: false,
      template: "<ng-container *ngIf=\"order$ | async as order\">\n  <div class=\"cx-nav row\">\n    <div class=\"col-xs-12 col-md-4 col-lg-3\">\n      <button\n        [routerLink]=\"{ cxRoute: 'orders' } | cxUrl\"\n        class=\"btn btn-block btn-secondary\"\n      >\n        {{ 'common.back' | cxTranslate }}\n      </button>\n    </div>\n\n    <div class=\"col-xs-12 col-md-4 col-lg-3\">\n      <a\n        *ngIf=\"order.cancellable\"\n        [routerLink]=\"\n          {\n            cxRoute: 'orderCancel',\n            params: order,\n          } | cxUrl\n        \"\n        cxBtnLikeLink\n        class=\"btn btn-block btn-secondary\"\n      >\n        {{ 'orderDetails.cancellationAndReturn.cancelAction' | cxTranslate }}\n      </a>\n\n      <a\n        *ngIf=\"order.returnable\"\n        [routerLink]=\"\n          {\n            cxRoute: 'orderReturn',\n            params: order,\n          } | cxUrl\n        \"\n        cxBtnLikeLink\n        class=\"btn btn-block btn-secondary\"\n      >\n        {{ 'orderDetails.cancellationAndReturn.returnAction' | cxTranslate }}\n      </a>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: OrderDetailsService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2OrderDetailsActionsComponent extends OrderDetailActionsComponent {
  constructor() {
    super(...arguments);
    this.eventService = inject(EventService);
  }
  ngOnInit() {
    this.order$.subscribe(order => {
      this.order = order;
    });
  }
  showDialog(order) {
    const newEvent = new DownloadOrderInvoicesEvent();
    newEvent.order = order;
    this.eventService.dispatch(newEvent);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMyAccountV2OrderDetailsActionsComponent_BaseFactory;
      return function MyAccountV2OrderDetailsActionsComponent_Factory(__ngFactoryType__) {
        return (ɵMyAccountV2OrderDetailsActionsComponent_BaseFactory || (ɵMyAccountV2OrderDetailsActionsComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MyAccountV2OrderDetailsActionsComponent)))(__ngFactoryType__ || MyAccountV2OrderDetailsActionsComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2OrderDetailsActionsComponent,
      selectors: [["cx-my-account-v2-order-details-actions"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [1, "cx-order-details-actions", "row"], [1, "cx-view-all-orders"], [1, "col-xs-12", "col-md-4", "col-lg-3"], [1, "cx-action-button-left"], ["id", "view-all-orders-btn", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"], [1, "cx-other-actions"], ["class", "cx-action-button", 4, "ngIf"], [1, "cx-action-button"], ["id", "download-invoices-btn", 1, "btn", "btn-block", "btn-secondary", 3, "click"], ["id", "cancel-items-btn", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"], ["id", "return-items-btn", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"]],
      template: function MyAccountV2OrderDetailsActionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2OrderDetailsActionsComponent_ng_container_0_Template, 17, 12, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.order);
        }
      },
      dependencies: [i2$1.NgIf, i2$2.RouterLink, i2.TranslatePipe, i2.UrlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2OrderDetailsActionsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-order-details-actions',
      standalone: false,
      template: "<ng-container *ngIf=\"order\">\n  <div class=\"cx-order-details-actions row\">\n    <div class=\"cx-view-all-orders\">\n      <span class=\"col-xs-12 col-md-4 col-lg-3\">\n        <span class=\"cx-action-button-left\">\n          <button\n            id=\"view-all-orders-btn\"\n            [routerLink]=\"{ cxRoute: 'orders' } | cxUrl\"\n            class=\"btn btn-block btn-secondary\"\n          >\n            {{ 'myAccountV2OrderDetails.viewAllOrders' | cxTranslate }}\n          </button>\n        </span>\n      </span>\n    </div>\n    <div class=\"cx-other-actions\">\n      <span class=\"col-xs-12 col-md-4 col-lg-3\">\n        <span *ngIf=\"order.cancellable\" class=\"cx-action-button\">\n          <button\n            id=\"cancel-items-btn\"\n            [routerLink]=\"\n              {\n                cxRoute: 'orderCancel',\n                params: order,\n              } | cxUrl\n            \"\n            class=\"btn btn-block btn-secondary\"\n          >\n            {{ 'myAccountV2OrderDetails.cancelItems' | cxTranslate }}\n          </button>\n        </span>\n        <span *ngIf=\"order.returnable\" class=\"cx-action-button\">\n          <button\n            id=\"return-items-btn\"\n            [routerLink]=\"\n              {\n                cxRoute: 'orderReturn',\n                params: order,\n              } | cxUrl\n            \"\n            class=\"btn btn-block btn-secondary\"\n          >\n            {{ 'myAccountV2OrderDetails.returnItems' | cxTranslate }}\n          </button>\n        </span>\n        <span class=\"cx-action-button\">\n          <button\n            id=\"download-invoices-btn\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"showDialog(order)\"\n          >\n            {{ 'myAccountV2OrderDetails.downloadInvoices' | cxTranslate }}\n          </button>\n        </span>\n      </span>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2DownloadInvoicesComponent {
  constructor() {
    this.OrderOutlets = OrderOutlets;
    this.invoiceCount = undefined;
    this.iconTypes = ICON_TYPE;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: true,
      focusOnEscape: true
    };
    this.launchDialogService = inject(LaunchDialogService);
    this.cdr = inject(ChangeDetectorRef);
  }
  ngAfterViewChecked() {
    this.cdr.detectChanges();
    if (this.invoiceComponent && this.invoiceComponent.pagination !== undefined) {
      this.invoiceCount = this.invoiceComponent.pagination.totalResults;
    }
  }
  close(reason, _message) {
    this.launchDialogService.closeDialog(reason);
  }
  static {
    this.ɵfac = function MyAccountV2DownloadInvoicesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2DownloadInvoicesComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2DownloadInvoicesComponent,
      selectors: [["cx-my-account-v2-download-invoices"]],
      viewQuery: function MyAccountV2DownloadInvoicesComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(InvoicesListComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invoiceComponent = _t.first);
        }
      },
      standalone: false,
      decls: 15,
      vars: 13,
      consts: [["role", "dialog", "aria-describedby", "downloadInvoicesContent", 1, "cx-modal-container", 3, "esc", "cxFocus"], ["id", "downloadInvoicesContent", 1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], ["id", "downloadInvoicesTitle", "aria-labelledby", "downloadInvoicesTitle", "tabindex", "-1", 1, "cx-dialog-title", "modal-title"], ["type", "button", "aria-controls", "downloadInvoicesContent", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [1, "cx-dialog-body", "modal-body"], ["id", "noInvoice", "role", "alert", 4, "ngIf"], ["class", "cx-spinner", "aria-live", "polite", "role", "alert", 4, "ngIf"], ["id", "noInvoice", "role", "alert"], ["aria-live", "polite", "role", "alert", 1, "cx-spinner"]],
      template: function MyAccountV2DownloadInvoicesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("esc", function MyAccountV2DownloadInvoicesComponent_Template_div_esc_0_listener() {
            return ctx.close("Escape clicked");
          });
          i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "button", 4);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵpipe(8, "cxTranslate");
          i0.ɵɵlistener("click", function MyAccountV2DownloadInvoicesComponent_Template_button_click_6_listener() {
            return ctx.close("Close download invoices dialog");
          });
          i0.ɵɵelementStart(9, "span", 5);
          i0.ɵɵelement(10, "cx-icon", 6);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(11, "div", 7);
          i0.ɵɵelement(12, "cx-invoices-list");
          i0.ɵɵtemplate(13, MyAccountV2DownloadInvoicesComponent_div_13_Template, 3, 3, "div", 8)(14, MyAccountV2DownloadInvoicesComponent_div_14_Template, 2, 0, "div", 9);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, "myAccountV2OrderDetails.downloadInvoices"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 9, "addToCart.closeModal"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 11, "addToCart.closeModal"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("type", ctx.iconTypes.CLOSE);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.invoiceCount === 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.invoiceCount === undefined);
        }
      },
      dependencies: [i2$1.NgIf, i3.FocusDirective, i3.IconComponent, i3.SpinnerComponent, i3$2.InvoicesListComponent, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2DownloadInvoicesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-download-invoices',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  class=\"cx-modal-container\"\n  role=\"dialog\"\n  aria-describedby=\"downloadInvoicesContent\"\n>\n  <div id=\"downloadInvoicesContent\" class=\"cx-modal-content\">\n    <div class=\"cx-dialog-header modal-header\">\n      <div\n        id=\"downloadInvoicesTitle\"\n        class=\"cx-dialog-title modal-title\"\n        aria-labelledby=\"downloadInvoicesTitle\"\n        tabindex=\"-1\"\n      >\n        {{ 'myAccountV2OrderDetails.downloadInvoices' | cxTranslate }}\n      </div>\n      <button\n        type=\"button\"\n        class=\"close\"\n        attr.aria-label=\"{{ 'addToCart.closeModal' | cxTranslate }}\"\n        aria-controls=\"downloadInvoicesContent\"\n        title=\"{{ 'addToCart.closeModal' | cxTranslate }}\"\n        (click)=\"close('Close download invoices dialog')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n\n    <div class=\"cx-dialog-body modal-body\">\n      <cx-invoices-list> </cx-invoices-list>\n      <div id=\"noInvoice\" *ngIf=\"invoiceCount === 0\" role=\"alert\">\n        {{ 'myAccountV2OrderDetails.noInvoices' | cxTranslate }}\n      </div>\n      <div\n        *ngIf=\"invoiceCount === undefined\"\n        class=\"cx-spinner\"\n        aria-live=\"polite\"\n        role=\"alert\"\n      >\n        <cx-spinner></cx-spinner>\n      </div>\n    </div>\n  </div>\n</div>\n"
    }]
  }], null, {
    invoiceComponent: [{
      type: ViewChild,
      args: [InvoicesListComponent, {
        static: false
      }]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultMyAccountV2DownloadInvoicesLayoutConfig = {
  launch: {
    DOWNLOAD_ORDER_INVOICES: {
      inlineRoot: true,
      component: MyAccountV2DownloadInvoicesComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2DownloadInvoicesEventListener {
  constructor() {
    this.subscription = new Subscription();
    this.eventService = inject(EventService);
    this.launchDialogService = inject(LaunchDialogService);
    this.onDownloadInvoices();
  }
  onDownloadInvoices() {
    this.subscription.add(this.eventService.get(DownloadOrderInvoicesEvent).subscribe(event => {
      this.openDialog(event);
    }));
  }
  openDialog(event) {
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.DOWNLOAD_ORDER_INVOICES, undefined, undefined, event.order);
    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function MyAccountV2DownloadInvoicesEventListener_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2DownloadInvoicesEventListener)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MyAccountV2DownloadInvoicesEventListener,
      factory: MyAccountV2DownloadInvoicesEventListener.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2DownloadInvoicesEventListener, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2DownloadInvoicesModule {
  constructor() {
    this.downloadInvoicesDialogEventListener = inject(MyAccountV2DownloadInvoicesEventListener);
  }
  static {
    this.ɵfac = function MyAccountV2DownloadInvoicesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2DownloadInvoicesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MyAccountV2DownloadInvoicesModule,
      declarations: [MyAccountV2DownloadInvoicesComponent],
      imports: [CommonModule, KeyboardFocusModule, IconModule, I18nModule, PaginationModule, SortingModule, SpinnerModule, PDFInvoicesComponentsModule],
      exports: [MyAccountV2DownloadInvoicesComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultMyAccountV2DownloadInvoicesLayoutConfig)],
      imports: [CommonModule, KeyboardFocusModule, IconModule, I18nModule, PaginationModule, SortingModule, SpinnerModule, PDFInvoicesComponentsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2DownloadInvoicesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, KeyboardFocusModule, IconModule, I18nModule, PaginationModule, SortingModule, SpinnerModule, PDFInvoicesComponentsModule],
      providers: [provideDefaultConfig(defaultMyAccountV2DownloadInvoicesLayoutConfig)],
      exports: [MyAccountV2DownloadInvoicesComponent],
      declarations: [MyAccountV2DownloadInvoicesComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const completedValues = ['DELIVERY_COMPLETED', 'PICKUP_COMPLETE'];
const cancelledValues = ['CANCELLED'];

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2OrderConsignmentsService {
  getGroupedConsignments(order, pickup) {
    const consignments = pickup ? order.consignments?.filter(consignment => consignment.deliveryPointOfService !== undefined) : order.consignments?.filter(consignment => consignment.deliveryPointOfService === undefined);
    return this.groupConsignments(consignments);
  }
  getUnconsignedEntries(order, pickup) {
    if (order.replenishmentOrderCode) {
      return [];
    }
    return pickup ? order.unconsignedEntries?.filter(entry => entry.deliveryPointOfService !== undefined) : order.unconsignedEntries?.filter(entry => entry.deliveryPointOfService === undefined);
  }
  groupConsignments(consignments) {
    const grouped = consignments?.reduce((result, current) => {
      const key = this.getStatusGroupKey(current.status || '');
      result[key] = result[key] || [];
      result[key].push(current);
      return result;
    }, {});
    return grouped ? [...(grouped[1] || []), ...(grouped[0] || []), ...(grouped[-1] || [])] : undefined;
  }
  /**
   * complete: 0
   * processing: 1
   * cancel: -1
   */
  getStatusGroupKey(status) {
    if (completedValues.includes(status)) {
      return 0;
    }
    if (cancelledValues.includes(status)) {
      return -1;
    }
    return 1;
  }
  static {
    this.ɵfac = function MyAccountV2OrderConsignmentsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2OrderConsignmentsService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MyAccountV2OrderConsignmentsService,
      factory: MyAccountV2OrderConsignmentsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2OrderConsignmentsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ConsignmentTrackingComponent {
  constructor(orderHistoryFacade, launchDialogService, vcr) {
    this.orderHistoryFacade = orderHistoryFacade;
    this.launchDialogService = launchDialogService;
    this.vcr = vcr;
    this.consignmentStatus = ['SHIPPED', 'IN_TRANSIT', 'DELIVERY_COMPLETED', 'DELIVERY_REJECTED', 'DELIVERING'];
  }
  ngOnInit() {
    this.consignmentTracking$ = this.orderHistoryFacade.getConsignmentTracking();
  }
  openTrackingDialog(consignment) {
    if (consignment.code) {
      this.orderHistoryFacade.loadConsignmentTracking(this.orderCode, consignment.code);
    }
    const modalInstanceData = {
      tracking$: this.consignmentTracking$,
      shipDate: consignment.statusDate
    };
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.CONSIGNMENT_TRACKING, this.element, this.vcr, modalInstanceData);
    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }
  ngOnDestroy() {
    this.orderHistoryFacade.clearConsignmentTracking();
  }
  static {
    this.ɵfac = function ConsignmentTrackingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConsignmentTrackingComponent)(i0.ɵɵdirectiveInject(i1.OrderHistoryFacade), i0.ɵɵdirectiveInject(i3.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ConsignmentTrackingComponent,
      selectors: [["cx-consignment-tracking"]],
      viewQuery: function ConsignmentTrackingComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c20, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      inputs: {
        consignment: "consignment",
        orderCode: "orderCode"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], ["type", "button", 1, "btn", "btn-secondary", "btn-track", 3, "click"]],
      template: function ConsignmentTrackingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ConsignmentTrackingComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.consignment && ctx.consignment.status);
        }
      },
      dependencies: [i2$1.NgIf, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsignmentTrackingComponent, [{
    type: Component,
    args: [{
      selector: 'cx-consignment-tracking',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"consignment && consignment.status\">\n  <div *ngIf=\"consignmentStatus.includes(consignment.status)\">\n    <button\n      (click)=\"openTrackingDialog(consignment)\"\n      class=\"btn btn-secondary btn-track\"\n      type=\"button\"\n    >\n      {{ 'orderDetails.consignmentTracking.action' | cxTranslate }}\n    </button>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.OrderHistoryFacade
  }, {
    type: i3.LaunchDialogService
  }, {
    type: i0.ViewContainerRef
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }],
    consignment: [{
      type: Input
    }],
    orderCode: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderConsignedEntriesComponent {
  constructor() {
    this.promotionLocation = PromotionLocation.Order;
    this.OrderOutlets = OrderOutlets;
    this.CartOutlets = CartOutlets;
    this.abstractOrderType = AbstractOrderType;
  }
  static {
    this.ɵfac = function OrderConsignedEntriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderConsignedEntriesComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderConsignedEntriesComponent,
      selectors: [["cx-order-consigned-entries"]],
      inputs: {
        consignments: "consignments",
        order: "order",
        enableAddToCart: "enableAddToCart",
        buyItAgainTranslation: "buyItAgainTranslation"
      },
      standalone: false,
      decls: 3,
      vars: 1,
      consts: [["addToCartBtn", ""], ["class", "cx-list row", 4, "ngFor", "ngForOf"], [1, "cx-list", "row"], [3, "cxOutlet", "cxOutletContext"], [1, "cx-list-item", "col-12"], [3, "cxAbstractOrderContext", "cxOutlet", "cxOutletContext"], [1, "cx-list-header", "col-12"], [1, "cx-list-status"], [4, "ngIf"], ["class", "cx-list-date", 4, "ngIf"], [3, "orderCode", "consignment", 4, "cxFeature"], [1, "cx-list-date"], [3, "orderCode", "consignment"], [1, "add-to-cart", 3, "productCode", "product", "showQuantity", "options", "pickupStore"]],
      template: function OrderConsignedEntriesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderConsignedEntriesComponent_div_0_Template, 4, 19, "div", 1)(1, OrderConsignedEntriesComponent_ng_template_1_Template, 1, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.consignments);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i2.FeatureDirective, i3.OutletDirective, i4.AddToCartComponent, i5.AbstractOrderContextDirective, ConsignmentTrackingComponent, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderConsignedEntriesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-consigned-entries',
      standalone: false,
      template: "<div *ngFor=\"let consignment of consignments\" class=\"cx-list row\">\n  <ng-template\n    [cxOutlet]=\"OrderOutlets.ORDER_CONSIGNMENT\"\n    [cxOutletContext]=\"{ item: consignment, order: order }\"\n  >\n    <div class=\"cx-list-header col-12\">\n      <div class=\"cx-list-status\">\n        <span *ngIf=\"consignment\">\n          {{\n            'orderDetails.deliveryStatus_' + consignment?.status | cxTranslate\n          }}\n        </span>\n      </div>\n      <div *ngIf=\"consignment?.statusDate\" class=\"cx-list-date\">\n        <div>{{ consignment?.statusDate | cxDate }}</div>\n      </div>\n\n      <cx-consignment-tracking\n        [orderCode]=\"order.code\"\n        [consignment]=\"consignment\"\n        *cxFeature=\"'consignmentTracking'\"\n      >\n      </cx-consignment-tracking>\n    </div>\n  </ng-template>\n  <div class=\"cx-list-item col-12\">\n    <ng-template\n      [cxAbstractOrderContext]=\"{\n        id: order.code,\n        type: abstractOrderType.ORDER,\n      }\"\n      [cxOutlet]=\"CartOutlets.CART_ITEM_LIST\"\n      [cxOutletContext]=\"{\n        items: consignment.entries,\n        readonly: true,\n        promotionLocation: promotionLocation,\n        options: {\n          displayAddToCart: enableAddToCart,\n          addToCartString: buyItAgainTranslation,\n          optionalBtn: addToCartBtn,\n        },\n      }\"\n    >\n    </ng-template>\n  </div>\n</div>\n\n<ng-template let-ctx #addToCartBtn>\n  <cx-add-to-cart\n    [productCode]=\"ctx.item.product?.code\"\n    [product]=\"ctx.item.product\"\n    [showQuantity]=\"false\"\n    [options]=\"ctx.options\"\n    [pickupStore]=\"ctx.item.deliveryPointOfService?.name\"\n    class=\"add-to-cart\"\n  >\n  </cx-add-to-cart>\n</ng-template>\n"
    }]
  }], null, {
    consignments: [{
      type: Input
    }],
    order: [{
      type: Input
    }],
    enableAddToCart: [{
      type: Input
    }],
    buyItAgainTranslation: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderDetailItemsComponent {
  constructor(orderDetailsService, component) {
    this.orderDetailsService = orderDetailsService;
    this.component = component;
    this.orderConsignmentsService = inject(MyAccountV2OrderConsignmentsService);
    this.OrderOutlets = OrderOutlets;
    this.CartOutlets = CartOutlets;
    this.abstractOrderType = AbstractOrderType;
    this.promotionLocation = PromotionLocation.Order;
    this.order$ = this.orderDetailsService.getOrderDetails().pipe(tap(order => {
      this.pickupConsignments = this.getGroupedConsignments(order, true);
      this.deliveryConsignments = this.getGroupedConsignments(order, false);
      this.pickupUnconsignedEntries = this.getUnconsignedEntries(order, true);
      this.deliveryUnConsignedEntries = this.getUnconsignedEntries(order, false);
    }));
    this.enableAddToCart$ = this.component.data$.pipe(map(data => data.enableAddToCart));
    this.isOrderLoading$ = typeof this.orderDetailsService.isOrderDetailsLoading === 'function' ? this.orderDetailsService.isOrderDetailsLoading() : of(false);
    this.groupCartItems$ = this.component.data$.pipe(map(data => data.groupCartItems));
  }
  getGroupedConsignments(order, pickup) {
    return this.orderConsignmentsService.getGroupedConsignments(order, pickup);
  }
  getUnconsignedEntries(order, pickup) {
    return this.orderConsignmentsService.getUnconsignedEntries(order, pickup);
  }
  static {
    this.ɵfac = function OrderDetailItemsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderDetailItemsComponent)(i0.ɵɵdirectiveInject(OrderDetailsService), i0.ɵɵdirectiveInject(i3.CmsComponentData));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderDetailItemsComponent,
      selectors: [["cx-order-details-items"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["addToCartBtn", ""], [4, "ngIf"], ["class", "cx-pickup-order-consigned-entries-header", 4, "ngIf"], [3, "order", "consignments", "enableAddToCart", "buyItAgainTranslation", 4, "ngIf"], [3, "promotions"], [1, "cx-pickup-order-consigned-entries-header"], [3, "order", "consignments", "enableAddToCart", "buyItAgainTranslation"], [3, "cxOutlet", "cxOutletContext"], ["class", "cx-list-header", 4, "ngIf"], [1, "cx-list-header"], [1, "cx-list-status"], ["class", "cx-review-header", 4, "ngIf"], [1, "cx-list-item"], [3, "cxAbstractOrderContext", "cxOutlet", "cxOutletContext"], [1, "cx-review-header"], [1, "cx-list"], [1, "add-to-cart", 3, "productCode", "product", "showQuantity", "options", "pickupStore"]],
      template: function OrderDetailItemsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderDetailItemsComponent_ng_container_0_Template, 5, 3, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i2$1.NgIf, i3.PromotionsComponent, i3.OutletDirective, i4.AddToCartComponent, i5.AbstractOrderContextDirective, OrderConsignedEntriesComponent, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderDetailItemsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-details-items',
      standalone: false,
      template: "<ng-container *ngIf=\"order$ | async as order\">\n  <ng-container *ngIf=\"!(isOrderLoading$ | async)\">\n    <ng-container\n      *ngIf=\"\n        order.consignments?.length ||\n        order.unconsignedEntries?.length ||\n        order.replenishmentOrderCode\n      \"\n    >\n      <cx-promotions\n        [promotions]=\"order.appliedOrderPromotions || []\"\n      ></cx-promotions>\n    </ng-container>\n\n    <!-- pickup consigned entries -->\n    <div\n      *ngIf=\"pickupConsignments?.length\"\n      class=\"cx-pickup-order-consigned-entries-header\"\n    >\n      {{ 'deliveryPointOfServiceDetails.itemsToBePickUp' | cxTranslate }}\n    </div>\n    <cx-order-consigned-entries\n      *ngIf=\"pickupConsignments\"\n      [order]=\"order\"\n      [consignments]=\"pickupConsignments\"\n      [enableAddToCart]=\"enableAddToCart$ | async\"\n      [buyItAgainTranslation]=\"'addToCart.buyItAgain' | cxTranslate\"\n    ></cx-order-consigned-entries>\n\n    <!-- delivery consignment address and delivery mode -->\n    <ng-template\n      *ngIf=\"\n        deliveryConsignments &&\n        deliveryConsignments.length > 0 &&\n        (groupCartItems$ | async)\n      \"\n      [cxOutlet]=\"OrderOutlets.CONSIGNMENT_DELIVERY_INFO\"\n      [cxOutletContext]=\"{\n        showItemList: false,\n        order: order,\n      }\"\n    >\n    </ng-template>\n\n    <!-- delivery consigned entries -->\n    <cx-order-consigned-entries\n      *ngIf=\"deliveryConsignments\"\n      [order]=\"order\"\n      [consignments]=\"deliveryConsignments\"\n      [enableAddToCart]=\"enableAddToCart$ | async\"\n      [buyItAgainTranslation]=\"'addToCart.buyItAgain' | cxTranslate\"\n    ></cx-order-consigned-entries>\n\n    <!-- unconsigned entries -->\n    <ng-container *ngIf=\"order?.unconsignedEntries?.length\">\n      <div *ngIf=\"order?.statusDisplay\" class=\"cx-list-header\">\n        <div class=\"cx-list-status\">\n          {{\n            'orderDetails.statusDisplay_' + order?.statusDisplay | cxTranslate\n          }}\n        </div>\n      </div>\n      <!-- delivery unconsigned entries -->\n      <ng-container *ngIf=\"deliveryUnConsignedEntries?.length\">\n        <h2 *ngIf=\"groupCartItems$ | async\" class=\"cx-review-header\">\n          {{ 'checkoutMode.deliveryEntries' | cxTranslate }}\n        </h2>\n        <div class=\"cx-list-item\">\n          <ng-template\n            [cxAbstractOrderContext]=\"{\n              id: order.code,\n              type: abstractOrderType.ORDER,\n            }\"\n            [cxOutlet]=\"CartOutlets.CART_ITEM_LIST\"\n            [cxOutletContext]=\"{\n              items: deliveryUnConsignedEntries,\n              readonly: true,\n              promotionLocation: promotionLocation,\n              options: {\n                displayAddToCart: enableAddToCart$ | async,\n                addToCartString: 'addToCart.buyItAgain' | cxTranslate,\n                optionalBtn: addToCartBtn,\n              },\n            }\"\n          >\n          </ng-template>\n        </div>\n      </ng-container>\n      <!-- pickup unconsigned entries, b2b does not have pickup items -->\n      <ng-container *ngIf=\"pickupUnconsignedEntries?.length\">\n        <h2 class=\"cx-review-header\">\n          {{ 'checkoutPickupInStore.heading' | cxTranslate }}\n        </h2>\n        <div class=\"cx-list-item\">\n          <ng-template\n            [cxAbstractOrderContext]=\"{\n              id: order.code,\n              type: abstractOrderType.ORDER,\n            }\"\n            [cxOutlet]=\"CartOutlets.CART_ITEM_LIST\"\n            [cxOutletContext]=\"{\n              items: pickupUnconsignedEntries,\n              readonly: true,\n              promotionLocation: promotionLocation,\n              options: {\n                displayAddToCart: enableAddToCart$ | async,\n                addToCartString: 'addToCart.buyItAgain' | cxTranslate,\n                optionalBtn: addToCartBtn,\n              },\n            }\"\n          >\n          </ng-template>\n        </div>\n      </ng-container>\n    </ng-container>\n\n    <!-- replenishment other entries -->\n    <ng-container *ngIf=\"order?.entries && order?.replenishmentOrderCode\">\n      <div class=\"cx-list\">\n        <div *ngIf=\"order?.statusDisplay\" class=\"cx-list-header\">\n          <div class=\"cx-list-status\">\n            {{\n              'orderDetails.statusDisplay_' + order?.statusDisplay | cxTranslate\n            }}\n          </div>\n        </div>\n        <div class=\"cx-list-item\">\n          <ng-template\n            [cxAbstractOrderContext]=\"{\n              id: order.code,\n              type: abstractOrderType.ORDER,\n            }\"\n            [cxOutlet]=\"CartOutlets.CART_ITEM_LIST\"\n            [cxOutletContext]=\"{\n              items: order.entries,\n              readonly: true,\n              promotionLocation: promotionLocation,\n              options: {\n                displayAddToCart: enableAddToCart$ | async,\n                addToCartString: 'addToCart.buyItAgain' | cxTranslate,\n                optionalBtn: addToCartBtn,\n              },\n            }\"\n          >\n          </ng-template>\n        </div>\n      </div>\n    </ng-container>\n  </ng-container>\n\n  <ng-template let-ctx #addToCartBtn>\n    <cx-add-to-cart\n      [productCode]=\"ctx.item.product?.code\"\n      [product]=\"ctx.item.product\"\n      [showQuantity]=\"false\"\n      [options]=\"ctx.options\"\n      [pickupStore]=\"ctx.item.deliveryPointOfService?.name\"\n      class=\"add-to-cart\"\n    >\n    </cx-add-to-cart>\n  </ng-template>\n</ng-container>\n"
    }]
  }], () => [{
    type: OrderDetailsService
  }, {
    type: i3.CmsComponentData
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TrackingEventsComponent {
  handleClick(event) {
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }
  constructor(orderHistoryFacade, launchDialogService, el) {
    this.orderHistoryFacade = orderHistoryFacade;
    this.launchDialogService = launchDialogService;
    this.el = el;
    this.subscription = new Subscription();
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
  }
  ngOnInit() {
    this.subscription.add(this.launchDialogService.data$.subscribe(data => {
      if (data) {
        this.init(data.tracking$, data.shipDate);
      }
    }));
  }
  ngOnDestroy() {
    this.orderHistoryFacade.clearConsignmentTracking();
    this.subscription?.unsubscribe();
  }
  init(tracking$, shipDate) {
    this.tracking$ = tracking$;
    this.shipDate = shipDate;
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  static {
    this.ɵfac = function TrackingEventsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TrackingEventsComponent)(i0.ɵɵdirectiveInject(i1.OrderHistoryFacade), i0.ɵɵdirectiveInject(i3.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TrackingEventsComponent,
      selectors: [["cx-tracking-events"]],
      hostBindings: function TrackingEventsComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function TrackingEventsComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 8,
      vars: 5,
      consts: [["noTracking", ""], ["loading", ""], [1, "modal-dialog", "modal-dialog-centered", "modal-lg", "cx-consignment-tracking-dialog", 3, "esc", "cxFocus"], [1, "modal-content", "cx-consignment-tracking-container"], [4, "ngIf", "ngIfElse"], [1, "modal-header", "cx-modal-header"], [1, "modal-title", "cx-consignment-tracking-title"], ["type", "button", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "cx-tracking-events", "modal-body"], [4, "ngFor", "ngForOf"], [1, "cx-shipment-heading"], [1, "row"], [1, "col-sm-12", "col-md-6"], [1, "cx-shipment-title"], [1, "cx-shipment-content"], [4, "ngIf"], ["target", "_blank", "rel", "noopener noreferrer", 3, "href"], [1, "cx-tracking-event-body"], [1, "cx-tracking-event-content"], [1, "cx-tracking-event-title"], [1, "cx-tracking-event-city"], [1, "cx-no-tracking-heading"], [1, "cx-tracking-loading"], [1, "header", "modal-header"], [1, "title", "modal-title"], ["type", "button", 1, "close", "btn-dismiss", 3, "click"], [1, "body", "modal-body"], [1, "col-sm-12"]],
      template: function TrackingEventsComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵlistener("esc", function TrackingEventsComponent_Template_div_esc_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.close("Escape clicked"));
          });
          i0.ɵɵelementStart(1, "div", 3);
          i0.ɵɵtemplate(2, TrackingEventsComponent_ng_container_2_Template, 12, 9, "ng-container", 4);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵtemplate(4, TrackingEventsComponent_ng_template_4_Template, 4, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(6, TrackingEventsComponent_ng_template_6_Template, 13, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          const loading_r8 = i0.ɵɵreference(7);
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 3, ctx.tracking$))("ngIfElse", loading_r8);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.SpinnerComponent, i3.FocusDirective, i2$1.AsyncPipe, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrackingEventsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-tracking-events',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  class=\"modal-dialog modal-dialog-centered modal-lg cx-consignment-tracking-dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n>\n  <div class=\"modal-content cx-consignment-tracking-container\">\n    <ng-container\n      *ngIf=\"tracking$ | async as consignmentTracking; else loading\"\n    >\n      <!-- Modal Header -->\n      <div class=\"modal-header cx-modal-header\">\n        <div class=\"modal-title cx-consignment-tracking-title\">\n          {{ 'orderDetails.consignmentTracking.dialog.header' | cxTranslate }}\n        </div>\n        <button\n          type=\"button\"\n          class=\"close\"\n          [attr.aria-label]=\"'common.close' | cxTranslate\"\n          (click)=\"close('Cross click')\"\n        >\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <!-- Modal Body -->\n      <!-- shipment header -->\n      <ng-container\n        *ngIf=\"\n          consignmentTracking?.carrierDetails &&\n            consignmentTracking?.trackingID;\n          else noTracking\n        \"\n      >\n        <div class=\"cx-shipment-heading\">\n          <div class=\"row\">\n            <div class=\"col-sm-12 col-md-6\">\n              <div class=\"cx-shipment-title\">\n                {{\n                  'orderDetails.consignmentTracking.dialog.shipped'\n                    | cxTranslate\n                }}\n              </div>\n              <div class=\"cx-shipment-content\">\n                {{ shipDate | cxDate: 'medium' }}\n              </div>\n            </div>\n            <div class=\"col-sm-12 col-md-6\">\n              <div class=\"cx-shipment-title\">\n                {{\n                  'orderDetails.consignmentTracking.dialog.estimate'\n                    | cxTranslate\n                }}\n              </div>\n              <div class=\"cx-shipment-content\">\n                {{ consignmentTracking?.targetArrivalDate | cxDate: 'medium' }}\n              </div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"col-sm-12 col-md-6\">\n              <div class=\"cx-shipment-title\">\n                {{\n                  'orderDetails.consignmentTracking.dialog.carrier'\n                    | cxTranslate\n                }}\n              </div>\n              <div class=\"cx-shipment-content\">\n                {{ consignmentTracking?.carrierDetails?.name }}\n              </div>\n            </div>\n            <div class=\"col-sm-12 col-md-6\">\n              <div class=\"cx-shipment-title\">\n                {{\n                  'orderDetails.consignmentTracking.dialog.trackingId'\n                    | cxTranslate\n                }}\n              </div>\n              <div class=\"cx-shipment-content\">\n                <ng-container *ngIf=\"consignmentTracking?.trackingUrl\">\n                  <a\n                    target=\"_blank\"\n                    rel=\"noopener noreferrer\"\n                    [href]=\"consignmentTracking.trackingUrl\"\n                    >{{ consignmentTracking?.trackingID }}</a\n                  >\n                </ng-container>\n                <ng-container *ngIf=\"!consignmentTracking?.trackingUrl\">\n                  <label>\n                    {{ consignmentTracking?.trackingID }}\n                  </label>\n                </ng-container>\n              </div>\n            </div>\n          </div>\n        </div>\n      </ng-container>\n\n      <!-- tracking events -->\n      <div class=\"cx-tracking-events modal-body\">\n        <ng-container\n          *ngFor=\"let consignmentEvent of consignmentTracking.trackingEvents\"\n        >\n          <div class=\"cx-tracking-event-body\">\n            <div class=\"cx-tracking-event-content\">\n              {{ consignmentEvent.eventDate | cxDate: 'medium' }}\n            </div>\n            <div class=\"cx-tracking-event-title\">\n              {{ consignmentEvent.referenceCode }}\n            </div>\n            <div class=\"cx-tracking-event-content\">\n              {{ consignmentEvent.detail }}\n            </div>\n            <div class=\"cx-tracking-event-city\">\n              location: {{ consignmentEvent.location }}\n            </div>\n          </div>\n        </ng-container>\n      </div>\n    </ng-container>\n\n    <ng-template #noTracking>\n      <div class=\"cx-no-tracking-heading\">\n        <div class=\"cx-shipment-content\">\n          {{\n            'orderDetails.consignmentTracking.dialog.noTracking' | cxTranslate\n          }}\n        </div>\n      </div>\n    </ng-template>\n\n    <ng-template #loading>\n      <div class=\"cx-tracking-loading\">\n        <div class=\"header modal-header\">\n          <div class=\"title modal-title\">\n            {{\n              'orderDetails.consignmentTracking.dialog.loadingHeader'\n                | cxTranslate\n            }}\n          </div>\n          <button\n            type=\"button\"\n            class=\"close btn-dismiss\"\n            [attr.aria-label]=\"'common.close' | cxTranslate\"\n            (click)=\"close('Cross click')\"\n          >\n            <span aria-hidden=\"true\">&times;</span>\n          </button>\n        </div>\n        <!-- Modal Body -->\n        <div class=\"body modal-body\">\n          <div class=\"row\">\n            <div class=\"col-sm-12\">\n              <cx-spinner></cx-spinner>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-template>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.OrderHistoryFacade
  }, {
    type: i3.LaunchDialogService
  }, {
    type: i0.ElementRef
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2ConsignmentTrackingComponent extends ConsignmentTrackingComponent {
  constructor() {
    super(...arguments);
    this.componentClass = 'cx-list-header col-12';
    this.outlet = inject(OutletContextData);
  }
  ngOnInit() {
    this.outlet?.context$.subscribe(context => {
      this.consignment = context.item;
    });
    this.outlet?.context$.subscribe(context => {
      this.orderCode = context?.order?.code ?? '';
    });
    super.ngOnInit();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMyAccountV2ConsignmentTrackingComponent_BaseFactory;
      return function MyAccountV2ConsignmentTrackingComponent_Factory(__ngFactoryType__) {
        return (ɵMyAccountV2ConsignmentTrackingComponent_BaseFactory || (ɵMyAccountV2ConsignmentTrackingComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MyAccountV2ConsignmentTrackingComponent)))(__ngFactoryType__ || MyAccountV2ConsignmentTrackingComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2ConsignmentTrackingComponent,
      selectors: [["cx-my-account-v2-consignment-tracking"]],
      hostVars: 1,
      hostBindings: function MyAccountV2ConsignmentTrackingComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("className", ctx.componentClass);
        }
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["showNoTrackingMessage", ""], ["class", "cx-list-status", 4, "ngIf"], [1, "cx-list-status"], [4, "ngIf"], ["class", "cx-item-list-tracking-id", 4, "ngIf"], ["class", "cx-consignment-status-date", 4, "ngIf"], [1, "cx-item-list-tracking-id"], [4, "ngIf", "ngIfElse"], [1, "cx-tracking-id-link", 3, "click"], [1, "cx-consignment-status-date"]],
      template: function MyAccountV2ConsignmentTrackingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2ConsignmentTrackingComponent_div_0_Template, 7, 3, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.consignment);
        }
      },
      dependencies: [i2$1.NgIf, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2ConsignmentTrackingComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-consignment-tracking',
      standalone: false,
      template: "<div *ngIf=\"consignment\" class=\"cx-list-status\">\n  <span>\n    <span *ngIf=\"consignment.status\">\n      {{ 'orderDetails.deliveryStatus_' + consignment.status | cxTranslate }}\n    </span>\n    <span\n      *ngIf=\"consignmentStatus.includes(consignment.status ?? '')\"\n      class=\"cx-item-list-tracking-id\"\n    >\n      <span *ngIf=\"consignment.trackingID; else showNoTrackingMessage\">\n        {{\n          'orderDetails.consignmentTracking.dialog.trackingId' | cxTranslate\n        }}:\n        <a\n          class=\"cx-tracking-id-link\"\n          (click)=\"openTrackingDialog(consignment)\"\n        >\n          {{ consignment.trackingID }}\n        </a>\n      </span>\n    </span>\n  </span>\n  <span *ngIf=\"consignment?.statusDate\" class=\"cx-consignment-status-date\">\n    {{ consignment.statusDate | cxDate }}\n  </span>\n  <ng-template #showNoTrackingMessage>\n    <a class=\"cx-tracking-id-link\" (click)=\"openTrackingDialog(consignment)\">\n      {{ 'orderDetails.consignmentTracking.action' | cxTranslate }}\n    </a>\n  </ng-template>\n</div>\n"
    }]
  }], null, {
    componentClass: [{
      type: HostBinding,
      args: ['className']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultConsignmentTrackingLayoutConfig = {
  launch: {
    CONSIGNMENT_TRACKING: {
      inlineRoot: true,
      component: TrackingEventsComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderDetailReorderComponent {
  constructor(orderDetailsService, launchDialogService, vcr) {
    this.orderDetailsService = orderDetailsService;
    this.launchDialogService = launchDialogService;
    this.vcr = vcr;
    this.subscription = new Subscription();
  }
  ngOnInit() {
    this.order$ = this.orderDetailsService.getOrderDetails();
  }
  onReorderClick(order) {
    this.launchDialog(order.code);
  }
  launchDialog(orderCode) {
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.REORDER, this.element, this.vcr, {
      orderCode
    });
    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function OrderDetailReorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderDetailReorderComponent)(i0.ɵɵdirectiveInject(OrderDetailsService), i0.ɵɵdirectiveInject(i3.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderDetailReorderComponent,
      selectors: [["cx-order-details-reorder"]],
      viewQuery: function OrderDetailReorderComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c20, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["element", ""], [4, "ngIf"], [1, "cx-nav", "row"], [1, "col-xs-12", "col-md-10", "col-lg-8"], [1, "btn", "btn-primary", 3, "click"]],
      template: function OrderDetailReorderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderDetailReorderComponent_ng_container_0_Template, 2, 1, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderDetailReorderComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-details-reorder',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"order$ | async as order\">\n  <ng-container *ngIf=\"order.code\">\n    <div class=\"cx-nav row\">\n      <div class=\"col-xs-12 col-md-10 col-lg-8\">\n        <button\n          #element\n          class=\"btn btn-primary\"\n          (click)=\"onReorderClick(order)\"\n        >\n          {{ 'reorder.button' | cxTranslate }}\n        </button>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: OrderDetailsService
  }, {
    type: i3.LaunchDialogService
  }, {
    type: i0.ViewContainerRef
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReorderDialogComponent {
  constructor(launchDialogService, reorderOrderFacade, multiCartFacade) {
    this.launchDialogService = launchDialogService;
    this.reorderOrderFacade = reorderOrderFacade;
    this.multiCartFacade = multiCartFacade;
    this.iconTypes = ICON_TYPE;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: true,
      focusOnEscape: true
    };
    this.loading$ = new BehaviorSubject(false);
    this.showDecisionPrompt$ = new BehaviorSubject(true);
    this.data$ = this.launchDialogService.data$;
    this.selectFocusUtility = inject(SelectFocusUtility);
    this.elementRef = inject(ElementRef, {
      optional: true
    });
  }
  createCartFromOrder(orderCode) {
    this.showDecisionPrompt$.next(false);
    this.loading$.next(true);
    this.reorderOrderFacade.reorder(orderCode).subscribe(cartModificationList => {
      this.multiCartFacade.reloadCart(OCC_CART_ID_CURRENT);
      this.cartModifications = cartModificationList.cartModifications;
      this.loading$.next(false);
      this.recaptureFocus();
    });
  }
  recaptureFocus() {
    this.selectFocusUtility?.findFirstFocusable(this.elementRef?.nativeElement)?.focus();
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  get cartValidationStatusCode() {
    return CartValidationStatusCode;
  }
  static {
    this.ɵfac = function ReorderDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReorderDialogComponent)(i0.ɵɵdirectiveInject(i3.LaunchDialogService), i0.ɵɵdirectiveInject(i1.ReorderOrderFacade), i0.ɵɵdirectiveInject(i3$3.MultiCartFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReorderDialogComponent,
      selectors: [["cx-reorder-dialog"]],
      standalone: false,
      decls: 15,
      vars: 14,
      consts: [["result", ""], ["loading", ""], ["cartResponse", ""], ["errorIcon", ""], ["role", "dialog", "aria-labelledby", "dialogTitle", "aria-modal", "true", 1, "cx-modal-container", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], ["id", "dialogTitle", 1, "cx-dialog-title", "modal-title"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [1, "cx-dialog-body", "modal-body"], [4, "ngIf"], [4, "ngIf", "ngIfElse"], [1, "cx-reorder-dialog-areyousure-section"], [1, "cx-reorder-dialog-footer"], [1, "row"], [1, "col-12"], [1, "btn", "btn-action", 3, "click"], [1, "btn", "btn-primary", 3, "click"], ["aria-live", "polite"], [1, "cx-cart-mod-entry-container"], [1, "alert-icon"], [1, "success", 3, "type"], ["class", "cx-cart-mod-entry-container", 4, "ngFor", "ngForOf"], [1, "warning", 3, "type"], [1, "error", 3, "type"], [1, "cx-spinner"]],
      template: function ReorderDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 4);
          i0.ɵɵlistener("esc", function ReorderDialogComponent_Template_div_esc_0_listener() {
            return ctx.close("Escape clicked");
          });
          i0.ɵɵelementStart(1, "div", 5);
          i0.ɵɵelementContainerStart(2);
          i0.ɵɵelementStart(3, "div", 6)(4, "div", 7);
          i0.ɵɵtext(5);
          i0.ɵɵpipe(6, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "button", 8);
          i0.ɵɵpipe(8, "cxTranslate");
          i0.ɵɵpipe(9, "cxTranslate");
          i0.ɵɵlistener("click", function ReorderDialogComponent_Template_button_click_7_listener() {
            return ctx.close("Close reorder result dialog");
          });
          i0.ɵɵelementStart(10, "span", 9);
          i0.ɵɵelement(11, "cx-icon", 10);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementStart(12, "div", 11);
          i0.ɵɵtemplate(13, ReorderDialogComponent_ng_container_13_Template, 5, 4, "ng-container", 12);
          i0.ɵɵpipe(14, "async");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, "reorder.dialog.reorderProducts"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(8, 8, "addToCart.closeModal"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 10, "addToCart.closeModal"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("type", ctx.iconTypes.CLOSE);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(14, 12, ctx.data$));
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.SpinnerComponent, i3.FocusDirective, i3.IconComponent, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReorderDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-reorder-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  class=\"cx-modal-container\"\n  role=\"dialog\"\n  aria-labelledby=\"dialogTitle\"\n  aria-modal=\"true\"\n>\n  <div class=\"cx-modal-content\">\n    <ng-container>\n      <div class=\"cx-dialog-header modal-header\">\n        <div id=\"dialogTitle\" class=\"cx-dialog-title modal-title\">\n          {{ 'reorder.dialog.reorderProducts' | cxTranslate }}\n        </div>\n        <button\n          type=\"button\"\n          class=\"close\"\n          attr.aria-label=\"{{ 'addToCart.closeModal' | cxTranslate }}\"\n          title=\"{{ 'addToCart.closeModal' | cxTranslate }}\"\n          (click)=\"close('Close reorder result dialog')\"\n        >\n          <span aria-hidden=\"true\">\n            <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n          </span>\n        </button>\n      </div>\n    </ng-container>\n\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <ng-container *ngIf=\"data$ | async as data\">\n        <ng-container *ngIf=\"showDecisionPrompt$ | async; else result\">\n          <div class=\"cx-reorder-dialog-areyousure-section\">\n            <p>\n              {{ 'reorder.dialog.areYouSureToReplaceCart' | cxTranslate }}\n            </p>\n            <div class=\"cx-reorder-dialog-footer\">\n              <div class=\"row\">\n                <div class=\"col-12\">\n                  <button\n                    class=\"btn btn-action\"\n                    (click)=\"close('Cancel creating cart from order')\"\n                  >\n                    {{ 'reorder.dialog.cancel' | cxTranslate }}\n                  </button>\n                  <button\n                    class=\"btn btn-primary\"\n                    (click)=\"createCartFromOrder(data.orderCode)\"\n                  >\n                    {{ 'reorder.dialog.continue' | cxTranslate }}\n                  </button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </ng-container>\n        <ng-template #result>\n          <ng-container *ngIf=\"!(loading$ | async); else loading\">\n            <p aria-live=\"polite\">\n              <ng-container\n                *ngIf=\"!cartModifications?.length; else cartResponse\"\n              >\n                <span class=\"cx-cart-mod-entry-container\">\n                  <span class=\"alert-icon\">\n                    <cx-icon\n                      class=\"success\"\n                      [type]=\"iconTypes.SUCCESS\"\n                    ></cx-icon>\n                  </span>\n                  {{ 'reorder.dialog.messages.success' | cxTranslate }}\n                </span>\n              </ng-container>\n              <ng-template #cartResponse>\n                <span\n                  *ngFor=\"let cartModification of cartModifications\"\n                  class=\"cx-cart-mod-entry-container\"\n                >\n                  <ng-container\n                    *ngIf=\"\n                      cartModification.statusCode ===\n                        cartValidationStatusCode.LOW_STOCK;\n                      else errorIcon\n                    \"\n                  >\n                    <span class=\"alert-icon\">\n                      <cx-icon\n                        class=\"warning\"\n                        [type]=\"iconTypes.INFO\"\n                      ></cx-icon>\n                    </span>\n                  </ng-container>\n                  <ng-template #errorIcon>\n                    <span class=\"alert-icon\">\n                      <cx-icon class=\"error\" [type]=\"iconTypes.ERROR\"></cx-icon>\n                    </span>\n                  </ng-template>\n                  <span>\n                    {{\n                      'reorder.dialog.messages.' + cartModification.statusCode\n                        | cxTranslate\n                          : {\n                              quantity: cartModification.quantity,\n                              quantityAdded: cartModification.quantityAdded,\n                              productCode: cartModification.entry.product.code,\n                              productName: cartModification.entry.product.name,\n                            }\n                    }}\n                  </span>\n                </span>\n              </ng-template>\n            </p>\n          </ng-container>\n          <ng-template #loading>\n            <div class=\"cx-spinner\">\n              <cx-spinner></cx-spinner>\n            </div>\n          </ng-template>\n        </ng-template>\n      </ng-container>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i3.LaunchDialogService
  }, {
    type: i1.ReorderOrderFacade
  }, {
    type: i3$3.MultiCartFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderDetailTotalsComponent {
  constructor(orderDetailsService) {
    this.orderDetailsService = orderDetailsService;
    this.CartOutlets = CartOutlets;
  }
  ngOnInit() {
    this.order$ = this.orderDetailsService.getOrderDetails();
  }
  static {
    this.ɵfac = function OrderDetailTotalsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderDetailTotalsComponent)(i0.ɵɵdirectiveInject(OrderDetailsService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderDetailTotalsComponent,
      selectors: [["cx-order-details-totals"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "row", "justify-content-end"], [1, "cx-summary", "col-sm-12", "col-md-6", "col-lg-5", "col-xl-4"], [3, "cxOutlet", "cxOutletContext"]],
      template: function OrderDetailTotalsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderDetailTotalsComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i2$1.NgIf, i3.OutletDirective, i2$1.AsyncPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderDetailTotalsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-details-totals',
      standalone: false,
      template: "<ng-container *ngIf=\"order$ | async as order\">\n  <div class=\"row justify-content-end\">\n    <div class=\"cx-summary col-sm-12 col-md-6 col-lg-5 col-xl-4\">\n      <ng-template\n        [cxOutlet]=\"CartOutlets.ORDER_SUMMARY\"\n        [cxOutletContext]=\"order\"\n      >\n      </ng-template>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: OrderDetailsService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultReorderLayoutConfig = {
  launch: {
    REORDER: {
      inline: true,
      component: ReorderDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderAttachmentsComponent {
  constructor() {
    this.orderDetailsService = inject(OrderDetailsService);
    this.launchDialogService = inject(LaunchDialogService);
    this.vcr = inject(ViewContainerRef);
    this.destroyRef = inject(DestroyRef);
    this.order$ = this.orderDetailsService.getOrderDetails();
  }
  onOrderAttachmentsClick(orderCode) {
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.ORDER_ATTACHMENTS, this.element, this.vcr, {
      orderCode
    });
    if (dialog) {
      dialog.pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe();
    }
  }
  static {
    this.ɵfac = function OrderAttachmentsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderAttachmentsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderAttachmentsComponent,
      selectors: [["cx-order-attachments"]],
      viewQuery: function OrderAttachmentsComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c20, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["element", ""], [4, "ngIf"], [1, "row", "justify-content-end"], [1, "col-sm-12", "col-md-6", "col-lg-5", "col-xl-4"], [1, "btn", "btn-secondary", "w-100", "order-attachments-dialog-btn", 3, "click"]],
      template: function OrderAttachmentsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderAttachmentsComponent_ng_container_0_Template, 2, 1, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.order$));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderAttachmentsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-attachments',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"order$ | async as order\">\n  <ng-container *ngIf=\"order.code\">\n    <div class=\"row justify-content-end\">\n      <div class=\"col-sm-12 col-md-6 col-lg-5 col-xl-4\">\n        <button\n          #element\n          class=\"btn btn-secondary w-100 order-attachments-dialog-btn\"\n          (click)=\"onOrderAttachmentsClick(order.code)\"\n        >\n          {{ 'attachments.button' | cxTranslate }}\n        </button>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n"
    }]
  }], null, {
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderAttachmentsDialogComponent {
  constructor() {
    this.config = inject(OrderConfig);
    this.launchDialogService = inject(LaunchDialogService);
    this.orderAttachmentsFacade = inject(OrderAttachmentsFacade);
    this.translation = inject(TranslationService);
    this.cd = inject(ChangeDetectorRef);
    this.destroyRef = inject(DestroyRef);
    this.globalMessageType = GlobalMessageType;
    this.iconTypes = ICON_TYPE;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: true,
      focusOnEscape: true
    };
    this.orderCode$ = this.launchDialogService.data$.pipe(map(data => data.orderCode));
    this.attachments$ = this.orderCode$.pipe(switchMap(orderId => this.orderAttachmentsFacade.getOrderAttachments(orderId)), map(attachments => attachments.sapAttachments ?? []), catchError(() => {
      this.loadError.set(true);
      return of([]);
    }), share());
    this.loadError = signal(false);
    this.attachmentsCount = toSignal(this.attachments$.pipe(map(attachments => attachments.length)), {
      initialValue: 0
    });
    this.loadingAttachments = [];
    this.erroredAttachments = [];
    this.errorCounter = 0;
  }
  openOrderAttachment(attachmentId, fileName) {
    this.orderCode$.pipe(filter(() => !this.loadingAttachments.includes(attachmentId)), tap(() => this.setAttachmentLoadingState(attachmentId, true)), switchMap(orderId => this.orderAttachmentsFacade.downloadOrderAttachment(orderId, attachmentId)), tap(blob => {
      if (blob.type && this.config.orderAttachments?.previewMimeTypes.includes(blob.type.split(';')[0])) {
        this.previewFile(blob);
        return;
      }
      this.downloadFile(blob, fileName);
    }), tap(() => this.setAttachmentLoadingState(attachmentId, false)), catchError(() => {
      this.setAttachmentLoadingState(attachmentId, false);
      this.addErrorMessage(attachmentId);
      return EMPTY;
    }), takeUntilDestroyed(this.destroyRef)).subscribe();
  }
  previewFile(blob) {
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank', 'noopener,noreferrer');
  }
  downloadFile(blob, fileName) {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  onMouseDown(event, attachmentId, fileName) {
    const leftMouseButton = 0;
    const middleMouseButton = 1;
    if (event.button === leftMouseButton || event.button === middleMouseButton) {
      this.openOrderAttachment(attachmentId, fileName);
    }
  }
  setAttachmentLoadingState(attachmentId, state) {
    if (state) {
      this.loadingAttachments.push(attachmentId);
    } else {
      this.loadingAttachments = this.loadingAttachments.filter(id => id !== attachmentId);
    }
    this.cd.detectChanges();
  }
  addErrorMessage(attachmentId) {
    this.erroredAttachments.push(`${attachmentId}_${this.errorCounter}`);
    this.errorCounter++;
    this.cd.detectChanges();
  }
  closeErrorMessage(attachmentId) {
    this.erroredAttachments = this.erroredAttachments.filter(id => id !== attachmentId);
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  static {
    this.ɵfac = function OrderAttachmentsDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderAttachmentsDialogComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderAttachmentsDialogComponent,
      selectors: [["cx-order-attachments-dialog"]],
      standalone: false,
      decls: 28,
      vars: 23,
      consts: [["error", ""], ["empty", ""], ["loading", ""], ["role", "dialog", "aria-labelledby", "dialogTitle", "aria-modal", "true", 1, "cx-modal-container", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], ["id", "dialogTitle", 1, "cx-dialog-title", "modal-title"], ["class", "attachments-counter", 4, "ngIf"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [1, "cx-dialog-body", "modal-body"], ["class", "cx-dialog-message attachment-error", 3, "text", "type", "closeMessage", 4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], [1, "cx-dialog-footer", "modal-footer"], ["type", "button", 1, "btn", "btn-secondary", "cancel-button", 3, "click"], [1, "attachments-counter"], [1, "cx-dialog-message", "attachment-error", 3, "closeMessage", "text", "type"], [1, "table"], [4, "ngFor", "ngForOf"], ["class", "order-attachment-row", 4, "ngIf"], [1, "order-attachment-row"], [3, "mousedown", "keydown.enter", "title", "ngClass"], [1, "inline-spinner", 3, "ngClass"], ["tabindex", "0", "role", "button", 1, "file-icon", 3, "click", "keydown.enter", "title", "ngClass"], [1, "cx-dialog-message", "error-message", 3, "text", "type", "isVisibleCloseButton"], [1, "cx-dialog-message", "info-message", 3, "text", "type", "isVisibleCloseButton"], [1, "cx-spinner"]],
      template: function OrderAttachmentsDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 3);
          i0.ɵɵlistener("esc", function OrderAttachmentsDialogComponent_Template_div_esc_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.close("Escape clicked"));
          });
          i0.ɵɵelementStart(1, "div", 4)(2, "div", 5)(3, "div", 6)(4, "span");
          i0.ɵɵtext(5);
          i0.ɵɵpipe(6, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, OrderAttachmentsDialogComponent_span_7_Template, 2, 1, "span", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "button", 8);
          i0.ɵɵpipe(9, "cxTranslate");
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵlistener("click", function OrderAttachmentsDialogComponent_Template_button_click_8_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.close("Close dialog"));
          });
          i0.ɵɵelementStart(11, "span", 9);
          i0.ɵɵelement(12, "cx-icon", 10);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(13, "div", 11);
          i0.ɵɵtemplate(14, OrderAttachmentsDialogComponent_cx_message_14_Template, 2, 4, "cx-message", 12)(15, OrderAttachmentsDialogComponent_ng_container_15_Template, 2, 2, "ng-container", 13);
          i0.ɵɵpipe(16, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(17, "div", 14)(18, "button", 15);
          i0.ɵɵpipe(19, "cxTranslate");
          i0.ɵɵlistener("click", function OrderAttachmentsDialogComponent_Template_button_click_18_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.close("Cancel dialog"));
          });
          i0.ɵɵtext(20);
          i0.ɵɵpipe(21, "cxTranslate");
          i0.ɵɵelementEnd()()()();
          i0.ɵɵtemplate(22, OrderAttachmentsDialogComponent_ng_template_22_Template, 2, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(24, OrderAttachmentsDialogComponent_ng_template_24_Template, 2, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(26, OrderAttachmentsDialogComponent_ng_template_26_Template, 2, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const loading_r11 = i0.ɵɵreference(27);
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 11, "attachments.dialog.title"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.attachmentsCount());
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(9, 13, "attachments.dialog.closeModal"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 15, "attachments.dialog.closeModal"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("type", ctx.iconTypes.CLOSE);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.erroredAttachments);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(16, 17, ctx.attachments$))("ngIfElse", loading_r11);
          i0.ɵɵadvance(3);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(19, 19, "common.cancel"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 21, "common.cancel"), " ");
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgForOf, i2$1.NgIf, i3.SpinnerComponent, i3.FocusDirective, i3.IconComponent, i3.MessageComponent, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderAttachmentsDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-attachments-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  class=\"cx-modal-container\"\n  role=\"dialog\"\n  aria-labelledby=\"dialogTitle\"\n  aria-modal=\"true\"\n>\n  <div class=\"cx-modal-content\">\n    <div class=\"cx-dialog-header modal-header\">\n      <div id=\"dialogTitle\" class=\"cx-dialog-title modal-title\">\n        <span>\n          {{ 'attachments.dialog.title' | cxTranslate }}\n        </span>\n        <span *ngIf=\"attachmentsCount() as count\" class=\"attachments-counter\">\n          {{ '(' + count + ')' }}\n        </span>\n      </div>\n      <button\n        type=\"button\"\n        class=\"close\"\n        attr.aria-label=\"{{ 'attachments.dialog.closeModal' | cxTranslate }}\"\n        title=\"{{ 'attachments.dialog.closeModal' | cxTranslate }}\"\n        (click)=\"close('Close dialog')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <cx-message\n        *ngFor=\"let errorId of erroredAttachments\"\n        [text]=\"'attachments.dialog.downloadError' | cxTranslate\"\n        [type]=\"globalMessageType.MSG_TYPE_ERROR\"\n        (closeMessage)=\"closeErrorMessage(errorId)\"\n        class=\"cx-dialog-message attachment-error\"\n      >\n      </cx-message>\n      <ng-container *ngIf=\"attachments$ | async as attachments; else loading\">\n        <ng-container *ngIf=\"!loadError(); else error\">\n          <ng-container *ngIf=\"attachmentsCount(); else empty\">\n            <table class=\"table\">\n              <ng-container *ngFor=\"let attachment of attachments\">\n                <tr\n                  *ngIf=\"attachment.sapAttachmentId\"\n                  class=\"order-attachment-row\"\n                >\n                  <td>\n                    <a\n                      attr.aria-label=\"{{\n                        'attachments.dialog.preview' | cxTranslate\n                      }}\"\n                      title=\"{{ 'attachments.dialog.preview' | cxTranslate }}\"\n                      [ngClass]=\"{\n                        disabled: loadingAttachments.includes(\n                          attachment.sapAttachmentId\n                        ),\n                      }\"\n                      (mousedown)=\"\n                        onMouseDown(\n                          $event,\n                          attachment.sapAttachmentId,\n                          attachment.sapFileName\n                        )\n                      \"\n                      (keydown.enter)=\"\n                        openOrderAttachment(\n                          attachment.sapAttachmentId,\n                          attachment.sapFileName\n                        )\n                      \"\n                    >\n                      {{ attachment.sapFileName }}\n                    </a>\n                  </td>\n                  <td>\n                    <div\n                      class=\"inline-spinner\"\n                      [ngClass]=\"{\n                        hidden: !loadingAttachments.includes(\n                          attachment.sapAttachmentId\n                        ),\n                      }\"\n                    >\n                      <cx-spinner></cx-spinner>\n                    </div>\n                  </td>\n                  <td>\n                    <a\n                      tabindex=\"0\"\n                      role=\"button\"\n                      class=\"file-icon\"\n                      attr.aria-label=\"{{\n                        'attachments.dialog.preview' | cxTranslate\n                      }}\"\n                      title=\"{{ 'attachments.dialog.preview' | cxTranslate }}\"\n                      [ngClass]=\"{\n                        disabled: loadingAttachments.includes(\n                          attachment.sapAttachmentId\n                        ),\n                      }\"\n                      (click)=\"\n                        openOrderAttachment(\n                          attachment.sapAttachmentId,\n                          attachment.sapFileName\n                        )\n                      \"\n                      (keydown.enter)=\"\n                        openOrderAttachment(\n                          attachment.sapAttachmentId,\n                          attachment.sapFileName\n                        )\n                      \"\n                    >\n                      <cx-icon [type]=\"iconTypes.FILE\"></cx-icon>\n                    </a>\n                  </td>\n                </tr>\n              </ng-container>\n            </table>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </div>\n\n    <!-- Modal Footer -->\n    <div class=\"cx-dialog-footer modal-footer\">\n      <button\n        (click)=\"close('Cancel dialog')\"\n        [attr.aria-label]=\"'common.cancel' | cxTranslate\"\n        class=\"btn btn-secondary cancel-button\"\n        type=\"button\"\n      >\n        {{ 'common.cancel' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n\n<ng-template #error>\n  <cx-message\n    [text]=\"'attachments.dialog.error' | cxTranslate\"\n    [type]=\"globalMessageType.MSG_TYPE_ERROR\"\n    [isVisibleCloseButton]=\"false\"\n    class=\"cx-dialog-message error-message\"\n  >\n  </cx-message>\n</ng-template>\n<ng-template #empty>\n  <cx-message\n    [text]=\"'attachments.dialog.empty' | cxTranslate\"\n    [type]=\"globalMessageType.MSG_TYPE_INFO\"\n    [isVisibleCloseButton]=\"false\"\n    class=\"cx-dialog-message info-message\"\n  >\n  </cx-message>\n</ng-template>\n<ng-template #loading>\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</ng-template>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultOrderAttachmentsDialogLayoutConfig = {
  launch: {
    ORDER_ATTACHMENTS: {
      inline: true,
      component: OrderAttachmentsDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function registerOrderOutletFactory() {
  const isMyAccountV2 = inject(USE_MY_ACCOUNT_V2_ORDER);
  const outletService = inject(OutletService);
  const componentFactoryResolver = inject(ComponentFactoryResolver);
  return () => {
    const config = {
      component: MyAccountV2ConsignmentTrackingComponent,
      id: OrderOutlets.ORDER_CONSIGNMENT,
      position: OutletPosition.REPLACE
    };
    if (isMyAccountV2) {
      const template = componentFactoryResolver.resolveComponentFactory(config.component);
      outletService.add(config.id, template, config.position);
    }
  };
}
const myAccountV2CmsMapping$1 = {
  cmsComponents: {
    AccountOrderDetailsActionsComponent: {
      component: MyAccountV2OrderDetailsActionsComponent
      //guards: inherited from standard config,
    }
  }
};
const moduleComponents$2 = [OrderOverviewComponent, OrderDetailActionsComponent, OrderDetailItemsComponent, OrderDetailTotalsComponent, OrderDetailBillingComponent, TrackingEventsComponent, ConsignmentTrackingComponent, OrderConsignedEntriesComponent, OrderDetailReorderComponent, ReorderDialogComponent, MyAccountV2OrderDetailsActionsComponent, MyAccountV2ConsignmentTrackingComponent, OrderAttachmentsComponent, OrderAttachmentsDialogComponent];
class OrderDetailsModule {
  static {
    this.ɵfac = function OrderDetailsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderDetailsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrderDetailsModule,
      declarations: [OrderOverviewComponent, OrderDetailActionsComponent, OrderDetailItemsComponent, OrderDetailTotalsComponent, OrderDetailBillingComponent, TrackingEventsComponent, ConsignmentTrackingComponent, OrderConsignedEntriesComponent, OrderDetailReorderComponent, ReorderDialogComponent, MyAccountV2OrderDetailsActionsComponent, MyAccountV2ConsignmentTrackingComponent, OrderAttachmentsComponent, OrderAttachmentsDialogComponent],
      imports: [CardModule, CommonModule, I18nModule, FeaturesConfigModule, PromotionsModule, UrlModule, SpinnerModule, RouterModule, OutletModule, AddToCartModule, KeyboardFocusModule, IconModule, MyAccountV2DownloadInvoicesModule, AbstractOrderContextModule, BtnLikeLinkModule, MessageComponentModule],
      exports: [OrderOverviewComponent, OrderDetailActionsComponent, OrderDetailItemsComponent, OrderDetailTotalsComponent, OrderDetailBillingComponent, TrackingEventsComponent, ConsignmentTrackingComponent, OrderConsignedEntriesComponent, OrderDetailReorderComponent, ReorderDialogComponent, MyAccountV2OrderDetailsActionsComponent, MyAccountV2ConsignmentTrackingComponent, OrderAttachmentsComponent, OrderAttachmentsDialogComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [OrderOverviewComponentService, provideDefaultConfig({
        cmsComponents: {
          AccountOrderDetailsActionsComponent: {
            component: OrderDetailActionsComponent,
            guards: [AuthGuard]
          },
          AccountOrderDetailsItemsComponent: {
            component: OrderDetailItemsComponent,
            guards: [AuthGuard],
            data: {
              enableAddToCart: true
            }
          },
          AccountOrderDetailsGroupedItemsComponent: {
            component: OrderDetailItemsComponent,
            guards: [AuthGuard],
            data: {
              enableAddToCart: true,
              groupCartItems: true
            }
          },
          AccountOrderDetailsTotalsComponent: {
            component: OrderDetailTotalsComponent,
            guards: [AuthGuard]
          },
          AccountOrderDetailsOverviewComponent: {
            component: OrderOverviewComponent,
            guards: [AuthGuard]
          },
          AccountOrderDetailsSimpleOverviewComponent: {
            component: OrderOverviewComponent,
            guards: [AuthGuard],
            data: {
              simple: true
            }
          },
          AccountOrderDetailsReorderComponent: {
            component: OrderDetailReorderComponent,
            guards: [AuthGuard]
          },
          AccountOrderAttachmentsComponent: {
            component: OrderAttachmentsComponent,
            guards: [AuthGuard]
          }
        },
        features: {
          consignmentTracking: '1.2'
        }
      }), provideDefaultConfig(defaultConsignmentTrackingLayoutConfig), provideDefaultConfig(defaultReorderLayoutConfig), provideDefaultConfig(defaultOrderAttachmentsDialogLayoutConfig), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_ORDER) ? myAccountV2CmsMapping$1 : {}), {
        provide: MODULE_INITIALIZER,
        useFactory: registerOrderOutletFactory,
        multi: true
      }],
      imports: [CardModule, CommonModule, I18nModule, FeaturesConfigModule, PromotionsModule, UrlModule, SpinnerModule, RouterModule, OutletModule, AddToCartModule, KeyboardFocusModule, IconModule, MyAccountV2DownloadInvoicesModule, AbstractOrderContextModule, BtnLikeLinkModule, MessageComponentModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderDetailsModule, [{
    type: NgModule,
    args: [{
      imports: [CardModule, CommonModule, I18nModule, FeaturesConfigModule, PromotionsModule, UrlModule, SpinnerModule, RouterModule, OutletModule, AddToCartModule, KeyboardFocusModule, IconModule, MyAccountV2DownloadInvoicesModule, AbstractOrderContextModule, BtnLikeLinkModule, MessageComponentModule],
      providers: [OrderOverviewComponentService, provideDefaultConfig({
        cmsComponents: {
          AccountOrderDetailsActionsComponent: {
            component: OrderDetailActionsComponent,
            guards: [AuthGuard]
          },
          AccountOrderDetailsItemsComponent: {
            component: OrderDetailItemsComponent,
            guards: [AuthGuard],
            data: {
              enableAddToCart: true
            }
          },
          AccountOrderDetailsGroupedItemsComponent: {
            component: OrderDetailItemsComponent,
            guards: [AuthGuard],
            data: {
              enableAddToCart: true,
              groupCartItems: true
            }
          },
          AccountOrderDetailsTotalsComponent: {
            component: OrderDetailTotalsComponent,
            guards: [AuthGuard]
          },
          AccountOrderDetailsOverviewComponent: {
            component: OrderOverviewComponent,
            guards: [AuthGuard]
          },
          AccountOrderDetailsSimpleOverviewComponent: {
            component: OrderOverviewComponent,
            guards: [AuthGuard],
            data: {
              simple: true
            }
          },
          AccountOrderDetailsReorderComponent: {
            component: OrderDetailReorderComponent,
            guards: [AuthGuard]
          },
          AccountOrderAttachmentsComponent: {
            component: OrderAttachmentsComponent,
            guards: [AuthGuard]
          }
        },
        features: {
          consignmentTracking: '1.2'
        }
      }), provideDefaultConfig(defaultConsignmentTrackingLayoutConfig), provideDefaultConfig(defaultReorderLayoutConfig), provideDefaultConfig(defaultOrderAttachmentsDialogLayoutConfig), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_ORDER) ? myAccountV2CmsMapping$1 : {}), {
        provide: MODULE_INITIALIZER,
        useFactory: registerOrderOutletFactory,
        multi: true
      }],
      declarations: [...moduleComponents$2],
      exports: [...moduleComponents$2]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderHistoryComponent {
  constructor(routing, orderHistoryFacade, translation, replenishmentOrderHistoryFacade) {
    this.routing = routing;
    this.orderHistoryFacade = orderHistoryFacade;
    this.translation = translation;
    this.replenishmentOrderHistoryFacade = replenishmentOrderHistoryFacade;
    this.PAGE_SIZE = 5;
    this.orders$ = this.orderHistoryFacade.getOrderHistoryList(this.PAGE_SIZE).pipe(tap(orders => {
      this.setOrderHistoryParams(orders);
    }));
    this.hasReplenishmentOrder$ = this.replenishmentOrderHistoryFacade.getReplenishmentOrderDetails().pipe(map(order => order && Object.keys(order).length !== 0));
    this.isLoaded$ = this.orderHistoryFacade.getOrderHistoryListLoaded();
    /**
     * When "Order Return" feature is enabled, this component becomes one tab in
     * TabParagraphContainerComponent. This can be read from TabParagraphContainer.
     */
    this.tabTitleParam$ = this.orders$.pipe(map(order => order?.pagination?.totalResults), filter(isNotUndefined), take(1));
    useFeatureStyles('a11yTabComponent');
  }
  setOrderHistoryParams(orders) {
    if (orders?.pagination?.sort) {
      this.sortType = orders.pagination.sort;
    }
    this.hasPONumber = orders?.orders?.[0]?.purchaseOrderNumber !== undefined;
  }
  ngOnDestroy() {
    this.orderHistoryFacade.clearOrderList();
  }
  changeSortCode(sortCode) {
    const event = {
      sortCode,
      currentPage: 0
    };
    this.sortType = sortCode;
    this.fetchOrders(event);
  }
  pageChange(page) {
    const event = {
      sortCode: this.sortType,
      currentPage: page
    };
    this.fetchOrders(event);
  }
  goToOrderDetail(order) {
    this.routing.go({
      cxRoute: 'orderDetails',
      params: order
    }, {
      queryParams: this.getQueryParams(order)
    });
  }
  getQueryParams(order) {
    return this.orderHistoryFacade.getQueryParams(order);
  }
  getSortLabels() {
    return combineLatest([this.translation.translate('sorting.date'), this.translation.translate('sorting.orderNumber')]).pipe(map(([textByDate, textByOrderNumber]) => {
      return {
        byDate: textByDate,
        byOrderNumber: textByOrderNumber
      };
    }));
  }
  fetchOrders(event) {
    this.orderHistoryFacade.loadOrderList(this.PAGE_SIZE, event.currentPage, event.sortCode);
  }
  static {
    this.ɵfac = function OrderHistoryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderHistoryComponent)(i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i1.OrderHistoryFacade), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i1.ReplenishmentOrderHistoryFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderHistoryComponent,
      selectors: [["cx-order-history"]],
      standalone: false,
      decls: 3,
      vars: 8,
      consts: [["noOrder", ""], ["otherOrder", ""], [4, "ngIf"], [1, "cx-order-history-container"], [3, "ngClass"], [1, "cx-order-history-body"], [4, "ngIf", "ngIfElse"], [1, "cx-order-history-sort", "top"], [1, "cx-order-history-form-group", "form-group"], ["ariaControls", "order-history-table", 3, "sortListEvent", "sortOptions", "sortLabels", "selectedOption", "placeholder", "ariaLabel"], ["class", "cx-order-history-pagination", 4, "ngIf"], ["role", "table", "id", "order-history-table", 1, "table", "cx-order-history-table", 3, "ngClass"], [1, "cx-visually-hidden"], [1, "cx-order-history-thead-mobile"], ["role", "row"], ["role", "columnheader", "scope", "col"], ["role", "row", 3, "click", 4, "ngFor", "ngForOf"], [1, "cx-order-history-sort", "bottom"], [1, "cx-order-history-pagination"], ["paginationID", "pagination-top", 3, "viewPageEvent", "pagination"], ["role", "row", 3, "click"], ["role", "cell", 1, "cx-order-history-code"], [1, "cx-order-history-label"], [1, "cx-order-history-value", 3, "routerLink", "queryParams"], ["role", "cell", 1, "cx-order-history-placed"], ["role", "cell", 1, "cx-order-history-status"], ["role", "cell", 1, "cx-order-history-total"], ["role", "cell", 1, "cx-order-history-po"], ["class", "cx-order-history-value", 3, "routerLink", "queryParams", 4, "ngIf"], ["role", "cell", 1, "cx-order-history-cost-center"], ["paginationID", "pagination-bottom", 3, "viewPageEvent", "pagination"], [3, "ngClass", 4, "ngIf"], ["routerLinkActive", "active", "cxBtnLikeLink", "", 1, "btn", "btn-primary", "btn-block", 3, "routerLink"]],
      template: function OrderHistoryComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderHistoryComponent_ng_container_0_Template, 2, 1, "ng-container", 2);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵpipe(2, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction2(5, _c28, i0.ɵɵpipeBind1(1, 1, ctx.orders$), i0.ɵɵpipeBind1(2, 3, ctx.hasReplenishmentOrder$)));
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgForOf, i2$1.NgIf, i2$2.RouterLink, i2$2.RouterLinkActive, i3.SortingComponent, i3.PaginationComponent, i3.BtnLikeLinkDirective, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderHistoryComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-history',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container\n  *ngIf=\"{\n    orderHistory: orders$ | async,\n    replenishmentOrder: hasReplenishmentOrder$ | async,\n  } as type\"\n>\n  <ng-container *ngIf=\"type.orderHistory\">\n    <div class=\"cx-order-history-container\">\n      <!-- HEADER -->\n      <div\n        [ngClass]=\"\n          type.replenishmentOrder\n            ? 'cx-replenishment-details-order-history-header'\n            : 'cx-order-history-header'\n        \"\n      >\n        <h4 *ngIf=\"type.replenishmentOrder\">\n          {{ 'orderHistory.replenishmentHistory' | cxTranslate }}\n        </h4>\n        <h2 *ngIf=\"!type.replenishmentOrder\">\n          {{ 'orderHistory.orderHistory' | cxTranslate }}\n        </h2>\n      </div>\n\n      <!-- BODY -->\n      <div class=\"cx-order-history-body\">\n        <ng-container\n          *ngIf=\"type.orderHistory.pagination.totalResults > 0; else noOrder\"\n        >\n          <!-- Select Form and Pagination Top -->\n          <div class=\"cx-order-history-sort top\">\n            <label class=\"cx-order-history-form-group form-group\"\n              ><span>\n                {{ 'orderHistory.sortBy' | cxTranslate }}\n              </span>\n              <cx-sorting\n                [sortOptions]=\"type.orderHistory.sorts\"\n                [sortLabels]=\"getSortLabels() | async\"\n                (sortListEvent)=\"changeSortCode($event)\"\n                [selectedOption]=\"type.orderHistory.pagination.sort\"\n                placeholder=\"{{ 'orderHistory.sortBy' | cxTranslate }}\"\n                [ariaLabel]=\"'orderHistory.sortOrders' | cxTranslate\"\n                ariaControls=\"order-history-table\"\n              ></cx-sorting>\n            </label>\n            <div\n              *ngIf=\"type.orderHistory.pagination.totalPages > 1\"\n              class=\"cx-order-history-pagination\"\n            >\n              <cx-pagination\n                [pagination]=\"type.orderHistory.pagination\"\n                (viewPageEvent)=\"pageChange($event)\"\n                paginationID=\"pagination-top\"\n              ></cx-pagination>\n            </div>\n          </div>\n\n          <table\n            role=\"table\"\n            id=\"order-history-table\"\n            class=\"table cx-order-history-table\"\n            [ngClass]=\"{ 'cx-order-history-table-po': hasPONumber }\"\n          >\n            <caption class=\"cx-visually-hidden\">\n              {{\n                'orderHistory.orderHistory' | cxTranslate\n              }}\n            </caption>\n            <thead class=\"cx-order-history-thead-mobile\">\n              <tr role=\"row\">\n                <th role=\"columnheader\" scope=\"col\">\n                  {{ 'orderHistory.orderId' | cxTranslate }}\n                </th>\n                <ng-container *ngIf=\"hasPONumber\">\n                  <th role=\"columnheader\" scope=\"col\">\n                    {{ 'orderHistory.PONumber' | cxTranslate }}\n                  </th>\n                  <th role=\"columnheader\" scope=\"col\">\n                    {{ 'orderHistory.costCenter' | cxTranslate }}\n                  </th>\n                </ng-container>\n                <th role=\"columnheader\" scope=\"col\">\n                  {{ 'orderHistory.date' | cxTranslate }}\n                </th>\n                <th role=\"columnheader\" scope=\"col\">\n                  {{ 'orderHistory.status' | cxTranslate }}\n                </th>\n                <th role=\"columnheader\" scope=\"col\">\n                  {{ 'orderHistory.total' | cxTranslate }}\n                </th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr\n                role=\"row\"\n                *ngFor=\"let order of type.orderHistory.orders; let i = index\"\n                (click)=\"goToOrderDetail(order)\"\n                [attr.aria-rowindex]=\"i + 1\"\n              >\n                <td role=\"cell\" class=\"cx-order-history-code\">\n                  <div class=\"cx-order-history-label\">\n                    {{ 'orderHistory.orderId' | cxTranslate }}\n                  </div>\n                  <a\n                    [routerLink]=\"\n                      {\n                        cxRoute: 'orderDetails',\n                        params: order,\n                      } | cxUrl\n                    \"\n                    [queryParams]=\"getQueryParams(order)\"\n                    class=\"cx-order-history-value\"\n                  >\n                    {{ order?.code }}</a\n                  >\n                </td>\n                <ng-container *ngIf=\"hasPONumber\">\n                  <td role=\"cell\" class=\"cx-order-history-po\">\n                    <div class=\"cx-order-history-label\">\n                      {{ 'orderHistory.PONumber' | cxTranslate }}\n                    </div>\n                    <a\n                      *ngIf=\"order.purchaseOrderNumber\"\n                      [routerLink]=\"\n                        {\n                          cxRoute: 'orderDetails',\n                          params: order,\n                        } | cxUrl\n                      \"\n                      [queryParams]=\"getQueryParams(order)\"\n                      class=\"cx-order-history-value\"\n                    >\n                      {{ order.purchaseOrderNumber }}</a\n                    >\n                  </td>\n                  <td role=\"cell\" class=\"cx-order-history-cost-center\">\n                    <div class=\"cx-order-history-label\">\n                      {{ 'orderHistory.costCenter' | cxTranslate }}\n                    </div>\n                    <a\n                      *ngIf=\"order.costCenter?.name\"\n                      [routerLink]=\"\n                        {\n                          cxRoute: 'orderDetails',\n                          params: order,\n                        } | cxUrl\n                      \"\n                      [queryParams]=\"getQueryParams(order)\"\n                      class=\"cx-order-history-value\"\n                    >\n                      {{ order.costCenter?.name }}</a\n                    >\n                  </td>\n                </ng-container>\n\n                <td role=\"cell\" class=\"cx-order-history-placed\">\n                  <div class=\"cx-order-history-label\">\n                    {{ 'orderHistory.date' | cxTranslate }}\n                  </div>\n                  <a\n                    [routerLink]=\"\n                      {\n                        cxRoute: 'orderDetails',\n                        params: order,\n                      } | cxUrl\n                    \"\n                    [queryParams]=\"getQueryParams(order)\"\n                    class=\"cx-order-history-value\"\n                    >{{ order?.placed | cxDate: 'longDate' }}</a\n                  >\n                </td>\n                <td role=\"cell\" class=\"cx-order-history-status\">\n                  <div class=\"cx-order-history-label\">\n                    {{ 'orderHistory.status' | cxTranslate }}\n                  </div>\n                  <a\n                    [routerLink]=\"\n                      {\n                        cxRoute: 'orderDetails',\n                        params: order,\n                      } | cxUrl\n                    \"\n                    [queryParams]=\"getQueryParams(order)\"\n                    class=\"cx-order-history-value\"\n                  >\n                    {{\n                      'orderDetails.statusDisplay_' + order?.statusDisplay\n                        | cxTranslate\n                    }}</a\n                  >\n                </td>\n                <td role=\"cell\" class=\"cx-order-history-total\">\n                  <div class=\"cx-order-history-label\">\n                    {{ 'orderHistory.total' | cxTranslate }}\n                  </div>\n                  <a\n                    [routerLink]=\"\n                      {\n                        cxRoute: 'orderDetails',\n                        params: order,\n                      } | cxUrl\n                    \"\n                    [queryParams]=\"getQueryParams(order)\"\n                    class=\"cx-order-history-value\"\n                  >\n                    {{ order?.total.formattedValue }}</a\n                  >\n                </td>\n              </tr>\n            </tbody>\n          </table>\n\n          <!-- Select Form and Pagination Bottom -->\n          <div class=\"cx-order-history-sort bottom\">\n            <div\n              *ngIf=\"type.orderHistory.pagination.totalPages > 1\"\n              class=\"cx-order-history-pagination\"\n            >\n              <cx-pagination\n                [pagination]=\"type.orderHistory.pagination\"\n                (viewPageEvent)=\"pageChange($event)\"\n                paginationID=\"pagination-bottom\"\n              ></cx-pagination>\n            </div>\n          </div>\n        </ng-container>\n\n        <!-- NO ORDER CONTAINER -->\n        <ng-template #noOrder>\n          <div\n            *ngIf=\"isLoaded$ | async\"\n            [ngClass]=\"\n              type.replenishmentOrder\n                ? 'cx-replenishment-details-order-history-no-order'\n                : 'cx-order-history-no-order'\n            \"\n          >\n            <div>\n              <ng-container *ngIf=\"type.replenishmentOrder; else otherOrder\">\n                <div>{{ 'orderHistory.notFound' | cxTranslate }}</div>\n              </ng-container>\n\n              <ng-template #otherOrder>\n                <div>{{ 'orderHistory.noOrders' | cxTranslate }}</div>\n                <a\n                  [routerLink]=\"{ cxRoute: 'home' } | cxUrl\"\n                  routerLinkActive=\"active\"\n                  class=\"btn btn-primary btn-block\"\n                  cxBtnLikeLink\n                  >{{ 'orderHistory.startShopping' | cxTranslate }}</a\n                >\n              </ng-template>\n            </div>\n          </div>\n        </ng-template>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: i2.RoutingService
  }, {
    type: i1.OrderHistoryFacade
  }, {
    type: i2.TranslationService
  }, {
    type: i1.ReplenishmentOrderHistoryFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var OrderCriticalStatus;
(function (OrderCriticalStatus) {
  OrderCriticalStatus["CANCELLED"] = "CANCELLED";
  OrderCriticalStatus["ERROR"] = "ERROR";
  OrderCriticalStatus["REJECTED"] = "REJECTED";
})(OrderCriticalStatus || (OrderCriticalStatus = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2ConsignmentEntriesComponent {
  getConsignmentNumber(code) {
    if (code) {
      const consignmentNumber = Number(code.split('_')[1]);
      if (!isNaN(consignmentNumber)) {
        return (consignmentNumber + 1).toString();
      }
    }
    return code;
  }
  static {
    this.ɵfac = function MyAccountV2ConsignmentEntriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2ConsignmentEntriesComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2ConsignmentEntriesComponent,
      selectors: [["cx-my-account-v2-consignment-entries"]],
      inputs: {
        consignments: "consignments",
        orderCode: "orderCode"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["showLastUpdated", ""], ["showNumber", ""], [4, "ngFor", "ngForOf"], ["class", "cx-consignment-info", 4, "ngIf"], [1, "cx-consignment-info"], [4, "ngIf", "ngIfElse"], [4, "ngIf"], ["target", "_blank", "rel", "noopener noreferrer", 1, "cx-tracking-id", 3, "href"]],
      template: function MyAccountV2ConsignmentEntriesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2ConsignmentEntriesComponent_ng_container_0_Template, 2, 1, "ng-container", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.consignments);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2ConsignmentEntriesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-consignment-entries',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngFor=\"let consignment of consignments; index as i\">\n  <!--\nexample:\nConsignment 1 | In Process | Last Updated: 13, September, 2023\nConsignment 2 | Tracking Number: 5657474 | Estimated Delivery: 22, September, 2023\n  -->\n  <div\n    class=\"cx-consignment-info\"\n    [attr.aria-label]=\"\n      'myAccountV2OrderHistory.consignmentDetailLabel' | cxTranslate\n    \"\n    *ngIf=\"consignment\"\n  >\n    <span\n      [attr.aria-label]=\"\n        'myAccountV2OrderHistory.consignmentNumberLabel' | cxTranslate\n      \"\n    >\n      {{\n        'myAccountV2OrderHistory.consignmentCode'\n          | cxTranslate: { param: i + 1 }\n      }}\n    </span>\n    |\n    <ng-container *ngIf=\"consignment.trackingID; else showLastUpdated\">\n      <ng-container *ngIf=\"consignment.consignmentTracking as tracking\">\n        <span\n          [attr.aria-label]=\"\n            'orderDetails.consignmentTracking.dialog.trackingId' | cxTranslate\n          \"\n        >\n          {{\n            'orderDetails.consignmentTracking.dialog.trackingId' | cxTranslate\n          }}:\n          <ng-container *ngIf=\"tracking.trackingUrl; else showNumber\">\n            <a\n              class=\"cx-tracking-id\"\n              target=\"_blank\"\n              rel=\"noopener noreferrer\"\n              [href]=\"tracking.trackingUrl\"\n              >{{ tracking.trackingID }}</a\n            >\n          </ng-container>\n          |\n        </span>\n        <span\n          [attr.aria-label]=\"\n            'myAccountV2OrderHistory.estimateDeliveryLabel' | cxTranslate\n          \"\n        >\n          {{\n            'orderDetails.consignmentTracking.dialog.estimate' | cxTranslate\n          }}:\n          {{ tracking.targetArrivalDate | cxDate: 'd, MMMM, yyyy' }}\n        </span>\n        <ng-template #showNumber>\n          {{ tracking.trackingID }}\n        </ng-template>\n      </ng-container>\n    </ng-container>\n    <ng-template #showLastUpdated>\n      <span\n        [attr.aria-label]=\"\n          'myAccountV2OrderHistory.consignmentStatusLabel' | cxTranslate\n        \"\n        *ngIf=\"consignment.status\"\n      >\n        {{\n          'orderDetails.deliveryStatus_' + consignment?.status?.toUpperCase()\n            | cxTranslate\n        }}\n      </span>\n      <span\n        *ngIf=\"consignment.statusDate\"\n        [attr.aria-label]=\"\n          'myAccountV2OrderHistory.consignmentStatusDateLabel' | cxTranslate\n        \"\n      >\n        |\n        {{\n          'myAccountV2OrderHistory.statusDate'\n            | cxTranslate\n              : { param: consignment.statusDate | cxDate: 'd, MMMM, yyyy' }\n        }}\n      </span>\n    </ng-template>\n  </div>\n</ng-container>\n"
    }]
  }], null, {
    consignments: [{
      type: Input
    }],
    orderCode: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2OrderConsolidatedInformationComponent {
  constructor() {
    this.orderConsignmentsService = inject(MyAccountV2OrderConsignmentsService);
    this.criticalStatuses = Object.values(OrderCriticalStatus);
    this.IMAGE_COUNT = 4; //showing fixed no.of images, without using carousel
  }
  getConsignmentsCount(consignments) {
    let count = 0;
    if (consignments) {
      for (const consignment of consignments) {
        if (consignment.entries) {
          count = count + consignment.entries.length;
        }
      }
    }
    return count;
  }
  getOrderEntriesCount(orderEntries) {
    return orderEntries?.length ?? 0;
  }
  isStatusCritical(status) {
    return this.criticalStatuses.includes(status.toUpperCase());
  }
  getPickupConsignments(consignments) {
    const orderDetail = {};
    orderDetail.consignments = consignments;
    return this.orderConsignmentsService.getGroupedConsignments(orderDetail, true) ?? [];
  }
  getDeliveryConsignments(consignments) {
    const orderDetail = {};
    orderDetail.consignments = consignments;
    return this.orderConsignmentsService.getGroupedConsignments(orderDetail, false) ?? [];
  }
  getDeliveryUnconsignedEntries(unconsignedEntries) {
    const orderDetail = {};
    orderDetail.unconsignedEntries = unconsignedEntries;
    return this.orderConsignmentsService.getUnconsignedEntries(orderDetail, false) ?? [];
  }
  getPickupUnconsignedEntries(unconsignedEntries) {
    const orderDetail = {};
    orderDetail.unconsignedEntries = unconsignedEntries;
    return this.orderConsignmentsService.getUnconsignedEntries(orderDetail, true) ?? [];
  }
  getProductImages(entries) {
    const images = [];
    let index = 0;
    for (const item of entries) {
      if (item.product?.images) {
        if (index >= this.IMAGE_COUNT) {
          break;
        }
        index++;
        images.push(item.product?.images);
      }
    }
    return images;
  }
  static {
    this.ɵfac = function MyAccountV2OrderConsolidatedInformationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2OrderConsolidatedInformationComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2OrderConsolidatedInformationComponent,
      selectors: [["cx-my-account-v2-order-consolidated-information"]],
      inputs: {
        order: "order"
      },
      standalone: false,
      decls: 5,
      vars: 1,
      consts: [["showManyItems", ""], ["showOneItem", ""], ["nonCritical", ""], ["showReturnCode", ""], ["class", "cx-consolidated-order-info", 4, "ngIf"], [1, "cx-consolidated-order-info"], [1, "cx-order-info"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "cx-order-images-container"], [1, "cx-order-status"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "orderCode", "consignments"], ["class", "cx-consignment-info", 4, "ngIf"], ["class", "cx-order-status-critical", 4, "ngIf", "ngIfElse"], [1, "cx-order-status-critical"], [1, "cx-consignment-info"], ["class", "cx-order-status-critical-link", 3, "routerLink", 4, "ngIf", "ngIfElse"], [1, "cx-order-status-critical-link", 3, "routerLink"], ["format", "thumbnail", "role", "presentation", 1, "cx-order-img", 3, "container"], [4, "ngIf", "ngIfElse"]],
      template: function MyAccountV2OrderConsolidatedInformationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2OrderConsolidatedInformationComponent_div_0_Template, 8, 7, "div", 4)(1, MyAccountV2OrderConsolidatedInformationComponent_ng_template_1_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, MyAccountV2OrderConsolidatedInformationComponent_ng_template_3_Template, 2, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.order);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$1.NgTemplateOutlet, i2$2.RouterLink, i3.MediaComponent, MyAccountV2ConsignmentEntriesComponent, i2.UrlPipe, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2OrderConsolidatedInformationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-order-consolidated-information',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"cx-consolidated-order-info\" *ngIf=\"order\">\n  <div class=\"cx-order-info\">\n    <!-- pickup consigned entries \n  eg: To Be Picked Up - 3 Items\n  -->\n    <div\n      *ngIf=\"\n        getConsignmentsCount(getPickupConsignments(order.consignments ?? [])) >\n        0\n      \"\n    >\n      <div class=\"cx-order-status\">\n        {{\n          'myAccountV2OrderHistory.deliveryPointOfServiceDetails.itemsToBePickUp'\n            | cxTranslate\n        }}\n        <ng-container\n          *ngTemplateOutlet=\"\n            showManyItems;\n            context: {\n              count: getConsignmentsCount(\n                getPickupConsignments(order.consignments ?? [])\n              ),\n            }\n          \"\n        ></ng-container>\n      </div>\n      <cx-my-account-v2-consignment-entries\n        [orderCode]=\"order.code ?? ''\"\n        [consignments]=\"getPickupConsignments(order.consignments ?? [])\"\n      ></cx-my-account-v2-consignment-entries>\n    </div>\n\n    <!-- delivery consigned entries\n  eg: To Be Shipped - 6 Items\n  -->\n    <div\n      *ngIf=\"\n        getConsignmentsCount(\n          getDeliveryConsignments(order.consignments ?? [])\n        ) > 0\n      \"\n    >\n      <!--heading taken from feature-libs/order/components/order-confirmation/order-confirmation-shipping/order-confirmation-shipping.component.html-->\n      <!--instead of [cxOutlet]=\"OrderOutlets.CONSIGNMENT_DELIVERY_INFO\"-->\n      <div class=\"cx-order-status\">\n        {{\n          'myAccountV2OrderHistory.checkoutMode.deliveryEntries' | cxTranslate\n        }}\n        <ng-container\n          *ngTemplateOutlet=\"\n            showManyItems;\n            context: {\n              count: getConsignmentsCount(\n                getDeliveryConsignments(order.consignments ?? [])\n              ),\n            }\n          \"\n        ></ng-container>\n      </div>\n      <cx-my-account-v2-consignment-entries\n        [orderCode]=\"order.code ?? ''\"\n        [consignments]=\"getDeliveryConsignments(order.consignments ?? [])\"\n      ></cx-my-account-v2-consignment-entries>\n    </div>\n\n    <!-- unconsigned entries \n  eg: Some_Status - 1 Item\n  -->\n    <div *ngIf=\"getOrderEntriesCount(order.unconsignedEntries) > 0\">\n      <div *ngIf=\"order.statusDisplay\">\n        <div\n          class=\"cx-order-status-critical\"\n          *ngIf=\"isStatusCritical(order.statusDisplay); else nonCritical\"\n        >\n          {{\n            'orderDetails.statusDisplay_' + order.statusDisplay | cxTranslate\n          }}\n          -\n          <ng-container\n            *ngTemplateOutlet=\"\n              showManyItems;\n              context: { count: getOrderEntriesCount(order.unconsignedEntries) }\n            \"\n          ></ng-container>\n        </div>\n        <ng-template #nonCritical>\n          <div class=\"cx-order-status\">\n            {{\n              'orderDetails.statusDisplay_' + order.statusDisplay | cxTranslate\n            }}\n            -\n            <ng-container\n              *ngTemplateOutlet=\"\n                showManyItems;\n                context: {\n                  count: getOrderEntriesCount(order.unconsignedEntries),\n                }\n              \"\n            ></ng-container>\n          </div>\n        </ng-template>\n      </div>\n\n      <!-- delivery unconsigned entries \n      eg: To Be Shipped - 6 Items //showing this is in extra information format\n    -->\n      <div\n        class=\"cx-consignment-info\"\n        *ngIf=\"\n          getOrderEntriesCount(\n            getDeliveryUnconsignedEntries(order.unconsignedEntries ?? [])\n          ) > 0\n        \"\n      >\n        {{\n          'myAccountV2OrderHistory.checkoutMode.deliveryEntries' | cxTranslate\n        }}\n        <ng-container\n          *ngTemplateOutlet=\"\n            showManyItems;\n            context: {\n              count: getOrderEntriesCount(\n                getDeliveryUnconsignedEntries(order.unconsignedEntries ?? [])\n              ),\n            }\n          \"\n        ></ng-container>\n      </div>\n\n      <!-- pickup unconsigned entries, b2b does not have pickup items\n      eg: To Be Picked Up - 7 Items //showing this is as an extra information format\n    -->\n      <div\n        class=\"cx-consignment-info\"\n        *ngIf=\"\n          getOrderEntriesCount(\n            getPickupUnconsignedEntries(order.unconsignedEntries ?? [])\n          ) > 0\n        \"\n      >\n        {{\n          'myAccountV2OrderHistory.checkoutPickupInStore.heading' | cxTranslate\n        }}\n        <ng-container\n          *ngTemplateOutlet=\"\n            showManyItems;\n            context: {\n              count: getOrderEntriesCount(\n                getPickupUnconsignedEntries(order.unconsignedEntries ?? [])\n              ),\n            }\n          \"\n        ></ng-container>\n      </div>\n    </div>\n\n    <!--return request details\n  eg: Returned: 2 Items\n      Return Processed: 15, September, 2022\n  -->\n    <div *ngFor=\"let returnRequest of order.returnRequests\">\n      <div class=\"cx-order-status-critical\">\n        {{ 'returnRequestList.returnRequestId' | cxTranslate }}\n        <a\n          *ngIf=\"returnRequest.rma; else showReturnCode\"\n          [routerLink]=\"\n            {\n              cxRoute: 'returnRequestDetails',\n              params: returnRequest,\n            } | cxUrl\n          \"\n          class=\"cx-order-status-critical-link\"\n        >\n          {{ returnRequest.rma }}</a\n        >\n      </div>\n      <ng-template #showReturnCode>\n        {{ returnRequest.code }}\n      </ng-template>\n      <div\n        class=\"cx-consignment-info\"\n        *ngIf=\"returnRequest.creationTime as creationTime\"\n      >\n        {{\n          'myAccountV2OrderHistory.returnProcessed'\n            | cxTranslate: { param: creationTime | cxDate: 'd, MMMM, yyyy' }\n        }}\n      </div>\n    </div>\n  </div>\n  <div class=\"cx-order-images-container\">\n    <ng-container *ngIf=\"order.entries\">\n      <ng-container *ngFor=\"let item of getProductImages(order.entries)\">\n        <cx-media\n          [container]=\"item.PRIMARY\"\n          class=\"cx-order-img\"\n          format=\"thumbnail\"\n          role=\"presentation\"\n        ></cx-media>\n      </ng-container>\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #showManyItems let-count=\"count\">\n  <ng-container *ngIf=\"count > 1; else showOneItem\">\n    {{ 'myAccountV2OrderHistory.items' | cxTranslate: { param: count } }}\n  </ng-container>\n</ng-template>\n<ng-template #showOneItem>\n  {{ 'myAccountV2OrderHistory.item' | cxTranslate: { param: 1 } }}\n</ng-template>\n"
    }]
  }], null, {
    order: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2OrderHistoryComponent extends OrderHistoryComponent {
  constructor() {
    super(...arguments);
    this.service = inject(MyAccountV2OrderHistoryService);
    this.ITEMS_PER_PAGE = 5;
    this.isLoaded$ = new BehaviorSubject(false);
    this.orders$ = this.service.getOrderHistoryList(this.ITEMS_PER_PAGE).pipe(tap(orders => {
      this.isLoaded$.next(true);
      super.setOrderHistoryParams(orders);
    }));
  }
  pageChange(page) {
    this.isLoaded$.next(false);
    this.service.clearOrderList();
    super.pageChange(page);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMyAccountV2OrderHistoryComponent_BaseFactory;
      return function MyAccountV2OrderHistoryComponent_Factory(__ngFactoryType__) {
        return (ɵMyAccountV2OrderHistoryComponent_BaseFactory || (ɵMyAccountV2OrderHistoryComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MyAccountV2OrderHistoryComponent)))(__ngFactoryType__ || MyAccountV2OrderHistoryComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2OrderHistoryComponent,
      selectors: [["cx-my-account-v2-order-history"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 6,
      vars: 4,
      consts: [["noOrder", ""], ["loading", ""], [4, "ngIf", "ngIfElse"], [1, "cx-my-account-v2-order-history-header"], [1, "cx-my-account-v2-order-history-body"], [4, "ngFor", "ngForOf"], ["class", "cx-order-history-pagination", 4, "ngIf"], [1, "cx-each-order"], [1, "cx-my-account-v2-order-history-code", 3, "click"], [3, "routerLink", "queryParams"], [1, "cx-my-account-v2-order-summary"], [3, "order"], [1, "cx-order-history-pagination"], [3, "viewPageEvent", "pagination"], ["routerLinkActive", "active", 1, "cx-no-order", 3, "routerLink"], [1, "cx-spinner"]],
      template: function MyAccountV2OrderHistoryComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2OrderHistoryComponent_div_0_Template, 9, 13, "div", 2);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, MyAccountV2OrderHistoryComponent_ng_template_2_Template, 2, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, MyAccountV2OrderHistoryComponent_ng_template_4_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const noOrder_r6 = i0.ɵɵreference(3);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.orders$))("ngIfElse", noOrder_r6);
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$2.RouterLink, i2$2.RouterLinkActive, i3.PaginationComponent, i3.SpinnerComponent, MyAccountV2OrderConsolidatedInformationComponent, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2OrderHistoryComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-order-history',
      standalone: false,
      template: "<div\n  *ngIf=\"orders$ | async as orderHistory; else noOrder\"\n  [attr.aria-label]=\"'myAccountV2OrderHistory.orderListResults' | cxTranslate\"\n>\n  <!-- HEADER -->\n  <div class=\"cx-my-account-v2-order-history-header\">\n    <h2>\n      {{\n        'myAccountV2OrderHistory.heading'\n          | cxTranslate: { param: tabTitleParam$ | async }\n      }}\n    </h2>\n  </div>\n  <!--BODY-->\n  <div class=\"cx-my-account-v2-order-history-body\">\n    <ng-container\n      *ngIf=\"orderHistory.pagination.totalResults > 0; else noOrder\"\n    >\n      <ng-container *ngFor=\"let order of orderHistory.orders\">\n        <div class=\"cx-each-order\">\n          <!--eg: Order # 12345-->\n          <div\n            class=\"cx-my-account-v2-order-history-code\"\n            [attr.aria-label]=\"\n              'myAccountV2OrderHistory.orderCodeLabel' | cxTranslate\n            \"\n            (click)=\"goToOrderDetail(order)\"\n          >\n            <a\n              [routerLink]=\"\n                {\n                  cxRoute: 'orderDetails',\n                  params: order,\n                } | cxUrl\n              \"\n              [queryParams]=\"getQueryParams(order)\"\n            >\n              {{ 'orderHistory.orderId' | cxTranslate }} {{ order?.code }}</a\n            >\n          </div>\n\n          <!--eg: 12,October,2022 | Total Price: $12.00-->\n          <div class=\"cx-my-account-v2-order-summary\">\n            <span\n              [attr.aria-label]=\"\n                'myAccountV2OrderHistory.orderPlaced' | cxTranslate\n              \"\n            >\n              {{ order.placed | cxDate: 'd, MMMM, yyyy' }} |\n            </span>\n            <span\n              [attr.aria-label]=\"\n                'myAccountV2OrderHistory.totalPriceLabel' | cxTranslate\n              \"\n            >\n              <strong>\n                {{\n                  'myAccountV2OrderHistory.totalPrice'\n                    | cxTranslate: { param: order.total?.formattedValue }\n                }}\n              </strong>\n            </span>\n          </div>\n\n          <!--eg: Display consolidated order information-->\n          <cx-my-account-v2-order-consolidated-information [order]=\"order\">\n          </cx-my-account-v2-order-consolidated-information>\n        </div>\n      </ng-container>\n\n      <!-- PAGINATION -->\n      <div\n        *ngIf=\"orderHistory.pagination.totalPages > 1\"\n        class=\"cx-order-history-pagination\"\n        [attr.aria-label]=\"\n          'myAccountV2OrderHistory.orderListPagination' | cxTranslate\n        \"\n      >\n        <cx-pagination\n          [pagination]=\"orderHistory.pagination\"\n          (viewPageEvent)=\"pageChange($event)\"\n        ></cx-pagination>\n      </div>\n    </ng-container>\n  </div>\n</div>\n\n<!-- NO ORDER CONTAINER -->\n<ng-template #noOrder>\n  <div *ngIf=\"isLoaded$ | async; else loading\">\n    <div [attr.aria-label]=\"'orderHistory.notFound' | cxTranslate\">\n      {{ 'orderHistory.noOrders' | cxTranslate }}\n    </div>\n    <a\n      [routerLink]=\"{ cxRoute: 'home' } | cxUrl\"\n      routerLinkActive=\"active\"\n      class=\"cx-no-order\"\n      >{{ 'orderHistory.startShopping' | cxTranslate }}</a\n    >\n  </div>\n</ng-template>\n\n<!-- ORDER HISTORY DATA STILL LOADING -->\n<ng-template #loading>\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</ng-template>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2CmsMapping = {
  cmsComponents: {
    AccountOrderHistoryComponent: {
      component: MyAccountV2OrderHistoryComponent
      //guards: inherited from standard config,
    }
  }
};
const moduleComponents$1 = [MyAccountV2OrderHistoryComponent, MyAccountV2OrderConsolidatedInformationComponent, MyAccountV2ConsignmentEntriesComponent];
class OrderHistoryModule {
  static {
    this.ɵfac = function OrderHistoryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderHistoryModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrderHistoryModule,
      declarations: [OrderHistoryComponent, MyAccountV2OrderHistoryComponent, MyAccountV2OrderConsolidatedInformationComponent, MyAccountV2ConsignmentEntriesComponent],
      imports: [CommonModule, RouterModule, FormsModule, NgSelectModule, ListNavigationModule, UrlModule, I18nModule, SpinnerModule, MediaModule, BtnLikeLinkModule],
      exports: [OrderHistoryComponent, MyAccountV2OrderHistoryComponent, MyAccountV2OrderConsolidatedInformationComponent, MyAccountV2ConsignmentEntriesComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountOrderHistoryComponent: {
            component: OrderHistoryComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_ORDER) ? myAccountV2CmsMapping : {})],
      imports: [CommonModule, RouterModule, FormsModule, NgSelectModule, ListNavigationModule, UrlModule, I18nModule, SpinnerModule, MediaModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderHistoryModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, FormsModule, NgSelectModule, ListNavigationModule, UrlModule, I18nModule, SpinnerModule, MediaModule, BtnLikeLinkModule],
      declarations: [OrderHistoryComponent, ...moduleComponents$1],
      exports: [OrderHistoryComponent, ...moduleComponents$1],
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountOrderHistoryComponent: {
            component: OrderHistoryComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_ORDER) ? myAccountV2CmsMapping : {})]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderDetailsOrderEntriesContext {
  constructor(orderHistoryFacade) {
    this.orderHistoryFacade = orderHistoryFacade;
    this.type = OrderEntriesSource.ORDER_DETAILS;
  }
  getEntries() {
    return this.orderHistoryFacade.getOrderDetails().pipe(map(order => order?.entries ?? []));
  }
  static {
    this.ɵfac = function OrderDetailsOrderEntriesContext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderDetailsOrderEntriesContext)(i0.ɵɵinject(i1.OrderHistoryFacade));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OrderDetailsOrderEntriesContext,
      factory: OrderDetailsOrderEntriesContext.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderDetailsOrderEntriesContext, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.OrderHistoryFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderCancellationDialogComponent {
  handleClick(event) {
    // Close on click outside the dialog window
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }
  constructor(replenishmentOrderHistoryFacade, globalMessageService, launchDialogService, el) {
    this.replenishmentOrderHistoryFacade = replenishmentOrderHistoryFacade;
    this.globalMessageService = globalMessageService;
    this.launchDialogService = launchDialogService;
    this.el = el;
    this.subscription = new Subscription();
    this.iconTypes = ICON_TYPE;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
  }
  ngOnInit() {
    this.subscription.add(combineLatest([this.replenishmentOrderHistoryFacade.getReplenishmentOrderDetails().pipe(startWith(null)), this.launchDialogService.data$]).subscribe(([replenishmentOrder, code]) => {
      this.replenishmentOrderCode = code || replenishmentOrder?.replenishmentOrderCode;
    }));
    this.subscription.add(this.replenishmentOrderHistoryFacade.getCancelReplenishmentOrderSuccess().subscribe(value => this.onSuccess(value)));
  }
  onSuccess(value) {
    if (value) {
      this.launchDialogService.closeDialog('Successffully cancelled replenishment');
      this.globalMessageService.add({
        key: 'orderDetails.cancelReplenishment.cancelSuccess',
        params: {
          replenishmentOrderCode: this.replenishmentOrderCode
        }
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
    this.replenishmentOrderHistoryFacade.clearCancelReplenishmentOrderProcessState();
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  cancelReplenishment() {
    this.replenishmentOrderHistoryFacade.cancelReplenishmentOrder(this.replenishmentOrderCode);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function ReplenishmentOrderCancellationDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderCancellationDialogComponent)(i0.ɵɵdirectiveInject(i1.ReplenishmentOrderHistoryFacade), i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i3.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReplenishmentOrderCancellationDialogComponent,
      selectors: [["cx-replenishment-order-cancellation-dialog"]],
      hostBindings: function ReplenishmentOrderCancellationDialogComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ReplenishmentOrderCancellationDialogComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 24,
      vars: 20,
      consts: [["role", "dialog", "aria-labelledby", "dialogTitle", 1, "modal-dialog", "modal-dialog-centered", "modal-sm", 3, "esc", "cxFocus"], [1, "modal-content"], [1, "modal-header"], ["id", "dialogTitle"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [1, "cx-cancel-replenishment-dialog-description"], [1, "modal-body"], [1, "cx-cancel-replenishment-btns", "row"], [1, "col-md-6"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "btn", "btn-block", "btn-primary", 3, "click"]],
      template: function ReplenishmentOrderCancellationDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("esc", function ReplenishmentOrderCancellationDialogComponent_Template_div_esc_0_listener() {
            return ctx.close("Escape clicked");
          });
          i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "h3", 3);
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "button", 4);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵpipe(8, "cxTranslate");
          i0.ɵɵlistener("click", function ReplenishmentOrderCancellationDialogComponent_Template_button_click_6_listener() {
            return ctx.close("Cross click");
          });
          i0.ɵɵelementStart(9, "span", 5);
          i0.ɵɵelement(10, "cx-icon", 6);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(11, "div", 7);
          i0.ɵɵtext(12);
          i0.ɵɵpipe(13, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "div", 8)(15, "div", 9)(16, "div", 10)(17, "button", 11);
          i0.ɵɵlistener("click", function ReplenishmentOrderCancellationDialogComponent_Template_button_click_17_listener() {
            return ctx.close("Close Replenishment Dialog");
          });
          i0.ɵɵtext(18);
          i0.ɵɵpipe(19, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(20, "div", 10)(21, "button", 12);
          i0.ɵɵlistener("click", function ReplenishmentOrderCancellationDialogComponent_Template_button_click_21_listener() {
            return ctx.cancelReplenishment();
          });
          i0.ɵɵtext(22);
          i0.ɵɵpipe(23, "cxTranslate");
          i0.ɵɵelementEnd()()()()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 8, "orderDetails.cancelReplenishment.title"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 10, "common.close"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 12, "common.close"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("type", ctx.iconTypes.CLOSE);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 14, "orderDetails.cancelReplenishment.description"), " ");
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 16, "orderDetails.cancelReplenishment.reject"), " ");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 18, "orderDetails.cancelReplenishment.accept"), " ");
        }
      },
      dependencies: [i3.IconComponent, i3.FocusDirective, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderCancellationDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-replenishment-order-cancellation-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  class=\"modal-dialog modal-dialog-centered modal-sm\"\n  role=\"dialog\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content\">\n    <div class=\"modal-header\">\n      <h3 id=\"dialogTitle\">\n        {{ 'orderDetails.cancelReplenishment.title' | cxTranslate }}\n      </h3>\n      <button\n        type=\"button\"\n        class=\"close\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        (click)=\"close('Cross click')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n    <div class=\"cx-cancel-replenishment-dialog-description\">\n      {{ 'orderDetails.cancelReplenishment.description' | cxTranslate }}\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"cx-cancel-replenishment-btns row\">\n        <div class=\"col-md-6\">\n          <button\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"close('Close Replenishment Dialog')\"\n          >\n            {{ 'orderDetails.cancelReplenishment.reject' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-md-6\">\n          <button\n            class=\"btn btn-block btn-primary\"\n            (click)=\"cancelReplenishment()\"\n          >\n            {{ 'orderDetails.cancelReplenishment.accept' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.ReplenishmentOrderHistoryFacade
  }, {
    type: i2.GlobalMessageService
  }, {
    type: i3.LaunchDialogService
  }, {
    type: i0.ElementRef
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderCancellationDialogModule {
  static {
    this.ɵfac = function ReplenishmentOrderCancellationDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderCancellationDialogModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ReplenishmentOrderCancellationDialogModule,
      declarations: [ReplenishmentOrderCancellationDialogComponent],
      imports: [CommonModule, I18nModule, IconModule, KeyboardFocusModule],
      exports: [ReplenishmentOrderCancellationDialogComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule, IconModule, KeyboardFocusModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderCancellationDialogModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, IconModule, KeyboardFocusModule],
      declarations: [ReplenishmentOrderCancellationDialogComponent],
      exports: [ReplenishmentOrderCancellationDialogComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultReplenishmentOrderCancellationLayoutConfig = {
  launch: {
    REPLENISHMENT_ORDER: {
      inline: true,
      component: ReplenishmentOrderCancellationDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderCancellationComponent {
  constructor(replenishmentOrderHistoryFacade, vcr, launchDialogService) {
    this.replenishmentOrderHistoryFacade = replenishmentOrderHistoryFacade;
    this.vcr = vcr;
    this.launchDialogService = launchDialogService;
    this.subscription = new Subscription();
    this.replenishmentOrder$ = this.replenishmentOrderHistoryFacade.getReplenishmentOrderDetails();
  }
  openDialog() {
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.REPLENISHMENT_ORDER, this.element, this.vcr);
    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.replenishmentOrderHistoryFacade.clearReplenishmentOrderDetails();
  }
  static {
    this.ɵfac = function ReplenishmentOrderCancellationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderCancellationComponent)(i0.ɵɵdirectiveInject(i1.ReplenishmentOrderHistoryFacade), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i3.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReplenishmentOrderCancellationComponent,
      selectors: [["cx-replenishment-order-cancellation"]],
      viewQuery: function ReplenishmentOrderCancellationComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c20, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 8,
      vars: 10,
      consts: [["element", ""], [1, "cx-cancel-replenishment-btns", "row"], [1, "col-xs-12", "col-md-5", "col-lg-4"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"], ["class", "col-xs-12 col-md-5 col-lg-4", 4, "ngIf"], [1, "btn", "btn-block", "btn-secondary", 3, "click"]],
      template: function ReplenishmentOrderCancellationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "a", 3);
          i0.ɵɵpipe(3, "cxUrl");
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(6, ReplenishmentOrderCancellationComponent_div_6_Template, 5, 3, "div", 4);
          i0.ɵɵpipe(7, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_2_0;
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(3, 3, i0.ɵɵpureFunction0(9, _c34)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, "common.back"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", (tmp_2_0 = i0.ɵɵpipeBind1(7, 7, ctx.replenishmentOrder$)) == null ? null : tmp_2_0.active);
        }
      },
      dependencies: [i2$1.NgIf, i2$2.RouterLink, i3.BtnLikeLinkDirective, i2$1.AsyncPipe, i2.TranslatePipe, i2.UrlPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderCancellationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-replenishment-order-cancellation',
      standalone: false,
      template: "<div class=\"cx-cancel-replenishment-btns row\">\n  <div class=\"col-xs-12 col-md-5 col-lg-4\">\n    <a\n      class=\"btn btn-block btn-secondary\"\n      [routerLink]=\"\n        {\n          cxRoute: 'replenishmentOrders',\n        } | cxUrl\n      \"\n      cxBtnLikeLink\n    >\n      {{ 'common.back' | cxTranslate }}\n    </a>\n  </div>\n  <div\n    *ngIf=\"(replenishmentOrder$ | async)?.active\"\n    class=\"col-xs-12 col-md-5 col-lg-4\"\n  >\n    <button #element class=\"btn btn-block btn-secondary\" (click)=\"openDialog()\">\n      {{ 'orderDetails.cancelReplenishment.title' | cxTranslate }}\n    </button>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.ReplenishmentOrderHistoryFacade
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i3.LaunchDialogService
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderDetailsService {
  constructor(routingService, replenishmentOrderHistoryFacade) {
    this.routingService = routingService;
    this.replenishmentOrderHistoryFacade = replenishmentOrderHistoryFacade;
    this.replenishmentOrderCode$ = this.routingService.getRouterState().pipe(map(routingData => routingData.state.params.replenishmentOrderCode), distinctUntilChanged());
    this.replenishmentOrderLoad$ = this.replenishmentOrderCode$.pipe(tap(replenishmentOrderCode => {
      if (Boolean(replenishmentOrderCode)) {
        this.replenishmentOrderHistoryFacade.loadReplenishmentOrderDetails(replenishmentOrderCode);
      } else {
        this.replenishmentOrderHistoryFacade.clearReplenishmentOrderDetails();
      }
    }), shareReplay({
      bufferSize: 1,
      refCount: true
    }));
  }
  getOrderDetails() {
    return this.replenishmentOrderLoad$.pipe(switchMap(_ => this.replenishmentOrderHistoryFacade.getReplenishmentOrderDetails()));
  }
  static {
    this.ɵfac = function ReplenishmentOrderDetailsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderDetailsService)(i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i1.ReplenishmentOrderHistoryFacade));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReplenishmentOrderDetailsService,
      factory: ReplenishmentOrderDetailsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderDetailsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i2.RoutingService
  }, {
    type: i1.ReplenishmentOrderHistoryFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const moduleComponents = [ReplenishmentOrderCancellationComponent];
class ReplenishmentOrderDetailsModule {
  static {
    this.ɵfac = function ReplenishmentOrderDetailsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderDetailsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ReplenishmentOrderDetailsModule,
      declarations: [ReplenishmentOrderCancellationComponent],
      imports: [CardModule, CommonModule, I18nModule, PromotionsModule, UrlModule, ReplenishmentOrderCancellationDialogModule, SpinnerModule, ListNavigationModule, RouterModule, BtnLikeLinkModule],
      exports: [ReplenishmentOrderCancellationComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultReplenishmentOrderCancellationLayoutConfig), provideDefaultConfig({
        cmsComponents: {
          ReplenishmentDetailItemsComponent: {
            component: OrderDetailItemsComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: ReplenishmentOrderDetailsService
            }]
          },
          ReplenishmentDetailTotalsComponent: {
            component: OrderDetailTotalsComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: ReplenishmentOrderDetailsService
            }]
          },
          ReplenishmentDetailShippingComponent: {
            component: OrderOverviewComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: ReplenishmentOrderDetailsService
            }]
          },
          ReplenishmentDetailActionsComponent: {
            component: ReplenishmentOrderCancellationComponent
          },
          ReplenishmentDetailOrderHistoryComponent: {
            component: OrderHistoryComponent
          }
        }
      })],
      imports: [CardModule, CommonModule, I18nModule, PromotionsModule, UrlModule, ReplenishmentOrderCancellationDialogModule, SpinnerModule, ListNavigationModule, RouterModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderDetailsModule, [{
    type: NgModule,
    args: [{
      imports: [CardModule, CommonModule, I18nModule, PromotionsModule, UrlModule, ReplenishmentOrderCancellationDialogModule, SpinnerModule, ListNavigationModule, RouterModule, BtnLikeLinkModule],
      providers: [provideDefaultConfig(defaultReplenishmentOrderCancellationLayoutConfig), provideDefaultConfig({
        cmsComponents: {
          ReplenishmentDetailItemsComponent: {
            component: OrderDetailItemsComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: ReplenishmentOrderDetailsService
            }]
          },
          ReplenishmentDetailTotalsComponent: {
            component: OrderDetailTotalsComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: ReplenishmentOrderDetailsService
            }]
          },
          ReplenishmentDetailShippingComponent: {
            component: OrderOverviewComponent,
            providers: [{
              provide: OrderDetailsService,
              useExisting: ReplenishmentOrderDetailsService
            }]
          },
          ReplenishmentDetailActionsComponent: {
            component: ReplenishmentOrderCancellationComponent
          },
          ReplenishmentDetailOrderHistoryComponent: {
            component: OrderHistoryComponent
          }
        }
      })],
      declarations: [...moduleComponents],
      exports: [...moduleComponents]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderHistoryComponent {
  constructor(routing, replenishmentOrderHistoryFacade, translation, vcr, launchDialogService) {
    this.routing = routing;
    this.replenishmentOrderHistoryFacade = replenishmentOrderHistoryFacade;
    this.translation = translation;
    this.vcr = vcr;
    this.launchDialogService = launchDialogService;
    this.subscription = new Subscription();
    this.PAGE_SIZE = 5;
    this.replenishmentOrders$ = this.replenishmentOrderHistoryFacade.getReplenishmentOrderHistoryList(this.PAGE_SIZE).pipe(tap(replenishmentOrders => {
      if (replenishmentOrders?.pagination?.sort) {
        this.sortType = replenishmentOrders.pagination.sort;
      }
    }));
    this.isLoaded$ = this.replenishmentOrderHistoryFacade.getReplenishmentOrderHistoryListSuccess();
  }
  changeSortCode(sortCode) {
    const event = {
      sortCode,
      currentPage: 0
    };
    this.sortType = sortCode;
    this.fetchReplenishmentOrders(event);
  }
  pageChange(page) {
    const event = {
      sortCode: this.sortType,
      currentPage: page
    };
    this.fetchReplenishmentOrders(event);
  }
  goToOrderDetail(order) {
    this.routing.go({
      cxRoute: 'replenishmentDetails',
      params: order
    });
  }
  getSortLabels() {
    return combineLatest([this.translation.translate('sorting.date'), this.translation.translate('sorting.replenishmentNumber'), this.translation.translate('sorting.nextOrderDate')]).pipe(map(([textByDate, textByOrderNumber, textbyNextOrderDate]) => {
      return {
        byDate: textByDate,
        byReplenishmentNumber: textByOrderNumber,
        byNextOrderDate: textbyNextOrderDate
      };
    }));
  }
  openDialog(event, replenishmentOrderCode) {
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.REPLENISHMENT_ORDER, this.element, this.vcr, replenishmentOrderCode);
    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
    event.stopPropagation();
  }
  fetchReplenishmentOrders(event) {
    this.replenishmentOrderHistoryFacade.loadReplenishmentOrderList(this.PAGE_SIZE, event.currentPage, event.sortCode);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.replenishmentOrderHistoryFacade.clearReplenishmentOrderList();
  }
  static {
    this.ɵfac = function ReplenishmentOrderHistoryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderHistoryComponent)(i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i1.ReplenishmentOrderHistoryFacade), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i3.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReplenishmentOrderHistoryComponent,
      selectors: [["cx-replenishment-order-history"]],
      viewQuery: function ReplenishmentOrderHistoryComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c20, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["noOrder", ""], ["element", ""], [4, "ngIf"], [1, "container"], [1, "cx-replenishment-order-history-header"], [1, "cx-replenishment-order-history-body"], [4, "ngIf", "ngIfElse"], [1, "cx-replenishment-order-history-sort", "top", "row"], [1, "cx-replenishment-order-history-form-group", "form-group", "col-sm-12", "col-md-4", "col-lg-4"], ["ariaControls", "replenishment-order-history-table", 3, "sortListEvent", "sortOptions", "sortLabels", "selectedOption", "placeholder", "ariaLabel"], ["class", "cx-replenishment-order-history-pagination", 4, "ngIf"], ["id", "replenishment-order-history-table", "role", "table", 1, "table", "cx-replenishment-order-history-table"], [1, "cx-visually-hidden"], ["class", "cx-replenishment-order-history-thead-mobile", 4, "cxFeature"], ["role", "row", 3, "click", 4, "ngFor", "ngForOf"], [1, "cx-replenishment-order-history-sort", "bottom", "row"], [1, "cx-replenishment-order-history-pagination"], ["paginationID", "pagination-bottom", 3, "pagination", "viewPageEvent", 4, "ngIf"], ["paginationID", "pagination-top", 3, "viewPageEvent", "pagination"], [1, "cx-replenishment-order-history-thead-mobile"], ["scope", "col"], [1, "cx-replenishment-order-history-ellipses"], ["scope", "col", 1, "cx-replenishment-order-history-total"], ["role", "columnheader", "scope", "col", "aria-sort", "none"], ["role", "columnheader", "scope", "col", "aria-sort", "none", 1, "cx-replenishment-order-history-total"], ["role", "row", 3, "click"], ["role", "cell", 1, "cx-replenishment-order-history-code"], [1, "d-md-none", "cx-replenishment-order-history-label"], [1, "cx-replenishment-order-history-value", 3, "routerLink"], ["role", "cell"], [1, "cx-replenishment-order-history-value", "cx-purchase-order-number", 3, "routerLink"], ["role", "cell", 1, "cx-replenishment-order-history-frequency"], [1, "cx-replenishment-order-history-value", "cx-next-order-date", 3, "routerLink"], [1, "cx-replenishment-order-history-total"], ["role", "cell", 1, "cx-replenishment-order-history-cancel"], ["class", "cx-order-cancel btn btn-secondary", 3, "click", 4, "ngIf"], [1, "cx-order-cancel", "btn", "btn-secondary", 3, "click"], ["paginationID", "pagination-bottom", 3, "viewPageEvent", "pagination"], ["class", "cx-replenishment-order-history-no-order row", 4, "ngIf"], [1, "cx-replenishment-order-history-no-order", "row"], [1, "col-sm-12", "col-md-6", "col-lg-4"], ["routerLinkActive", "active", "cxBtnLikeLink", "", 1, "btn", "btn-primary", "btn-block", 3, "routerLink"]],
      template: function ReplenishmentOrderHistoryComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ReplenishmentOrderHistoryComponent_ng_container_0_Template, 10, 5, "ng-container", 2);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.replenishmentOrders$));
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$2.RouterLink, i2$2.RouterLinkActive, i3.SortingComponent, i3.PaginationComponent, i3.BtnLikeLinkDirective, i2.FeatureDirective, i2$1.AsyncPipe, i2$1.SlicePipe, i2.UrlPipe, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderHistoryComponent, [{
    type: Component,
    args: [{
      selector: 'cx-replenishment-order-history',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"replenishmentOrders$ | async as replenishmentOrders\">\n  <div class=\"container\">\n    <!-- HEADER -->\n    <div class=\"cx-replenishment-order-history-header\">\n      <h3>\n        {{ 'orderHistory.replenishmentOrderHistory' | cxTranslate }}\n      </h3>\n    </div>\n\n    <!-- BODY -->\n    <div class=\"cx-replenishment-order-history-body\">\n      <ng-container\n        *ngIf=\"replenishmentOrders.pagination.totalResults > 0; else noOrder\"\n      >\n        <!-- Select Form and Pagination Top -->\n        <div class=\"cx-replenishment-order-history-sort top row\">\n          <label\n            class=\"cx-replenishment-order-history-form-group form-group col-sm-12 col-md-4 col-lg-4\"\n          >\n            <span>{{ 'orderHistory.sortBy' | cxTranslate }}</span>\n            <cx-sorting\n              [sortOptions]=\"replenishmentOrders.sorts\"\n              [sortLabels]=\"getSortLabels() | async\"\n              (sortListEvent)=\"changeSortCode($event)\"\n              [selectedOption]=\"replenishmentOrders.pagination.sort\"\n              placeholder=\"{{ 'orderHistory.sortBy' | cxTranslate }}\"\n              [ariaLabel]=\"'orderHistory.sortOrders' | cxTranslate\"\n              ariaControls=\"replenishment-order-history-table\"\n            ></cx-sorting>\n          </label>\n          <div\n            class=\"cx-replenishment-order-history-pagination\"\n            *ngIf=\"replenishmentOrders.pagination.totalPages > 1\"\n          >\n            <cx-pagination\n              [pagination]=\"replenishmentOrders.pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-top\"\n            ></cx-pagination>\n          </div>\n        </div>\n        <!-- TABLE -->\n        <table\n          id=\"replenishment-order-history-table\"\n          class=\"table cx-replenishment-order-history-table\"\n          role=\"table\"\n        >\n          <caption class=\"cx-visually-hidden\">\n            {{\n              'orderHistory.orderHistory' | cxTranslate\n            }}\n          </caption>\n          <thead\n            *cxFeature=\"'!a11yTableHeaderReadout'\"\n            class=\"cx-replenishment-order-history-thead-mobile\"\n          >\n            <th scope=\"col\">\n              <span class=\"cx-replenishment-order-history-ellipses\">\n                {{ 'orderHistory.replenishmentOrderId' | cxTranslate }}\n              </span>\n            </th>\n            <th scope=\"col\">\n              <span class=\"cx-replenishment-order-history-ellipses\">\n                {{ 'orderHistory.purchaseOrderNumber' | cxTranslate }}\n              </span>\n            </th>\n            <th scope=\"col\">\n              <span class=\"cx-replenishment-order-history-ellipses\">\n                {{ 'orderHistory.startOn' | cxTranslate }}\n              </span>\n            </th>\n            <th scope=\"col\">\n              <span class=\"cx-replenishment-order-history-ellipses\">\n                {{ 'orderHistory.frequency' | cxTranslate }}\n              </span>\n            </th>\n            <th scope=\"col\">\n              <span class=\"cx-replenishment-order-history-ellipses\">\n                {{ 'orderHistory.nextOrderDate' | cxTranslate }}\n              </span>\n            </th>\n            <th scope=\"col\" class=\"cx-replenishment-order-history-total\">\n              <span class=\"cx-replenishment-order-history-ellipses\">\n                {{ 'orderHistory.total' | cxTranslate }}\n              </span>\n            </th>\n            <th scope=\"col\">\n              <span class=\"cx-replenishment-order-history-ellipses\">\n                {{ 'orderHistory.actions' | cxTranslate }}\n              </span>\n            </th>\n          </thead>\n          <thead\n            *cxFeature=\"'a11yTableHeaderReadout'\"\n            class=\"cx-replenishment-order-history-thead-mobile\"\n          >\n            <tr>\n              <th role=\"columnheader\" scope=\"col\" aria-sort=\"none\">\n                <span class=\"cx-replenishment-order-history-ellipses\">\n                  {{ 'orderHistory.replenishmentOrderId' | cxTranslate }}\n                </span>\n              </th>\n              <th role=\"columnheader\" scope=\"col\" aria-sort=\"none\">\n                <span class=\"cx-replenishment-order-history-ellipses\">\n                  {{ 'orderHistory.purchaseOrderNumber' | cxTranslate }}\n                </span>\n              </th>\n              <th role=\"columnheader\" scope=\"col\" aria-sort=\"none\">\n                <span class=\"cx-replenishment-order-history-ellipses\">\n                  {{ 'orderHistory.startOn' | cxTranslate }}\n                </span>\n              </th>\n              <th role=\"columnheader\" scope=\"col\" aria-sort=\"none\">\n                <span class=\"cx-replenishment-order-history-ellipses\">\n                  {{ 'orderHistory.frequency' | cxTranslate }}\n                </span>\n              </th>\n              <th role=\"columnheader\" scope=\"col\" aria-sort=\"none\">\n                <span class=\"cx-replenishment-order-history-ellipses\">\n                  {{ 'orderHistory.nextOrderDate' | cxTranslate }}\n                </span>\n              </th>\n              <th\n                role=\"columnheader\"\n                scope=\"col\"\n                aria-sort=\"none\"\n                class=\"cx-replenishment-order-history-total\"\n              >\n                <span class=\"cx-replenishment-order-history-ellipses\">\n                  {{ 'orderHistory.total' | cxTranslate }}\n                </span>\n              </th>\n              <th role=\"columnheader\" scope=\"col\" aria-sort=\"none\">\n                <span class=\"cx-replenishment-order-history-ellipses\">\n                  {{ 'orderHistory.actions' | cxTranslate }}\n                </span>\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr\n              role=\"row\"\n              *ngFor=\"\n                let order of replenishmentOrders.replenishmentOrders;\n                let i = index\n              \"\n              (click)=\"goToOrderDetail(order)\"\n              [attr.aria-rowindex]=\"i + 1\"\n            >\n              <td class=\"cx-replenishment-order-history-code\" role=\"cell\">\n                <div class=\"d-md-none cx-replenishment-order-history-label\">\n                  {{ 'orderHistory.replenishmentOrderId' | cxTranslate }}\n                </div>\n                <a\n                  [routerLink]=\"\n                    {\n                      cxRoute: 'replenishmentDetails',\n                      params: order,\n                    } | cxUrl\n                  \"\n                  class=\"cx-replenishment-order-history-value\"\n                >\n                  {{ order?.replenishmentOrderCode }}</a\n                >\n              </td>\n              <td role=\"cell\">\n                <div class=\"d-md-none cx-replenishment-order-history-label\">\n                  {{ 'orderHistory.purchaseOrderNumber' | cxTranslate }}\n                </div>\n                <a\n                  [routerLink]=\"\n                    {\n                      cxRoute: 'replenishmentDetails',\n                      params: order,\n                    } | cxUrl\n                  \"\n                  class=\"cx-replenishment-order-history-value cx-purchase-order-number\"\n                >\n                  {{\n                    order?.purchaseOrderNumber?.length > 0\n                      ? order?.purchaseOrderNumber\n                      : ('orderHistory.emptyPurchaseOrderId' | cxTranslate)\n                  }}\n                </a>\n              </td>\n              <td role=\"cell\">\n                <div class=\"d-md-none cx-replenishment-order-history-label\">\n                  {{ 'orderHistory.startOn' | cxTranslate }}\n                </div>\n                <a\n                  [routerLink]=\"\n                    {\n                      cxRoute: 'replenishmentDetails',\n                      params: order,\n                    } | cxUrl\n                  \"\n                  class=\"cx-replenishment-order-history-value\"\n                >\n                  {{ order?.firstDate | cxDate: 'M/d/yyyy' }}</a\n                >\n              </td>\n              <td class=\"cx-replenishment-order-history-frequency\" role=\"cell\">\n                <div class=\"d-md-none cx-replenishment-order-history-label\">\n                  {{ 'orderHistory.frequency' | cxTranslate }}\n                </div>\n                <a\n                  [routerLink]=\"\n                    {\n                      cxRoute: 'replenishmentDetails',\n                      params: order,\n                    } | cxUrl\n                  \"\n                  class=\"cx-replenishment-order-history-value\"\n                >\n                  {{ order?.trigger.displayTimeTable | slice: 0 : -12 }}\n                </a>\n              </td>\n              <td role=\"cell\">\n                <div class=\"d-md-none cx-replenishment-order-history-label\">\n                  {{ 'orderHistory.nextOrderDate' | cxTranslate }}\n                </div>\n\n                <a\n                  [routerLink]=\"\n                    {\n                      cxRoute: 'replenishmentDetails',\n                      params: order,\n                    } | cxUrl\n                  \"\n                  class=\"cx-replenishment-order-history-value cx-next-order-date\"\n                >\n                  {{\n                    order?.active\n                      ? (order?.trigger.activationTime | cxDate: 'M/d/yyyy')\n                      : ('orderHistory.cancelled' | cxTranslate)\n                  }}\n                </a>\n              </td>\n              <td class=\"cx-replenishment-order-history-total\">\n                <div class=\"d-md-none cx-replenishment-order-history-label\">\n                  {{ 'orderHistory.total' | cxTranslate }}\n                </div>\n                <a\n                  [routerLink]=\"\n                    {\n                      cxRoute: 'replenishmentDetails',\n                      params: order,\n                    } | cxUrl\n                  \"\n                  class=\"cx-replenishment-order-history-value\"\n                >\n                  {{ order?.totalPriceWithTax.formattedValue }}</a\n                >\n              </td>\n              <td class=\"cx-replenishment-order-history-cancel\" role=\"cell\">\n                <div\n                  class=\"d-md-none cx-replenishment-order-history-label\"\n                ></div>\n                <button\n                  (click)=\"openDialog($event, order?.replenishmentOrderCode)\"\n                  class=\"cx-order-cancel btn btn-secondary\"\n                  #element\n                  *ngIf=\"order?.active\"\n                >\n                  {{ 'orderHistory.cancel' | cxTranslate }}\n                </button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <!-- Select Form and Pagination Bottom -->\n        <div class=\"cx-replenishment-order-history-sort bottom row\">\n          <div class=\"cx-replenishment-order-history-pagination\">\n            <cx-pagination\n              [pagination]=\"replenishmentOrders.pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              *ngIf=\"replenishmentOrders.pagination.totalPages > 1\"\n              paginationID=\"pagination-bottom\"\n            ></cx-pagination>\n          </div>\n        </div>\n      </ng-container>\n\n      <!-- NO ORDER CONTAINER -->\n      <ng-template #noOrder>\n        <div\n          class=\"cx-replenishment-order-history-no-order row\"\n          *ngIf=\"isLoaded$ | async\"\n        >\n          <div class=\"col-sm-12 col-md-6 col-lg-4\">\n            <div>{{ 'orderHistory.noReplenishmentOrders' | cxTranslate }}</div>\n            <a\n              [routerLink]=\"{ cxRoute: 'home' } | cxUrl\"\n              routerLinkActive=\"active\"\n              class=\"btn btn-primary btn-block\"\n              cxBtnLikeLink\n              >{{ 'orderHistory.startShopping' | cxTranslate }}</a\n            >\n          </div>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i2.RoutingService
  }, {
    type: i1.ReplenishmentOrderHistoryFacade
  }, {
    type: i2.TranslationService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i3.LaunchDialogService
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReplenishmentOrderHistoryModule {
  static {
    this.ɵfac = function ReplenishmentOrderHistoryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReplenishmentOrderHistoryModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ReplenishmentOrderHistoryModule,
      declarations: [ReplenishmentOrderHistoryComponent],
      imports: [CommonModule, RouterModule, ListNavigationModule, UrlModule, I18nModule, BtnLikeLinkModule, FeaturesConfigModule],
      exports: [ReplenishmentOrderHistoryComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultReplenishmentOrderCancellationLayoutConfig), provideDefaultConfig({
        cmsComponents: {
          AccountReplenishmentHistoryComponent: {
            component: ReplenishmentOrderHistoryComponent,
            guards: [AuthGuard]
          }
        }
      })],
      imports: [CommonModule, RouterModule, ListNavigationModule, UrlModule, I18nModule, BtnLikeLinkModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReplenishmentOrderHistoryModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, ListNavigationModule, UrlModule, I18nModule, BtnLikeLinkModule, FeaturesConfigModule],
      providers: [provideDefaultConfig(defaultReplenishmentOrderCancellationLayoutConfig), provideDefaultConfig({
        cmsComponents: {
          AccountReplenishmentHistoryComponent: {
            component: ReplenishmentOrderHistoryComponent,
            guards: [AuthGuard]
          }
        }
      })],
      declarations: [ReplenishmentOrderHistoryComponent],
      exports: [ReplenishmentOrderHistoryComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReturnRequestService {
  constructor(routingService, returnRequestService, globalMessageService) {
    this.routingService = routingService;
    this.returnRequestService = returnRequestService;
    this.globalMessageService = globalMessageService;
  }
  get isCancelling$() {
    return this.returnRequestService.getCancelReturnRequestLoading();
  }
  get isCancelSuccess$() {
    return this.returnRequestService.getCancelReturnRequestSuccess();
  }
  getReturnRequest() {
    return combineLatest([this.routingService.getRouterState(), this.returnRequestService.getOrderReturnRequest(), this.returnRequestService.getReturnRequestLoading()]).pipe(map(([routingState, returnRequest, isLoading]) => [routingState.state.params['returnCode'], returnRequest, isLoading]), filter(([returnCode]) => Boolean(returnCode)), tap(([returnCode, returnRequest, isLoading]) => {
      if ((returnRequest === undefined || returnRequest.rma !== returnCode) && !isLoading) {
        this.returnRequestService.loadOrderReturnRequestDetail(returnCode);
      }
    }), map(([_, returnRequest]) => returnRequest), filter(returnRequest => Boolean(returnRequest)), distinctUntilChanged());
  }
  clearReturnRequest() {
    this.returnRequestService.clearOrderReturnRequestDetail();
  }
  cancelReturnRequest(returnRequestCode) {
    this.returnRequestService.cancelOrderReturnRequest(returnRequestCode, {
      status: 'CANCELLING'
    });
  }
  cancelSuccess(rma) {
    this.returnRequestService.resetCancelReturnRequestProcessState();
    this.globalMessageService.add({
      key: 'returnRequest.cancelSuccess',
      params: {
        rma
      }
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.routingService.go({
      cxRoute: 'orders'
    });
  }
  backToList() {
    this.routingService.go({
      cxRoute: 'orders'
    }, {
      state: {
        activeTab: 1
      }
    });
  }
  static {
    this.ɵfac = function ReturnRequestService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnRequestService)(i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i1.OrderReturnRequestFacade), i0.ɵɵinject(i2.GlobalMessageService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ReturnRequestService,
      factory: ReturnRequestService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnRequestService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i2.RoutingService
  }, {
    type: i1.OrderReturnRequestFacade
  }, {
    type: i2.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReturnRequestItemsComponent {
  constructor(returnRequestService) {
    this.returnRequestService = returnRequestService;
    this.returnRequest$ = this.returnRequestService.getReturnRequest();
  }
  static {
    this.ɵfac = function ReturnRequestItemsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnRequestItemsComponent)(i0.ɵɵdirectiveInject(ReturnRequestService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReturnRequestItemsComponent,
      selectors: [["cx-return-request-items"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["class", "cx-return-request-items", 4, "ngIf"], [1, "cx-return-request-items"], [1, "cx-visually-hidden"], ["role", "columnheader", 1, "cx-item-list-desc"], ["role", "columnheader", 1, "cx-item-list-price"], ["role", "columnheader", 1, "cx-item-list-qty"], ["role", "columnheader", 1, "cx-item-list-total"], [1, "cx-item-list-items"], ["class", "cx-item-list-row cx-return-request-item-row", 4, "ngFor", "ngForOf"], [1, "cx-item-list-row", "cx-return-request-item-row"], ["role", "cell"], [1, "cx-table-item-container"], ["format", "thumbnail", 3, "container"], [1, "cx-info"], ["class", "cx-name", 4, "ngIf"], ["class", "cx-code", 4, "ngIf"], ["class", "cx-property", 4, "ngFor", "ngForOf"], ["role", "cell", "class", "cx-price", 4, "ngIf"], ["role", "cell", 1, "cx-quantity"], [1, "cx-mobile-header"], [1, "cx-value"], ["role", "cell", 1, "cx-total"], [1, "cx-name"], [1, "cx-code"], [1, "cx-property"], ["class", "cx-label", 4, "ngIf"], ["class", "cx-value", 4, "ngIf"], [1, "cx-label"], ["role", "cell", 1, "cx-price"]],
      template: function ReturnRequestItemsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ReturnRequestItemsComponent_table_0_Template, 20, 16, "table", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.returnRequest$));
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.MediaComponent, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnRequestItemsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-return-request-items',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<table\n  class=\"cx-return-request-items\"\n  *ngIf=\"returnRequest$ | async as returnRequest\"\n>\n  <caption class=\"cx-visually-hidden\">\n    {{\n      'returnRequest.caption' | cxTranslate\n    }}\n  </caption>\n  <thead>\n    <tr>\n      <th role=\"columnheader\" class=\"cx-item-list-desc\">\n        {{ 'returnRequest.item' | cxTranslate }}\n      </th>\n      <th role=\"columnheader\" class=\"cx-item-list-price\">\n        {{ 'returnRequest.itemPrice' | cxTranslate }}\n      </th>\n      <th role=\"columnheader\" class=\"cx-item-list-qty\">\n        {{ 'returnRequest.returnQty' | cxTranslate }}\n      </th>\n      <th role=\"columnheader\" class=\"cx-item-list-total\">\n        {{ 'returnRequest.total' | cxTranslate }}\n      </th>\n    </tr>\n  </thead>\n\n  <tbody class=\"cx-item-list-items\">\n    <!-- TODO: This should be a separate component-->\n    <tr\n      class=\"cx-item-list-row cx-return-request-item-row\"\n      *ngFor=\"let returnEntry of returnRequest.returnEntries; let i = index\"\n    >\n      <td role=\"cell\">\n        <!-- Item Image -->\n        <div class=\"cx-table-item-container\">\n          <cx-media\n            [container]=\"returnEntry.orderEntry?.product.images?.PRIMARY\"\n            format=\"thumbnail\"\n          ></cx-media>\n          <!-- Item Description -->\n          <div class=\"cx-info\">\n            <div *ngIf=\"returnEntry.orderEntry?.product.name\" class=\"cx-name\">\n              {{ returnEntry.orderEntry?.product.name }}\n            </div>\n            <div *ngIf=\"returnEntry.orderEntry?.product.code\" class=\"cx-code\">\n              {{ 'cartItems.id' | cxTranslate }}\n              {{ returnEntry.orderEntry?.product.code }}\n            </div>\n            <!-- Variants -->\n            <div\n              *ngFor=\"\n                let variant of (returnEntry.orderEntry?.product.baseOptions)[0]\n                  ?.selected?.variantOptionQualifiers\n              \"\n              class=\"cx-property\"\n            >\n              <div class=\"cx-label\" *ngIf=\"variant.name\">\n                {{ variant.name }}:\n              </div>\n              <div class=\"cx-value\" *ngIf=\"variant.value\">\n                {{ variant.value }}\n              </div>\n            </div>\n          </div>\n        </div>\n      </td>\n      <!-- Item Price -->\n      <td\n        role=\"cell\"\n        class=\"cx-price\"\n        *ngIf=\"returnEntry.orderEntry?.basePrice\"\n      >\n        <div class=\"cx-mobile-header\">\n          {{ 'returnRequest.itemPrice' | cxTranslate }}\n        </div>\n        <div class=\"cx-value\">\n          {{ returnEntry.orderEntry?.basePrice?.formattedValue }}\n        </div>\n      </td>\n      <!-- return Quantity -->\n      <td role=\"cell\" class=\"cx-quantity\">\n        <div class=\"cx-mobile-header\">\n          {{ 'returnRequest.returnQty' | cxTranslate }}\n        </div>\n        <div class=\"cx-value\">\n          {{ returnEntry.expectedQuantity }}\n        </div>\n      </td>\n      <!-- Total Price -->\n      <td role=\"cell\" class=\"cx-total\">\n        <div class=\"cx-mobile-header\">\n          {{ 'returnRequest.total' | cxTranslate }}\n        </div>\n        <div class=\"cx-value\">\n          {{ returnEntry.refundAmount?.formattedValue }}\n        </div>\n      </td>\n    </tr>\n  </tbody>\n</table>\n"
    }]
  }], () => [{
    type: ReturnRequestService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReturnRequestOverviewComponent {
  constructor(returnRequestService) {
    this.returnRequestService = returnRequestService;
    this.returnRequest$ = this.returnRequestService.getReturnRequest().pipe(tap(returnRequest => this.rma = returnRequest.rma ?? ''));
    this.isCancelling$ = this.returnRequestService.isCancelling$;
  }
  ngOnInit() {
    this.subscription = this.returnRequestService.isCancelSuccess$.subscribe(success => {
      if (success) {
        this.returnRequestService.cancelSuccess(this.rma);
      }
    });
  }
  cancelReturn(returnRequestCode) {
    this.returnRequestService.cancelReturnRequest(returnRequestCode);
  }
  back() {
    this.returnRequestService.backToList();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function ReturnRequestOverviewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnRequestOverviewComponent)(i0.ɵɵdirectiveInject(ReturnRequestService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReturnRequestOverviewComponent,
      selectors: [["cx-return-request-overview"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "cx-nav", "row"], [1, "col-xs-12", "col-md-4", "col-lg-3"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["class", "btn btn-block btn-primary", 3, "disabled", "click", 4, "ngIf"], [1, "cx-header", "row"], [1, "cx-detail", "col-sm-12", "col-md-4"], [1, "cx-detail-label"], [1, "cx-detail-value"], [1, "btn", "btn-block", "btn-primary", 3, "click", "disabled"]],
      template: function ReturnRequestOverviewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ReturnRequestOverviewComponent_ng_container_0_Template, 28, 18, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.returnRequest$));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnRequestOverviewComponent, [{
    type: Component,
    args: [{
      selector: 'cx-return-request-overview',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"returnRequest$ | async as returnRequest\">\n  <div class=\"cx-nav row\">\n    <div class=\"col-xs-12 col-md-4 col-lg-3\">\n      <button (click)=\"back()\" class=\"btn btn-block btn-secondary\">\n        {{ 'common.back' | cxTranslate }}\n      </button>\n    </div>\n\n    <div class=\"col-xs-12 col-md-4 col-lg-3\">\n      <button\n        *ngIf=\"returnRequest.cancellable\"\n        class=\"btn btn-block btn-primary\"\n        (click)=\"cancelReturn(returnRequest.rma)\"\n        [disabled]=\"isCancelling$ | async\"\n      >\n        {{ 'returnRequest.cancel' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n  <div class=\"cx-header row\">\n    <div class=\"cx-detail col-sm-12 col-md-4\">\n      <div class=\"cx-detail-label\">\n        {{ 'returnRequest.returnRequestId' | cxTranslate }}\n      </div>\n      <div class=\"cx-detail-value\">{{ returnRequest.rma }}</div>\n    </div>\n    <div class=\"cx-detail col-sm-12 col-md-4\">\n      <div class=\"cx-detail-label\">\n        {{ 'returnRequest.orderCode' | cxTranslate }}\n      </div>\n      <div class=\"cx-detail-value\">{{ returnRequest.order?.code }}</div>\n    </div>\n    <div class=\"cx-detail col-sm-12 col-md-4\">\n      <div class=\"cx-detail-label\">\n        {{ 'returnRequest.status' | cxTranslate }}\n      </div>\n      <div class=\"cx-detail-value\">\n        {{\n          'returnRequestList.statusDisplay_' + returnRequest?.status\n            | cxTranslate\n        }}\n      </div>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: ReturnRequestService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReturnRequestTotalsComponent {
  constructor(returnRequestService) {
    this.returnRequestService = returnRequestService;
    this.returnRequest$ = this.returnRequestService.getReturnRequest();
  }
  ngOnDestroy() {
    this.returnRequestService.clearReturnRequest();
  }
  static {
    this.ɵfac = function ReturnRequestTotalsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnRequestTotalsComponent)(i0.ɵɵdirectiveInject(ReturnRequestService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReturnRequestTotalsComponent,
      selectors: [["cx-return-request-totals"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "row", "justify-content-end"], [1, "cx-summary", "col-sm-12", "col-md-6", "col-lg-5", "col-xl-4"], [1, "cx-summary-row"], [1, "col-6", "cx-summary-label"], [1, "col-6", "cx-summary-amount"], [1, "cx-summary-row", "cx-summary-total"], [1, "cx-summary-row", "cx-footnote"]],
      template: function ReturnRequestTotalsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ReturnRequestTotalsComponent_ng_container_0_Template, 27, 18, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.returnRequest$));
        }
      },
      dependencies: [i2$1.NgIf, i2$1.AsyncPipe, i2.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnRequestTotalsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-return-request-totals',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"returnRequest$ | async as returnRequest\">\n  <div class=\"row justify-content-end\">\n    <div class=\"cx-summary col-sm-12 col-md-6 col-lg-5 col-xl-4\">\n      <h4>{{ 'returnRequest.summary' | cxTranslate }}</h4>\n      <div class=\"cx-summary-row\">\n        <div class=\"col-6 cx-summary-label\">\n          {{ 'returnRequest.subtotal' | cxTranslate }}\n        </div>\n        <div class=\"col-6 cx-summary-amount\">\n          {{ returnRequest.subTotal?.formattedValue }}\n        </div>\n      </div>\n      <div class=\"cx-summary-row\">\n        <div class=\"col-6 cx-summary-label\">\n          {{ 'returnRequest.deliveryCode' | cxTranslate }}\n        </div>\n        <div class=\"col-6 cx-summary-amount\">\n          {{ returnRequest.deliveryCost?.formattedValue }}\n        </div>\n      </div>\n      <div class=\"cx-summary-row cx-summary-total\">\n        <div class=\"col-6 cx-summary-label\">\n          {{ 'returnRequest.estimatedRefund' | cxTranslate }}\n        </div>\n        <div class=\"col-6 cx-summary-amount\">\n          {{ returnRequest.totalPrice?.formattedValue }}\n        </div>\n      </div>\n      <div class=\"cx-summary-row cx-footnote\">\n        {{ 'returnRequest.note' | cxTranslate }}\n      </div>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: ReturnRequestService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const components = [ReturnRequestOverviewComponent, ReturnRequestItemsComponent, ReturnRequestTotalsComponent];
class ReturnRequestDetailModule {
  static {
    this.ɵfac = function ReturnRequestDetailModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnRequestDetailModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ReturnRequestDetailModule,
      declarations: [ReturnRequestOverviewComponent, ReturnRequestItemsComponent, ReturnRequestTotalsComponent],
      imports: [CommonModule, RouterModule, UrlModule, I18nModule, MediaModule],
      exports: [ReturnRequestOverviewComponent, ReturnRequestItemsComponent, ReturnRequestTotalsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturnRequestOverviewComponent: {
            component: ReturnRequestOverviewComponent
          },
          ReturnRequestItemsComponent: {
            component: ReturnRequestItemsComponent
          },
          ReturnRequestTotalsComponent: {
            component: ReturnRequestTotalsComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, UrlModule, I18nModule, MediaModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnRequestDetailModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, UrlModule, I18nModule, MediaModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturnRequestOverviewComponent: {
            component: ReturnRequestOverviewComponent
          },
          ReturnRequestItemsComponent: {
            component: ReturnRequestItemsComponent
          },
          ReturnRequestTotalsComponent: {
            component: ReturnRequestTotalsComponent
          }
        }
      })],
      declarations: [...components],
      exports: [...components]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderReturnRequestListComponent {
  constructor(returnRequestService, translation) {
    this.returnRequestService = returnRequestService;
    this.translation = translation;
    this.PAGE_SIZE = 5;
    this.returnRequests$ = this.returnRequestService.getOrderReturnRequestList(this.PAGE_SIZE).pipe(tap(requestList => {
      if (requestList?.pagination?.sort) {
        this.sortType = requestList.pagination.sort;
      }
    }));
    /**
     * When "Order Return" feature is enabled, this component becomes one tab in
     * TabParagraphContainerComponent. This can be read from TabParagraphContainer.
     */
    this.tabTitleParam$ = this.returnRequests$.pipe(map(returnRequests => returnRequests?.pagination?.totalResults), filter(isNotUndefined), take(1));
  }
  ngOnDestroy() {
    this.returnRequestService.clearOrderReturnRequestList();
  }
  changeSortCode(sortCode) {
    const event = {
      sortCode,
      currentPage: 0
    };
    this.sortType = sortCode;
    this.fetchReturnRequests(event);
  }
  pageChange(page) {
    const event = {
      sortCode: this.sortType,
      currentPage: page
    };
    this.fetchReturnRequests(event);
  }
  getSortLabels() {
    return combineLatest([this.translation.translate('sorting.date'), this.translation.translate('sorting.rma')]).pipe(map(([textByDate, textByRma]) => {
      return {
        byDate: textByDate,
        byRMA: textByRma
      };
    }));
  }
  fetchReturnRequests(event) {
    this.returnRequestService.loadOrderReturnRequestList(this.PAGE_SIZE, event.currentPage, event.sortCode);
  }
  static {
    this.ɵfac = function OrderReturnRequestListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderReturnRequestListComponent)(i0.ɵɵdirectiveInject(i1.OrderReturnRequestFacade), i0.ɵɵdirectiveInject(i2.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OrderReturnRequestListComponent,
      selectors: [["cx-order-return-request-list"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "container"], [1, "cx-order-history-body"], [1, "cx-order-history-sort", "top"], [1, "cx-order-history-form-group", "form-group"], ["ariaControls", "order-return-table", 3, "sortListEvent", "sortOptions", "sortLabels", "selectedOption", "ariaLabel"], [1, "cx-order-history-pagination"], ["paginationID", "pagination-top", 3, "viewPageEvent", "pagination"], ["id", "order-return-table", 1, "table", "cx-order-history-table"], ["class", "cx-order-history-thead-mobile", 4, "cxFeature"], [4, "ngFor", "ngForOf"], [1, "cx-order-history-sort", "bottom"], ["paginationID", "pagination-bottom", 3, "viewPageEvent", "pagination"], [1, "cx-order-history-thead-mobile"], ["scope", "col"], [1, "cx-order-history-code"], [1, "cx-order-history-label"], [1, "cx-order-history-value", 3, "routerLink"], [1, "cx-order-history-placed"], [1, "cx-order-history-status"]],
      template: function OrderReturnRequestListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OrderReturnRequestListComponent_ng_container_0_Template, 4, 1, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.returnRequests$));
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$2.RouterLink, i3.SortingComponent, i3.PaginationComponent, i2.FeatureDirective, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderReturnRequestListComponent, [{
    type: Component,
    args: [{
      selector: 'cx-order-return-request-list',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"returnRequests$ | async as returnRequests\">\n  <div class=\"container\">\n    <!-- BODY -->\n    <div class=\"cx-order-history-body\">\n      <ng-container *ngIf=\"returnRequests.pagination.totalResults > 0\">\n        <!-- Select Form and Pagination Top -->\n        <div class=\"cx-order-history-sort top\">\n          <label class=\"cx-order-history-form-group form-group\"\n            ><span>{{ 'returnRequestList.sortBy' | cxTranslate }}</span>\n            <cx-sorting\n              [sortOptions]=\"returnRequests.sorts\"\n              [sortLabels]=\"getSortLabels() | async\"\n              (sortListEvent)=\"changeSortCode($event)\"\n              [selectedOption]=\"returnRequests.pagination.sort\"\n              [ariaLabel]=\"'returnRequestList.sortReturns' | cxTranslate\"\n              ariaControls=\"order-return-table\"\n            ></cx-sorting>\n          </label>\n          <div class=\"cx-order-history-pagination\">\n            <cx-pagination\n              [pagination]=\"returnRequests.pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-top\"\n            ></cx-pagination>\n          </div>\n        </div>\n        <!-- TABLE -->\n        <table id=\"order-return-table\" class=\"table cx-order-history-table\">\n          <thead\n            *cxFeature=\"'!a11yTableHeaderReadout'\"\n            class=\"cx-order-history-thead-mobile\"\n          >\n            <th scope=\"col\">\n              {{ 'returnRequestList.returnRequestId' | cxTranslate }}\n            </th>\n            <th scope=\"col\">{{ 'returnRequestList.orderId' | cxTranslate }}</th>\n            <th scope=\"col\">\n              {{ 'returnRequestList.date' | cxTranslate }}\n            </th>\n            <th scope=\"col\">{{ 'returnRequestList.status' | cxTranslate }}</th>\n          </thead>\n          <thead\n            *cxFeature=\"'a11yTableHeaderReadout'\"\n            class=\"cx-order-history-thead-mobile\"\n          >\n            <tr>\n              <th scope=\"col\">\n                {{ 'returnRequestList.returnRequestId' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                {{ 'returnRequestList.orderId' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                {{ 'returnRequestList.date' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                {{ 'returnRequestList.status' | cxTranslate }}\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr *ngFor=\"let return of returnRequests.returnRequests\">\n              <td class=\"cx-order-history-code\">\n                <div class=\"cx-order-history-label\">\n                  {{ 'returnRequestList.returnRequestId' | cxTranslate }}\n                </div>\n                <a\n                  [routerLink]=\"\n                    {\n                      cxRoute: 'returnRequestDetails',\n                      params: return,\n                    } | cxUrl\n                  \"\n                  class=\"cx-order-history-value\"\n                >\n                  {{ return?.rma }}</a\n                >\n              </td>\n              <td class=\"cx-order-history-code\">\n                <div class=\"cx-order-history-label\">\n                  {{ 'returnRequestList.orderId' | cxTranslate }}\n                </div>\n                <a\n                  [routerLink]=\"\n                    {\n                      cxRoute: 'orderDetails',\n                      params: return?.order,\n                    } | cxUrl\n                  \"\n                  class=\"cx-order-history-value\"\n                >\n                  {{ return?.order?.code }}</a\n                >\n              </td>\n\n              <td class=\"cx-order-history-placed\">\n                <div class=\"cx-order-history-label\">\n                  {{ 'returnRequestList.date' | cxTranslate }}\n                </div>\n                {{ return?.creationTime | cxDate: 'longDate' }}\n              </td>\n              <td class=\"cx-order-history-status\">\n                <div class=\"cx-order-history-label\">\n                  {{ 'returnRequestList.status' | cxTranslate }}\n                </div>\n                {{\n                  'returnRequestList.statusDisplay_' + return?.status\n                    | cxTranslate\n                }}\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <!-- Select Form and Pagination Bottom -->\n        <div class=\"cx-order-history-sort bottom\">\n          <label class=\"cx-order-history-form-group form-group\"\n            ><span>{{ 'returnRequestList.sortBy' | cxTranslate }}</span>\n            <cx-sorting\n              [sortOptions]=\"returnRequests.sorts\"\n              [sortLabels]=\"getSortLabels() | async\"\n              (sortListEvent)=\"changeSortCode($event)\"\n              [selectedOption]=\"returnRequests.pagination.sort\"\n              [ariaLabel]=\"'returnRequestList.sortReturns' | cxTranslate\"\n              ariaControls=\"order-return-table\"\n            ></cx-sorting>\n          </label>\n          <div class=\"cx-order-history-pagination\">\n            <cx-pagination\n              [pagination]=\"returnRequests.pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-bottom\"\n            ></cx-pagination>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.OrderReturnRequestFacade
  }, {
    type: i2.TranslationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ReturnRequestListModule {
  static {
    this.ɵfac = function ReturnRequestListModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReturnRequestListModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ReturnRequestListModule,
      declarations: [OrderReturnRequestListComponent],
      imports: [CommonModule, RouterModule, ListNavigationModule, UrlModule, I18nModule, FeaturesConfigModule],
      exports: [OrderReturnRequestListComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          OrderReturnRequestListComponent: {
            component: OrderReturnRequestListComponent,
            guards: [AuthGuard]
          }
        }
      })],
      imports: [CommonModule, RouterModule, ListNavigationModule, UrlModule, I18nModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReturnRequestListModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, ListNavigationModule, UrlModule, I18nModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          OrderReturnRequestListComponent: {
            component: OrderReturnRequestListComponent,
            guards: [AuthGuard]
          }
        }
      })],
      declarations: [OrderReturnRequestListComponent],
      exports: [OrderReturnRequestListComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OrderComponentsModule {
  static {
    this.ɵfac = function OrderComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OrderComponentsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OrderComponentsModule,
      imports: [OrderHistoryModule, OrderDetailsModule, ReplenishmentOrderDetailsModule, OrderCancellationModule, OrderReturnModule, ReplenishmentOrderHistoryModule, ReturnRequestListModule, ReturnRequestDetailModule, OrderConfirmationModule, MyAccountV2OrdersModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: OrderDetailsOrderEntriesContextToken,
        useExisting: OrderDetailsOrderEntriesContext
      }],
      imports: [OrderHistoryModule, OrderDetailsModule, ReplenishmentOrderDetailsModule, OrderCancellationModule, OrderReturnModule, ReplenishmentOrderHistoryModule, ReturnRequestListModule, ReturnRequestDetailModule, OrderConfirmationModule, MyAccountV2OrdersModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderComponentsModule, [{
    type: NgModule,
    args: [{
      imports: [OrderHistoryModule, OrderDetailsModule, ReplenishmentOrderDetailsModule, OrderCancellationModule, OrderReturnModule, ReplenishmentOrderHistoryModule, ReturnRequestListModule, ReturnRequestDetailModule, OrderConfirmationModule, MyAccountV2OrdersModule],
      providers: [{
        provide: OrderDetailsOrderEntriesContextToken,
        useExisting: OrderDetailsOrderEntriesContext
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AmendOrderActionsComponent, AmendOrderActionsModule, AmendOrderItemsModule, AmendOrderType, CancelOrReturnItemsComponent, CancelOrderComponent, CancelOrderConfirmationComponent, CancelOrderConfirmationModule, CancelOrderModule, ConsignmentTrackingComponent, MyAccountV2ConsignmentEntriesComponent, MyAccountV2ConsignmentTrackingComponent, MyAccountV2DownloadInvoicesComponent, MyAccountV2DownloadInvoicesEventListener, MyAccountV2DownloadInvoicesModule, MyAccountV2OrderConsignmentsService, MyAccountV2OrderConsolidatedInformationComponent, MyAccountV2OrderDetailsActionsComponent, MyAccountV2OrderHistoryComponent, MyAccountV2OrdersComponent, MyAccountV2OrdersModule, OrderAmendService, OrderAttachmentsComponent, OrderAttachmentsDialogComponent, OrderCancellationGuard, OrderCancellationModule, OrderCancellationService, OrderComponentsModule, OrderConfirmationGuard, OrderConfirmationItemsComponent, OrderConfirmationModule, OrderConfirmationOrderEntriesContext, OrderConfirmationShippingComponent, OrderConfirmationThankYouMessageComponent, OrderConfirmationTotalsComponent, OrderConsignedEntriesComponent, OrderCriticalStatus, OrderDetailActionsComponent, OrderDetailBillingComponent, OrderDetailItemsComponent, OrderDetailReorderComponent, OrderDetailTotalsComponent, OrderDetailsModule, OrderDetailsOrderEntriesContext, OrderDetailsService, OrderGuestRegisterFormComponent, OrderHistoryComponent, OrderHistoryModule, OrderOverviewComponent, OrderOverviewComponentService, OrderReturnGuard, OrderReturnModule, OrderReturnRequestListComponent, OrderReturnService, ReorderDialogComponent, ReplenishmentOrderCancellationComponent, ReplenishmentOrderCancellationDialogComponent, ReplenishmentOrderCancellationDialogModule, ReplenishmentOrderDetailsModule, ReplenishmentOrderDetailsService, ReplenishmentOrderHistoryComponent, ReplenishmentOrderHistoryModule, ReturnOrderComponent, ReturnOrderConfirmationComponent, ReturnOrderConfirmationModule, ReturnOrderModule, ReturnRequestDetailModule, ReturnRequestItemsComponent, ReturnRequestListModule, ReturnRequestOverviewComponent, ReturnRequestTotalsComponent, TrackingEventsComponent, defaultMyAccountV2DownloadInvoicesLayoutConfig, defaultReplenishmentOrderCancellationLayoutConfig };
